<template>
  <div class="avecor-table" >
    <OrderExpand  location="orders" v-if="selectedOrderOrderId ? true: false" />
    <PinnedOrders  location="orders"  />
    <div style="position:fixed; top:154px;left:0px;z-index:10;width:100%;background:#fafafa;border-top:1px solid #ccc;border-bottom:1px solid #ccc;" v-if="Object.keys(batchUpdateItems).length > 0">
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('archive')">
          <div class="status-text " style="width:100%">ARKISTOI</div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('shippedAndInvoiced')">
          <div class="status-text " style="width:100%">LÄHETETTY JA LASKUTETTU</div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('shipped')">
          <div class="status-text " style="width:100%">LÄHETETTY</div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('invoiced')">
          <div class="status-text " style="width:100%">LASKUTETTU</div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('cancelled')">
          <div class="status-text " style="width:100%">PERUUTA</div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('pendingOn')">
          <div class="status-text " style="width:100%">ODOTTAVA - <b style="color:green">ON</b></div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('pendingOff')">
          <div class="status-text " style="width:100%">ODOTTAVA - <b style="color:red">OFF</b></div>
      </div>
      <div style="" class="px-3  avecor-button-order-status pointer" @click.stop="batchUpdateOrder('clearSelections')">
          <div class="status-text " style="width:100%">POISTA VALINNAT</div>
      </div>
      <div v-if="orderResponsibility === 'logoRequested' || orderResponsibility === 'logoReminderSent'" style="" class="px-3  avecor-button-order-status pointer" @click.stop="sendEmailToSelected('customer','logo_reminder')">
          <div class="status-text " style="width:100%">LÄHETÄ MATERIAALI MUISTUTUS</div>
      </div>
      <div v-if="orderResponsibility === 'logoReminderSent' || orderResponsibility === 'salesRequestedToContact'" style="" class="px-3  avecor-button-order-status pointer" @click.stop="sendEmailToSelected('salesperson','sales_asked_to_contact_for_logo')">
          <div class="status-text " style="width:100%">PYYDÄ MYYJÄÄ KONTAKTOIMAAN (LOGO)</div>
      </div>
      <div v-if="orderResponsibility === 'draftOrdered'" style="" class="px-3  avecor-button-order-status pointer" @click.stop="sendEmailToSelected('wholesale','draft_reminder_wholesale')">
          <div class="status-text " style="width:100%">VEDOS MUISTUTUS TOIMITTAJALLE</div>
      </div>
      <div v-if="orderResponsibility === 'draftSentToCustomer' || orderResponsibility === 'draftReminder1'" style="" class="px-3  avecor-button-order-status pointer" @click="sendEmailToSelected('customer','draft_reminder_customer')">
          <div class="status-text " style="width:100%">VEDOS MUISTUTUS ASIAKKALLE</div>
      </div>
      <div v-if="orderResponsibility === 'draftReminder1' || orderResponsibility === 'salesRequestedToContact'" style="" class="px-3  avecor-button-order-status pointer" @click.stop="sendEmailToSelected('salesperson','sales_asked_to_contact_for_draft')">
          <div class="status-text " style="width:100%">PYYDÄ MYYJÄÄ KONTAKTOIMAAN (VEDOS)</div>
      </div>
      <div v-if="orderResponsibility === 'orderCreated' || orderResponsibility === 'orderCreatedReminder'" style="" class="px-3  avecor-button-order-status pointer" @click.stop="sendEmailToSelected('wholesale','order_created_reminder_wholesale')">
          <div class="status-text " style="width:100%">TILAUS TEHTY MUISTUTUS</div>
      </div>
    </div>
    <v-container class="pa-0 ma-0" fluid  style="position:absolute; top:7px; padding-bottom:150px; width:100%;">  
      <div v-if="device === 'desktop'">
        <v-row no-gutters class="orders-table-headers orders-table-headers-sticky" id="orders-table-headers">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="text-center pb-0" v-if="device === 'desktop'" style="overflow-x:scroll;overflow-y:hidden;">
                <!-- <v-btn-toggle  dense :multiple="false" :mandatory="settings.toggleMandatory" style="width:100%;border-radius:0px !important;display: flex; " v-model="orderResponsibility"> -->
                <div style="width:100%;border-radius:0px !important;display: flex;border-bottom:1px solid #ccc; ">
                  <div class="avecor-processing-status-div avecor-button-global" >
                    <div class="third-status" @click="changeResp('samples')" :style="getButtonStyle('samples')">
                      <div class="status-text">SOVITUSP. <span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div>
                      <!-- <div><span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div> -->
                    </div>
                    <div  @click="orderResponsibility = 'pending'"  :style="getButtonStyle('pending')" class="third-status">
                      <div class="status-text" style="width:100%">ODOTTA. <span class="status-number status-number-all">{{numberOfPendingOrders}}</span></div>
                    </div>
                    <div  @click="orderResponsibility = 'salespersonSamples';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('salespersonSamples')" class="third-status">
                      <div class="status-text" style="width:100%">MYYJ. MALLI. <span class="status-number status-number-all">{{numberOfSalespersonSampleOrders}}</span></div>
                    </div>
                  </div>
                  
                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" value="pending" :style="getButtonStyle('pending')">
                    <div class="text-center">
                      <div class="status-text" style="width:100%">Odottavat</div>
                      <div><span class="status-number status-number-all">{{numberOfPendingOrders}}</span></div>
                    </div>
                  </v-btn> -->
                  
                    <!-- <v-btn class="" value="samples" :style="getButtonStyle('samples')">
                      <div class="text-center">
                        <div class="status-text">Sovituspaketit asiakkaille</div>
                        <div><span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div>
                      </div>
                    </v-btn> -->
                  
                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'salespersonSamples';batchUpdateOrder('clearSelections')" value="salespersonSamples" :style="getButtonStyle('salespersonSamples')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">MYYJIEN MALLITILAUKSET</span></div>
                      <div style="height:19px"><span class="status-number status-number-all">{{numberOfSalespersonSampleOrders}}</span></div>
                    </div>
                  </v-btn> -->
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'avecorOrders';batchUpdateOrder('clearSelections')" value="avecorOrders" :style="getButtonStyle('avecorOrders')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Avecor tilaukset</span></div>
                      <div style="height:19px"><span class="status-number status-number-all">{{numberOfAvecorOrders}}</span></div>
                    </div>
                  </v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'allNotShipped';batchUpdateOrder('clearSelections')" value="allNotShipped" :style="getButtonStyle('allNotShipped')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Kaikki ei-toimitetut</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfNotShippedOrders}}</span>
                        <!-- <span class="status-number status-number-all">{{numberOfNotShippedOrderedProducts}}</span> -->
                        <!-- <span class="status-number status-number-all">{{numberOfNotInvoicedOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfNotInvoicedOrderededProducts}}</span> -->
                      </div>
                    </div>
                  </v-btn>
                  <v-btn  class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'new';batchUpdateOrder('clearSelections')" value="new" :style="getButtonStyle('new')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Uudet tilaukset</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfNewOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfNewOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn  class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'reclamations';batchUpdateOrder('clearSelections')" value="reclamations" :style="getButtonStyle('reclamations')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Reklamaatiot/ Selvitettävät</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfReclamationOrders}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button " @click="orderResponsibility = 'processLater';batchUpdateOrder('clearSelections')" value="processLater" :style="getButtonStyle('processLater')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tilaus myöhemmin</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfProcessLaterOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfProcessLaterOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button " @click="orderResponsibility = 'waitingInfo';batchUpdateOrder('clearSelections')" value="waitingInfo" :style="getButtonStyle('waitingInfo')">
                    <div class="text-center" style="height:49px">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Odottaa tietoa</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfWaitingInfoOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfWaitingInfoOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button " @click="orderResponsibility = 'deadline';batchUpdateOrder('clearSelections')" value="deadline" :style="getButtonStyle('deadline')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Deadline Tilaukset</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfDeadlineOrders}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button " @click="orderResponsibility = 'compileProducts';batchUpdateOrder('clearSelections')" value="compileProducts" :style="getButtonStyle('compileProducts')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Koonti perjantaina</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfCompileProductsOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfCompileProductsOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>

                  <div class="avecor-processing-status-div avecor-button-global">
                    <div @click="orderResponsibility = 'logoRequested';batchUpdateOrder('clearSelections')" :style="getButtonStyle('logoRequested')" class="two-thirds-status">
                      <div class="status-text" style="line-height:13px;padding-top:2px;">
                        <div>LOGO PYYD</div>
                        <div>ASIAK<span class="status-number status-number-all ml-1" style="line-height:13px;">{{numberOfLogoRequestedOrders}}</span></div>
                      </div>
                      <!-- <div><span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div> -->
                    </div>
                    <div @click="orderResponsibility = 'logoReminderSent';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('logoReminderSent')" class="one-third-status">
                      <div class="status-text" style="width:100%">MUIST. <span class="status-number status-number-all">{{numberOfLogoReminderSentOrders}}</span></div>
                    </div>
                  </div>

                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'logoRequested';batchUpdateOrder('clearSelections')" value="logoRequested" :style="getButtonStyle('logoRequested')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Logo pyydetty asiakkaalta</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfLogoRequestedOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfLogoRequestedOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'logoReminderSent';batchUpdateOrder('clearSelections')" value="logoReminderSent" :style="getButtonStyle('logoReminderSent')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Logo muistutus lähetetty</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfLogoReminderSentOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfLogoReminderSentOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn> -->
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'sendProductsToPrint';batchUpdateOrder('clearSelections')" value="sendProductsToPrint" :style="getButtonStyle('sendProductsToPrint')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Lähetä tuotteet merkkaamoon</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfSendProductsToPrintOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfSendProductsToPrintOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <!-- <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'draftOrdered';batchUpdateOrder('clearSelections')" value="draftOrdered" :style="getButtonStyle('draftOrdered')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Vedos tilattu toimittajalta</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfDraftOrderedOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfDraftOrderedOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn> -->

                  <div v-if="allAccess" class="avecor-processing-status-div avecor-button-global" style="color:#fff;" >
                    <div @click="orderResponsibility = 'draftOrdered';batchUpdateOrder('clearSelections')" :style="getButtonStyle('draftOrdered')" class="two-thirds-status">
                      <div class="status-text" style="line-height:13px;padding-top:2px;">
                        <div>VEDOS TIL.</div>
                        <div>TOIM.
                          <span class="status-number status-number-all ml-1" style="line-height:13px;">{{numberOfDraftOrderedOrders}}</span>
                          <!-- <span class="status-number status-number-all ml-1" style="line-height:13px;">{{numberOfDraftOrderedOrderedProducts}}</span> -->
                        </div>
                      </div>
                    
                      <!-- <div><span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div> -->
                    </div>
                    <div @click="orderResponsibility = 'draftOrderedReminder';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('draftOrderedReminder')" class="one-third-status">
                      <div class="status-text" style="width:100%">MUIST. <span class="status-number status-number-all">{{numberOfDraftOrderedReminderOrders}}</span></div>
                    </div>
                  </div>


                  <div class="avecor-processing-status-div avecor-button-global" style="color:#fff;" >
                    <div @click="orderResponsibility = 'draftSentToCustomer';batchUpdateOrder('clearSelections')" :style="getButtonStyle('draftSentToCustomer')" class="two-thirds-status">
                      <div class="status-text" style="line-height:13px;padding-top:2px;">
                        <div>VEDOS LÄHE.</div>
                        <div>ASIAK<span class="status-number status-number-all ml-1" style="line-height:13px;">{{numberOfDraftSentToCustomerOrders}}</span></div>
                      </div>
                    
                      <!-- <div><span class="status-number status-number-all">{{numberOfFittingOrders}}</span></div> -->
                    </div>
                    <div @click="orderResponsibility = 'draftReminder1';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('draftReminder1')" class="one-third-status">
                      <div class="status-text" style="width:100%">MUIST. <span class="status-number status-number-all">{{numberOfDraftReminderOrders}}</span></div>
                    </div>
                  </div>

                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'draftSentToCustomer';batchUpdateOrder('clearSelections')" value="draftSentToCustomer" :style="getButtonStyle('draftSentToCustomer')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;color:white;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Vedos lähetetty asiakkaalle</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfDraftSentToCustomerOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfDraftSentToCustomerOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'draftReminder1';batchUpdateOrder('clearSelections')" value="draftReminder1" :style="getButtonStyle('draftReminder1')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;color:white;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Vedos muistutus lähetetty</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfDraftReminderOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfDraftReminderOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn> -->
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'salesRequestedToContact';batchUpdateOrder('clearSelections')" value="salesRequestedToContact" :style="getButtonStyle('salesRequestedToContact')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Myyjää pyydetty kontakt.</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfSalesRequestedToContactOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfSalesRequestedToContactOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>

                  <!-- <div class="avecor-processing-status-div avecor-button-global" style="color:#fff;" >
                    <div @click="orderResponsibility = 'draftSentToCustomer';batchUpdateOrder('clearSelections')" :style="getButtonStyle('draftSentToCustomer')" class="two-thirds-status">
                      <div class="status-text" style="line-height:13px;padding-top:2px;">
                        <div>VEDOS LÄH</div>
                        <div>ASIAK<span class="status-number status-number-all ml-1">{{numberOfDraftSentToCustomerOrders}}</span></div>
                      </div>
                    </div>
                    <div @click="orderResponsibility = 'draftReminder1';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('draftReminder1')" class="one-third-status">
                      <div class="status-text" style="width:100%">MUISTUTUS <span class="status-number status-number-all">{{numberOfDraftReminderOrders}}</span></div>
                    </div>
                  </div> -->

                  <div class="avecor-processing-status-div avecor-button-global" >
                    <div @click="orderResponsibility = 'orderCreated';batchUpdateOrder('clearSelections')" :style="getButtonStyle('orderCreated')" class="two-thirds-status">
                      <div class="status-text" style="line-height:13px;padding-top:2px;">
                        <div>TILAUS</div>
                        <div>TEHTY<span class="status-number status-number-all ml-1" style="line-height:13px;">{{numberOfOrderCreatedOrders}}</span></div>
                      </div>
                    </div>
                    <div @click="orderResponsibility = 'orderCreatedReminder';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('orderCreatedReminder')" class="one-third-status">
                      <div class="status-text" style="width:100%">MUIST. <span class="status-number status-number-all">{{numberOfOrderCreatedRemindersOrders}}</span></div>
                    </div>
                  </div>

                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'orderCreated';batchUpdateOrder('clearSelections')" value="orderCreated" :style="getButtonStyle('orderCreated')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tilaus tehty</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfOrderCreatedOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfOrderCreatedOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'orderCreatedReminder';batchUpdateOrder('clearSelections')" value="orderCreatedReminder" :style="getButtonStyle('orderCreatedReminder')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tilaus tehty muistutus</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfOrderCreatedRemindersOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfOrderCreatedRemindersOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn> -->
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'awaitingBatch';batchUpdateOrder('clearSelections')" value="awaitingBatch" :style="getButtonStyle('awaitingBatch')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;color:white;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Odottaa erää</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfAwaitingBatchOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfAwaitingBatchOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn v-if="allAccess" class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'productsArrivedToWarehouse';batchUpdateOrder('clearSelections')" value="productsArrivedToWarehouse" :style="getButtonStyle('productsArrivedToWarehouse')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tuotteet saapunut varastoon</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfProductsArrivedToWarehouseOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfProductsArrivedToWarehouseOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'incompleteShelf';batchUpdateOrder('clearSelections')" value="incompleteShelf" :style="getButtonStyle('incompleteShelf')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Keskeneräiset hyllyyn</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfIncompleteShelfOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfIncompleteShelfOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'orderLaterIncompleteShelf';batchUpdateOrder('clearSelections')" value="orderLaterIncompleteShelf" :style="getButtonStyle('orderLaterIncompleteShelf')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tilaus myöh. keskeneräiset</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfOrderLaterIncompleteShelfOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfOrderLaterIncompleteShelfOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  
                  <v-btn class="avecor-button-global avecor-processing-status-button avecor-processing-status-no-right-border" @click="orderResponsibility = 'productsShipped';batchUpdateOrder('clearSelections')" value="productsShipped" :style="getButtonStyle('productsShipped')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">Tuotteet lähetetty asiakkaalle</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfProductsShippedOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfProductsShippedOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>

                  <v-btn class="avecor-button-global avecor-processing-status-button avecor-processing-status-no-right-border" @click="orderResponsibility = 'invoice';batchUpdateOrder('clearSelections')" value="productsShipped" :style="getButtonStyle('invoice')">
                    <div class="text-center">
                      <div class="status-text" style="height:30px;line-height:33px;"><span style="line-height:normal;display:inline-block;vertical-align:middle;">SAA LASKUTTAA</span></div>
                      <div style="height:19px">
                        <span class="status-number status-number-all">{{numberOfInvoiceOrders}}</span>
                        <span class="status-number status-number-all">{{numberOfInvoiceOrderedProducts}}</span>
                      </div>
                    </div>
                  </v-btn>
                  

                  <div class="avecor-processing-status-div avecor-button-global" >
                    <div class="fourth-status" @click="orderResponsibility = 'cancelled';batchUpdateOrder('clearSelections')" :style="getButtonStyle('cancelled')" style="line-height:9px;">
                      <div class="status-text" style="color:#FFF">PERUTUT</div>
                    </div>
                    <div class="fourth-status" @click="orderResponsibility = 'toBeReturned';batchUpdateOrder('clearSelections')" :style="getButtonStyle('toBeReturned')" style="line-height:9px;">
                      <div class="status-text" >PALAUTETTAVAT</div>
                    </div>
                    <div class="fourth-status" @click="orderResponsibility = 'returned';batchUpdateOrder('clearSelections')" :style="getButtonStyle('returned')" style="line-height:9px;">
                      <div class="status-text" >PALAUTETUT</div>
                    </div>
                    <div class="fourth-status" @click="orderResponsibility = 'archived';batchUpdateOrder('clearSelections')" :style="getButtonStyle('archived')" style="line-height:9px;">
                      <div class="status-text">ARKISTOIDUT</div>
                    </div>
                    <!-- <div class="fourth-status" @click="orderResponsibility = 'invoicedAll';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('invoicedAll')" style="line-height:9px;">
                      <div class="status-text" style="width:100%">LASKUTETUT</div>
                    </div>
                    <div class="fourth-status" @click="orderResponsibility = 'paid';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('paid')" style="line-height:9px;">
                      <div class="status-text" style="width:100%">MAKSETUT</div>
                    </div> -->
                  </div>
                  <div class="avecor-processing-status-div avecor-button-global" >
                    <div class="third-status" @click="orderResponsibility = 'invoicedAll';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('invoicedAll')" >
                      <div class="status-text" style="width:100%">LASKUTETUT</div>
                    </div>
                    <div class="third-status" @click="orderResponsibility = 'notPaid';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('notPaid')">
                      <div class="status-text" style="width:100%;font-size:7px;">MAKSAMATTOMAT</div>
                    </div>
                    <div class="third-status" @click="orderResponsibility = 'paid';batchUpdateOrder('clearSelections')"  :style="getButtonStyle('paid')">
                      <div class="status-text" style="width:100%">MAKSETUT</div>
                    </div>
                  </div>
                  <!-- <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'salespersonSamples'" value="archived" :style="getButtonStyle('archived')">Arkistoidut</v-btn>
                  <v-btn class="avecor-button-global avecor-processing-status-button" @click="orderResponsibility = 'salespersonSamples'" value="invoicedAll" :style="getButtonStyle('invoicedAll')">Laskutetut</v-btn> -->
                  <!-- <v-btn height="30" class="avecor-button-global avecor-processing-status-button" value="invoicedGreaterThanThreeMonths" :style="getButtonStyle('invoicedGreaterThanThreeMonths')">Laskutetut &gt;3kk</v-btn> -->
                </div>
                <!-- </v-btn-toggle> -->

              </v-col>
            </v-row>
            <v-row class="pb-2">
              <v-col cols="1" class="pl-10" v-if="device === 'desktop'">
                Tilaukset
              </v-col>
              <v-col cols="2" class="pl-0 pb-0 pt-1 text-left" v-if="device === 'desktop'">
                <div style="font-size:10px">{{numberOfHighCriticalOrders}} todella kiireinen</div>
                <div style="font-size:10px">{{numberOfMediumCriticalOrders}} semi-kiireinen</div>
                <div v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="font-size:8px">{{numberOfOrders +' ('+numberOfOrderedProducts+')'}} yhteensä</div>
                
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="1" class="px-0 pt-0 my-0 pb-0" style="">
                <div class="" :style="allAccess ? 'display:inline-block;line-height:20px;' : 'display:inline-block;line-height:45px;'">
                  <label style="display: inline-block;padding-right: 10px;white-space: nowrap;font-size:10px;padding-left:3px;display:inline-block;line-height:10px;">
                    <input style="vertical-align: middle;" type="checkbox" :checked="ordersSearchWithinSelectedStatus" @change="ordersSearchWithinSelectedStatus = !ordersSearchWithinSelectedStatus"/> 
                    <span style="vertical-align: middle;">Hae välilehden sisällä</span>
                  </label>
                  <label v-if="allAccess" style="display: inline-block;padding-right: 10px;white-space: nowrap;font-size:10px;padding-left:3px;display:inline-block;line-height:10px;">
                    <input style="vertical-align: middle;" type="checkbox" :checked="showOnlyHistoryOrders" @change="showOnlyHistoryOrders = !showOnlyHistoryOrders"/> 
                    <span style="vertical-align: middle;">Näytä vain historiatilaukset</span>
                  </label>
                <!-- <div style="font-size:10px;padding-left:3px;display:inline-block;">Hae statuksen sisällä</div> -->
                </div>

              </v-col>
              <v-col cols="6" :class="allAccess ? 'px-0 py-0' : 'px-0 py-1'">
                <v-text-field
                  :value="ordersSearch"
                  ref="ordersSearch"
                  :class="getOrdersSearchClasses"
                  label="Etsi tilauksia (myyjä, tilauskooste, tuotekoodit, tukkuri, merkkaamo, yrityksen nimi/y-tunnus/osoite, kontaktin tiedot, toimiston/myyjän kommentit, viite, netvisor id)"
                  @change="(event) => {ordersSearch = event; fetchExtraData()}"
                  
                  :hint="ordersSearchHint"
                  single-line
                  :hide-details="!allAccess"
                  dense
                  autocomplete="off"
                ></v-text-field>
                <!-- 
                  @keyup.enter="(event) => {ordersSearch = event; fetchExtraData()}"
                  @change="(event) => {ordersSearch = event; fetchExtraData()}" -->
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="text-right my-0 pt-0 pb-1">
                <div class="pr-7" v-if="orderResponsibility === 'invoicedAll'">
                  <v-btn-toggle  dense :multiple="false" :mandatory="true" style="" v-model="invoicesTimePeriod">
                    <v-btn height="15" class="avecor-button-global avecor-button-group-button" value="threeMonths">
                      &#60; 3kk
                    </v-btn>
                    <v-btn height="15" class="avecor-button-global avecor-button-group-button" value="all">
                      Kaikki
                    </v-btn>
                  </v-btn-toggle>
                </div>
                
                  <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="addToGoogleContacts()">Contacts</span>
                  <!-- <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="setSalespersonForOrderedProducts()">Set salespersons</span> -->
                  <!-- <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="setAdditionaDetailsOrderedProducts()">Set warehoused</span> -->
                  <!-- <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="transferOrders()">Siirrä tilaukset</span> -->
                  <!-- <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="janiOrders()">Jani tilaukset</span> -->
                  <span v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="padding-right:5px; font-size:10px;text-decoration:underline;" @click="setAllInvoicesPaidToFalse()">All paid</span>
                  
                
                <v-tooltip bottom >
                  <template v-slot:activator="{ on }">
                    <span v-on="on" style="padding-right:30px; font-size:10px;text-decoration:underline;">Mitä värikoodit tarkoittavat?</span>
                    
                  </template>
                  <div style="padding-top:20px">Varastostatukset (ensimmäinen laatikko)</div>
                  <div v-for="(status, index) in settings.orderedProductWarehouseStatusArray" :key="'ordered-product-warehouse-status-'+index">
                    <v-icon
                      :color="settings.orderStatusColors[status.id]"
                      :size="10"
                      style="padding-right:5px;"
                    >
                      fas fa-square-full
                    </v-icon>
                    {{ status.text }}
                  </div>
                  <div style="padding-top:20px">Toimitusstatukset (toinen laatikko)</div>
                  <div v-for="(status, index) in settings.orderedProductStatusArray" :key="'ordered-product-delivery-status-'+index">
                    <v-icon
                      :color="settings.orderStatusColors[status.id]"
                      :size="10"
                      style="padding-right:5px;"
                    >
                      fas fa-square-full
                    </v-icon>
                    {{typeof status.nextStepResponsible !== "undefined" ? status.text +' (Seuraavan statuksen vastuu: '+status.nextStepResponsible+')': status.text }}
                  </div>
                  <div style="padding-top:20px">Laskutusstatukset (kolmas laatikko)</div>
                  <div v-for="(status, index) in settings.orderedProductInvoiceStatusArray" :key="'ordered-product-invoice-'+index">
                    <v-icon :color="settings.orderStatusColors[status.id]" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon>
                    {{typeof status.nextStepResponsible !== "undefined" ? status.text +' (Seuraavan statuksen vastuu: '+status.nextStepResponsible+')': status.text }}
                  </div>
                  <div style="padding-top:20px">Katekerroin (viimeinen laatikko ensimmäisessä sarakkeessa) </div>
                  <div>
                    <v-icon :color="'#000'" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon>
                    Katetta ei lisätty
                  </div>
                  <div>
                    <v-icon :color="'#DE3164'" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon>
                    Katerroin alle 2 
                  </div>
                  <div>
                    <v-icon :color="'#FFBF00'" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon>
                    Katerroin yli 2 ja vähemmän kuin 2.5
                  </div>
                  <div>
                    <v-icon :color="'#2ECC40'" :size="10" style="padding-right:5px;">fas fa-square-full</v-icon>
                    Katerroin yli 2.5
                  </div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="orderResponsibility === 'awaitingBatch' && user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="border-top:1px solid #ccc;overflow-y:scroll;height:300px;">
                <v-col cols="12" class="text-center">
                  Tuotesuodatin
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters style="border-top:1px #ccc solid; max-height:50px; overflow:hidden" class="py-2 px-2">
                    <v-col sm="12">
                      <v-row no-gutters>
                        <v-col class="orders-custom-header pr-1" sm="3">Name</v-col>
                        <v-col class="orders-custom-header pr-1" sm="2">Variaatio</v-col>
                        
                        <v-col class="orders-custom-header pr-1" sm="1">Määrä</v-col>
                        <v-col class="orders-custom-header pr-1" sm="1">Status</v-col>
                        <v-col class="orders-custom-header pr-1" sm="1">Osoite</v-col>
                        <v-col class="orders-custom-header pr-1" sm="1">Vedos email</v-col>
                        <v-col class="orders-custom-header pr-1" sm="3">Tilaaja</v-col>
                        <!-- <v-col class="orders-custom-header pr-1" sm="1">Tilaaja email</v-col>
                        <v-col class="orders-custom-header pr-1" sm="1">Pnumero</v-col> -->
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row no-gutters v-for="(p,i) in getProducts" :key="p.id+'_batch_awaiting'" class="px-2">
                    
                    <div v-for="(pvId, j) in Object.keys(p.productVariations)" :key="pvId + '_batch'" style="width:100%">
                      <div v-for="(bId, k) in Object.keys(p.productVariations[pvId].batches)" :key="bId + '_batch'" style="width:100%">
                        <v-row no-gutters>
                          <v-col class="orders-custom-field pr-1" sm="3">{{p.name}}</v-col>
                          <v-col class="orders-custom-field pr-1" sm="2">{{p.productVariations[pvId].name}}</v-col>
                          <v-col class="orders-custom-field pr-1" sm="1">{{p.productVariations[pvId].batches[bId].quantity}}</v-col>
                          <v-col class="orders-custom-field pr-1" sm="1">
                            <v-autocomplete
                              autocomplete="off"
                              :value="p.productVariations[pvId].batches[bId].status"
                              :items="settings.batchStatusArray"
                              
                              persistent-hint
                              item-text="text"
                              item-value="id"
                              
                              hide-details
                              class="avecor-select awaiting-batch-select"
                              style="display:inline-block; width:100px;"
                            />
                            <!-- {{p.productVariations[pvId].batches[bId].status}} -->
                          </v-col>
                          <!-- <v-col class="orders-custom-field pr-1" sm="9">{{p.productVariations[pvId].batches[bId]}}</v-col> -->
                        </v-row>
                      </div>
                    </div>
                  </v-row>
                </v-col>
                
            </v-row>
            <v-row no-gutters style="border-top:1px #ccc solid; max-height:50px; overflow:hidden;background:#EEEEEE" class="py-1">
              <v-col sm="5">
                <v-row no-gutters>
                  <v-col class="orders-custom-header pr-1" sm="2" style="max-width:100px;">
                    <span class="pl-3">
                      <i v-if="allStatusOrdersSelected" @click="batchUpdateOrder('clearSelections')" style="padding-right:1px;color:green;font-size:12px;" class="fas fa-check-square" />
                      <i v-else @click="selectAllOrdersInStatus()" style="padding-right:1px;color:#666;font-size:12px;" class="far fa-square" />
                    </span>
                    <!-- <v-icon v-if="allStatusOrdersSelected" @click="batchUpdateItems = {};allStatusOrdersSelected = false" style="padding-right:1px;" color="green" size="12" dark>fas fa-check-square</v-icon>
                    <v-icon v-else @click="getOrders.forEach(o => batchUpdateItems[o.id] = true);allStatusOrdersSelected = true" style="padding-right:1px;" color="#666" size="12" dark>far fa-square</v-icon> -->
                  </v-col>
                  <v-col class="orders-custom-header pr-1" sm="1">Tilaus pvm</v-col>
                  <v-col class="orders-custom-header pr-1" sm="1">Myyjä</v-col>
                  <!-- <v-col class="orders-custom-header pr-1" sm="1">Vastaava</v-col> -->
                  <v-col class="orders-custom-header pr-1" sm="1">Yritys</v-col>
                  <!-- <v-col class="orders-custom-header pr-1" sm="1">Y-tunnus</v-col> -->
                  <v-col class="orders-custom-header pr-1" sm="2">Osoite</v-col>
                  
                  <v-col class="orders-custom-header pr-1" sm="3">Tilaaja</v-col>
                  <v-col class="orders-custom-header pr-1" sm="1">Toim. vko</v-col>
                  <v-col class="orders-custom-header " sm="1" >Viite</v-col>
                  <!-- <v-col class="orders-custom-header pr-1" sm="1">Tilaaja email</v-col>
                  <v-col class="orders-custom-header pr-1" sm="1">Pnumero</v-col> -->
                </v-row>
              </v-col>
              <v-col sm="7">
                <v-row no-gutters>
                  <v-col sm="9">
                    <v-row no-gutters>
                      <v-col class="orders-custom-header pr-1" sm="2">Tilauskooste</v-col>
                      <v-col class="orders-custom-header pr-1" sm="3">Myyjän kommentit</v-col>
                      <v-col class="orders-custom-header pr-1" sm="3" v-if="staff[user.uid] !== undefined && (staff[user.uid].isAdmin || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')" >Toimiston kommentit</v-col>
                      <v-col class="orders-custom-header pr-1" sm="3">Historia</v-col>
                      
                    </v-row>
                  </v-col>
                  <v-col sm="3">
                    <v-row no-gutters> 
                      <v-col class="orders-custom-header pr-1" sm="8" >Tiedot</v-col>
                      <v-col class="orders-custom-header text-right pr-4" sm="4">Statukset</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <v-col sm="1">
                <v-row no-gutters>
                  <v-col class="orders-custom-header pr-1" sm="6" ></v-col>
                  <v-col class="orders-custom-header text-left pr-1" sm="6">Statukset</v-col>
                </v-row>
              </v-col> -->
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div :class="device === 'desktop' ? 'orders-table-content' : ''" id="orders-table-content" :key="orderTableKey" :style="orderResponsibility === 'awaitingBatch' && user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' ? 'padding-top:460px;' : 'padding-top:180px;'">
        <v-lazy
          style="width:100%; padding:0px; margin:0px;min-height:50px;"
          :options="{threshold: .1}"
          v-for="(order) in getOrders"
          :key="order.id"
        >
          <div>
            <!-- MOBILE -->
            <div v-if="device === 'mobile'" style="width:100%;">
              <v-row no-gutters sm="12" class="pa-1" :class="getOrderRowClasses(order.id)">
                <div style="position:absolute; top:15px; right:15px;">
                  <v-icon :size="18" @click="selectedOrderOrderId = order.id;" style="padding-right:1px;">far fa-eye</v-icon>
                </div>

                <div style="position:absolute; top:45px; right:15px;" v-if="ordersData[order.id] !== undefined && ordersData[order.id].orderedProducts !== undefined">
                  <div v-for="(opKey, index) in Object.keys(ordersData[order.id].orderedProducts)" :key="'op-status-'+index">
                    <!-- <v-icon 
                      v-if="ordersData[order.id].orderedProducts[opKey].warehoused"
                      :color="ordersData[order.id].orderedProducts[opKey].warehouseStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].warehouseStatus] : '#ccc'"
                      :size="10"
                      style="padding-right:5px;"
                    >
                      fas fa-square-full
                    </v-icon> -->
                    <v-icon 
                      :color="ordersData[order.id].orderedProducts[opKey].deliveryStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].deliveryStatus] : '#ccc'"
                      :size="10"
                      style="padding-right:5px;"
                    >
                      fas fa-square-full
                    </v-icon>
                    <v-icon 
                      :color="ordersData[order.id].orderedProducts[opKey].invoiceStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].invoiceStatus] : '#ccc'"
                      :size="10"
                      style="padding-right:5px;"
                    >
                      fas fa-square-full
                    </v-icon>
                  </div>
                </div>
                <div style="color:rgba(0,0,0,.38); font-size:12px;width:100%" class="px-2">
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span style="font-size:14px"><b>Yritys</b></span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div style="font-size:14px"><b>{{companies[order.companyId].companyName + ',  ' + companies[order.companyId].companyId}}</b></div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Tilauspäivä</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.created_at ? customFormatter(order.created_at) : ''}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Myyjä</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.salespersonFirstName}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Tilausvastaava</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{typeof staff[order.orderResponsible] !== 'undefined' ? staff[order.orderResponsible].firstName: ''}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Y-tunnus </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{companies[order.companyId].companyId}}</div>
                      </div>
                    </v-col>
                  </v-row> -->
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Osoite </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.companyAddress}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Asiakastiedot </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.contactName + ',  ' + order.contactPhone + ',  ' + order.contactEmail}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Yhteenveto </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.orderSummary}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Toimituskulut </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{order.deliveryCharge + '€'}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4" >
                      <span >Yhteensä </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{(Number(order.total) + Number(order.deliveryCharge)).toFixed(2) + '€'}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4 pt-3" >
                      <span >Kate </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <v-text-field
                          :disabled="order.viaSearch"
                          :value="order.salespersonMargin"
                          @change="v => inlineSaveField(order.id,'salespersonMargin',v)"
                          class="avecor-select"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4 pt-3">
                      <span >Myyjän kommentit </span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <v-textarea
                          v-if="!order.viaSearch && orders[order.id]"
                          :value="orders[order.id].orderComments"
                          @change="v => inlineSaveField(order.id,'orderComments',v)"
                          single-line
                          rows=1
                          :auto-grow="autogrow"
                          class="avecor-select avecor-textarea"
                        ></v-textarea>
                        <v-textarea
                          v-else-if="order.viaSearch && searchOrders[order.id]"
                          :value="searchOrders[order.id].orderComments"
                          single-line
                          :disabled="true"
                          rows=1
                          :auto-grow="autogrow"
                          class="avecor-select avecor-textarea"
                        ></v-textarea>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
            </div>
            <!-- DESKTOP -->
            <div v-if="device === 'desktop'" >
              <v-row no-gutters sm="12" class="pa-1" :class="getOrderRowClasses(order.id)" :style="order.viaSearch ? 'background:#f5f5f5;' :''">
                <v-col sm="5" >
                  <v-row no-gutters>
                    <v-col sm="2" class="pr-1" style="max-width:100px;">
                      <div class="justify-center text-left pl-2" >
                        <!-- BATCH UPDATES -->
                        <span v-if="allAccess && !order.viaSearch">
                          <v-icon v-if="batchUpdateItems[order.id]" @click="updateBatchSelectionForItem(order.id)" style="padding-right:1px;" color="green" size="12" dark>fas fa-check-square</v-icon>
                          <v-icon v-else @click="updateBatchSelectionForItem(order.id)" style="padding-right:1px;" color="#666" size="12" dark>far fa-square</v-icon>
                        </span>
                    <!-- {{item.print ? 'far fa-check-square' : 'far fa-square'}} -->
                  
                        <v-icon :size="9" @click="selectedOrderOrderId = order.id;" style="padding-right:1px;">far fa-eye</v-icon>
                        <v-icon v-if="!order.viaSearch && (allAccess || order.allOrderStatusesNew)" :size="9" @click="deleteItem(order)" style="padding-right:1px;">far fa-trash-alt</v-icon>
                        <!-- {{order.areAllArchived}} -->
                        
                        <!-- areAllArchived isAtLeastOneArchived -->                          
                        <!-- {{order.orderedProducts}}ordersData[order.id].orderedProducts -->
                        <v-icon v-if="allAccess" :size="9" @click.stop="printItem(order)" style="padding-right:1px;">fas fa-print</v-icon>
                        <v-icon v-if="allAccess" :size="9" @click.stop="printOrderLetter(order)" style="padding-right:1px;">fas fa-file-invoice</v-icon>
                        <div/>
                        <!-- ARKISTOINTI -->
                        <span v-if="allAccess && !order.viaSearch ">
                          <v-icon v-if="order.areAllArchived" color="green" :size="9" @click.stop="toggleArchive(order)" style="padding-right:1px;">fas fa-archive</v-icon>
                          <v-icon v-if="order.isAtLeastOneArchived && !order.areAllArchived" color="orange" :size="9" @click.stop="toggleArchive(order)" style="padding-right:1px;">fas fa-archive</v-icon>
                          <v-icon v-if="!order.isAtLeastOneArchived" color="#666" :size="9" @click.stop="toggleArchive(order)" style="padding-right:1px;">fas fa-archive</v-icon>
                        </span>
                        <span v-else>
                          <v-icon v-if="order.areAllArchived" color="green" :size="9" style="padding-right:1px;">fas fa-archive</v-icon>
                          <v-icon v-if="order.isAtLeastOneArchived && !order.areAllArchived" color="orange" :size="9" style="padding-right:1px;">fas fa-archive</v-icon>
                          <v-icon v-if="!order.isAtLeastOneArchived" color="#666" :size="9" style="padding-right:1px;">fas fa-archive</v-icon>
                        </span>
                        <!-- ODOTTAVAT -->
                        <v-tooltip bottom v-if="order" >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="9" v-if="order.pending === undefined || !order.pending" @click.stop="togglePending(order)" style="padding-right:1px;">fas fa-pause</v-icon>
                                <v-icon :size="9" v-if="order.pending !== undefined && order.pending" @click.stop="togglePending(order)" style="padding-right:1px;color:red;">fas fa-pause</v-icon>
                              </span>
                              <span v-else>
                                <v-icon :size="9" v-if="order.pending === undefined || !order.pending" style="padding-right:1px;">fas fa-pause</v-icon>
                                <v-icon :size="9" v-if="order.pending !== undefined && order.pending" style="padding-right:1px;color:red;">fas fa-pause</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus odottavaksi tilaukseksi. Aktivoituna tilaus näkyy 'Odottavat'-välilehdellä.</span>
                        </v-tooltip>
                        <!-- SOVITUSPAKETIT -->
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="9" v-if="order.sample === undefined || !order.sample" @click.stop="toggleSample(order)" style="padding-right:1px;">fas fa-tshirt</v-icon>
                                <v-icon :size="9" v-if="order.sample !== undefined && order.sample" @click.stop="toggleSample(order)" style="padding-right:1px;color:red;">fas fa-tshirt</v-icon>
                              </span>
                              <span v-else>
                                <v-icon :size="9" v-if="order.sample === undefined || !order.sample" style="padding-right:1px;">fas fa-tshirt</v-icon>
                                <v-icon :size="9" v-if="order.sample !== undefined && order.sample" style="padding-right:1px;color:red;">fas fa-tshirt</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus sovituspaketiksi asiakkaalle. Aktivoituna tilaus näkyy 'Sovituspaketit asiakkaille'-välilehdellä.</span>
                        </v-tooltip>
                        <!-- MYYJIEN MALLITILAUKSET -->
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="9" v-if="order.salespersonSample === undefined || !order.salespersonSample" @click.stop="toggleSalespersonSample(order)" style="padding-right:1px;">fas fa-user-tie</v-icon>
                                <v-icon :size="9" v-if="order.salespersonSample !== undefined && order.salespersonSample" @click.stop="toggleSalespersonSample(order)" style="padding-right:1px;color:red;">fas fa-user-tie</v-icon>
                              </span>
                              <span v-else>
                                <v-icon :size="9" v-if="order.salespersonSample === undefined || !order.salespersonSample" style="padding-right:1px;">fas fa-user-tie</v-icon>
                                <v-icon :size="9" v-if="order.salespersonSample !== undefined && order.salespersonSample" style="padding-right:1px;color:red;">fas fa-user-tie</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus myyjän mallitilaukseksi. Aktivoituna tilaus näkyy 'Myyjien mallitilaukset'-välilehdellä.</span>
                        </v-tooltip>
                        <!-- REKLAMAATIOT -->
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="9" v-if="order.reclaimed === undefined || !order.reclaimed" @click.stop="toggleReclaimed(order)" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
                                <v-icon :size="9" v-if="order.reclaimed !== undefined && order.reclaimed" @click.stop="toggleReclaimed(order)" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
                              </span>
                              <!-- <span v-else-if="allAccess && order.viaSearch">
                                <v-icon :size="9" v-if="order.reclaimed === undefined || !order.reclaimed" @click.stop="toggleHistoryReclaimed(order)" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
                                <v-icon :size="9" v-if="order.reclaimed !== undefined && order.reclaimed" @click.stop="toggleHistoryReclaimed(order)" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
                              </span> -->

                              <span v-else>
                                <v-icon :size="9" v-if="order.reclaimed === undefined || !order.reclaimed" style="padding-right:1px;">fas fa-exclamation-triangle</v-icon>
                                <v-icon :size="9" v-if="order.reclaimed !== undefined && order.reclaimed" style="padding-right:1px;color:red;">fas fa-exclamation-triangle</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus reklamaatio-tilaukseksi. Aktivoituna tilaus näkyy 'Reklamaatiot/Selvitettävät'-välilehdellä.</span>
                        </v-tooltip>
                        <div/>    
                        <!-- DEADLINE TILAUKSET -->
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="9" v-if="order.deadline === undefined || !order.deadline" @click.stop="toggleDeadline(order)" style="padding-right:1px;">fas fa-clock</v-icon>
                                <v-icon :size="9" v-if="order.deadline !== undefined && order.deadline" @click.stop="toggleDeadline(order)" style="padding-right:1px;color:red;">fas fa-clock</v-icon>
                              </span>
                              <span v-else>
                                <v-icon :size="9" v-if="order.deadline === undefined || !order.deadline" style="padding-right:1px;">fas fa-clock</v-icon>
                                <v-icon :size="9" v-if="order.deadline !== undefined && order.deadline" style="padding-right:1px;color:red;">fas fa-clock</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus deadline-tilaukseksi. Aktivoituna tilaus näkyy 'deadline'-välilehdellä.</span>
                        </v-tooltip>
                        <!-- TILAUKSEN UUDELLEEN LÄHETYS -->
                        <v-menu open-on-hover bottom  nudge-right="10" close-delay="100" v-if="!order.viaSearch">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <v-icon :size="9">far fa-envelope</v-icon>
                            </span>
                          </template>
                          <div style="font-size:11px;background:#FFF;padding:10px;">
                            
                            <div class="pb-2">
                              <div style="font-weight:600">Lähetä tilausvahvistus</div>
                              <v-btn @click="sendEmail(order.id,'user','order_confirmation')"  x-small>Lähetä minulle</v-btn>
                              <v-btn @click="sendEmail(order.id,'miko','order_confirmation')"  x-small>Lähetä mikolle</v-btn>
                              <v-btn @click="sendEmail(order.id,'salesperson','order_confirmation')"  x-small>Lähetä myyjälle</v-btn>
                              <v-btn @click="sendEmail(order.id,'customer','order_confirmation')"  x-small>Lähetä asiakkaalle</v-btn>
                            </div>
                            <div >
                              <div style="font-weight:600">Lähetä materiaalipyyntö</div>
                              <v-btn @click="sendEmail(order.id,'user','material_request')"  x-small>Lähetä minulle</v-btn>
                              <v-btn @click="sendEmail(order.id,'miko','material_request')"  x-small>Lähetä mikolle</v-btn>
                              <v-btn @click="sendEmail(order.id,'salesperson','material_request')"  x-small>Lähetä myyjälle</v-btn>
                              <v-btn @click="sendEmail(order.id,'customer','material_request')"  x-small>Lähetä asiakkaalle</v-btn>
                            </div>
                          </div>
                        </v-menu>
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <!-- <v-icon :size="9"  @click="sendEmail(order.id)">far fa-envelope</v-icon> -->
                              <span v-if="allAccess && !order.viaSearch">
                                <v-icon :size="11" v-if="order.avecorOrder === undefined || !order.avecorOrder" @click.stop="toggleAvecorOrder(order)" style="padding-right:1px;">fas fa-font</v-icon>
                                <v-icon :size="11" v-if="order.avecorOrder !== undefined && order.avecorOrder" @click.stop="toggleAvecorOrder(order)" style="padding-right:1px;color:#F26538;">fas fa-font</v-icon>
                              </span>
                              <span v-else>
                                <v-icon :size="11" v-if="order.avecorOrder === undefined || !order.avecorOrder" style="padding-right:1px;">fas fa-font</v-icon>
                                <v-icon :size="11" v-if="order.avecorOrder !== undefined && order.avecorOrder" style="padding-right:1px;color:#F26538;">fas fa-font</v-icon>
                              </span>
                            </span>
                          </template>
                          <span style="font-size:11px;">Merkkaa tilaus Avecor-tilaukseksi. Aktivoituna tilaus näkyy 'Avecor tilaukset'-välilehdellä.</span>
                        </v-tooltip>
                        <v-tooltip bottom >
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on" >
                              <v-icon :size="12" v-if="order.shopifyOrder === undefined || !order.shopifyOrder" style="padding-right:1px;">fab fa-shopify</v-icon>
                              <v-icon :size="12" v-if="order.shopifyOrder !== undefined && order.shopifyOrder" style="padding-right:1px;color:#5E8E3E;">fab fa-shopify</v-icon>
                            </span>
                          </template>
                          <span style="font-size:11px;">Jos vihreä, niin tilaus on tullut shopifysta .</span>
                        </v-tooltip>
                        <!-- <v-icon :size="9" :color="order.marginRateColor">fas fa-square-full</v-icon> -->
                        <v-icon :size="9" v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" @click="copyToClipboard(order.id)" >far fa-id-badge</v-icon>
                        <!-- <i v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" @click="copyToClipboard(c.id)" style="padding-right:4px;padding-top:0px;font-size:10px;color:#666" class="far fa-id-badge pointer" /> -->
                        <div v-if="order.viaSearch">
                          <button class="avecor-button-global small-add-button mr-1" @click="setLoadOnStartForOrder(order,true)" style="padding-bottom:10px !important;">PALAUTA</button>
                        </div>
                        <div v-else-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'">
                          <button class="avecor-button-global small-add-button mr-1" @click="setLoadOnStartForOrder(order,false)" style="padding-bottom:10px !important;">SKIP LATAUS</button>
                        </div>
                      </div>
                    </v-col>
                    <v-col sm="1" class="pr-1">
                      <!-- <v-text-field
                        slot="activator"
                        class="avecor-date-picker"  
                        :value="order.created_at ? customFormatter(order.created_at) : ''"
                        readonly
                      ></v-text-field> -->
                      <div class="orders-custom-field" @click="copyToClipboard(order.created_at ? customFormatter(order.created_at) : '')" style="color:rgba(0,0,0,.38);">{{order.created_at ? customFormatter(order.created_at) : ''}}</div>
                    </v-col>
                    <v-col sm="1" class="pr-1">
                      <!-- <a @click="window.print(); return false;" href="https://firebasestorage.googleapis.com/v0/b/avecor-public/o/avecor%2Fsalesperson-leaflets%2FKiitoskortti_Avecor_henripotila_A4.pdf?alt=media&token=f951ef7b-69e2-49fb-aebb-c6adce641691" target="_blank"></a> -->
                      <div class="orders-custom-field" style="color:rgba(0,0,0,.38);">
                        {{order.salespersonFirstName}}
                        <span v-if="order.totalOrders < 2" style="cursor:pointer;">
                          <v-icon class="pl-1" @click="printPDF(henkkaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'zNBbbWRgacVUU3TU06kTSLesn872'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(hannaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === '2hq19s6eQHSrEhwXiAeDGxo0Q5e2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(jarkkoUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'zPFY35K13WV7Ayo68l5umKdnXyH2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(juhaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === '7DUdAZqzwwYNAdGsNwz5jxgU0A12'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(atteUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'GTNKFjWUHNhcAJVbORirRPNvCnv1'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(hennaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'bWKOZFPQiyU04skj2CYYSTuo40A2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>

                          <v-icon class="pl-1" @click="printPDF(janneUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'MG7ysPafpYMEQtqd0HJVzck3yXM2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(katriUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'WEKfjCcgRvcKWX4nnUqMwsFpeaP2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(markkuUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'eZ4PiIehfVg7xo0J2tZV8tYtLZ23'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(samiUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'CfssvG9CYWWCoLSkeoR6FVXy6K72'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(timoUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'RqjgIwdXWzXqCR2MOVr1etp2iY22'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>

                          <v-icon class="pl-1" @click="printPDF(janiUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'GJ51vbQ1pLNNJMeKc4896QKdjVr1'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(tuukkaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'I7RPIfMJIbYurRauvSR35yp9MJD2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(camillaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'lsglSdCDm6T8EcsGbn84TbzKwVv2'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>
                          <v-icon class="pl-1" @click="printPDF(janitaUrl)" :size="9" v-if="order.salespersonId !== undefined && order.salespersonId === 'QFJp86frV7O88Zgga2fuUv4giKC3'" style="padding-right:1px;cursor:pointer;">fas fa-address-card</v-icon>


                        </span>
                      </div>
                    </v-col>
                    <!-- <v-col sm="1" class="pr-1">
                      <div class="orders-custom-field" @click="copyToClipboard(typeof staff[order.orderResponsible] !== 'undefined' ? staff[order.orderResponsible].firstName: '')" style="color:rgba(0,0,0,.38);">{{typeof staff[order.orderResponsible] !== 'undefined' ? staff[order.orderResponsible].firstName: ''}}</div>
                    </v-col> -->
                    <v-col sm="1" class="pr-1">
                      <div class="orders-custom-field" @click="copyToClipboard(companies[order.companyId].companyName)" style="color:rgba(0,0,0,.38);">{{companies[order.companyId].companyName}}</div>
                      <div class="orders-custom-field" @click="copyToClipboard(companies[order.companyId] && companies[order.companyId].companyId ? companies[order.companyId].companyId : '')" style="color:rgba(0,0,0,.38);">{{companies[order.companyId] && companies[order.companyId].companyId ? companies[order.companyId].companyId : ''}}</div>
                    </v-col>
                    <!-- <v-col sm="1" class="pr-1">
                      
                    </v-col> -->
                    <v-col sm="2" class="pr-1">
                      <div class="orders-custom-field" @click="copyToClipboard(order.companyAddress)" style="color:rgba(0,0,0,.38);">{{order.companyAddress}}</div>
                    </v-col>
                    
                    <v-col sm="3" class="pr-1">
                      <div class="orders-custom-field" @click="copyToClipboard(order.contactName)" style="color:rgba(0,0,0,.38);">{{order.contactName}}</div>
                      <div class="orders-custom-field" @click="copyToClipboard(order.contactEmail)" style="color:rgba(0,0,0,.38);">{{order.contactEmail}}</div>
                      <div class="orders-custom-field" @click="copyToClipboard(order.contactPhone)" style="color:rgba(0,0,0,.38);">{{order.contactPhone}}</div>
                      <div v-if="order.clientPrintDetailsEmail" class="orders-custom-field" @click="copyToClipboard(order.clientPrintDetailsEmail)" style="color:rgba(0,0,0,.38);"><b>Vedos:</b> {{order.clientPrintDetailsEmail}}</div>
                    </v-col>
                    <v-col md="1" class="px-1 text-left">
                      <span v-if="!deliveryWeekEdit[order.id]" style="font-size:10px;">
                        <div>{{order.deliveryWeek.split(' ')[0]}} </div>
                        <div>{{order.deliveryWeek.split(' ')[1]}}</div>
                        <span v-if="!order.viaSearch" @click="setDeliveryWeekOrder(order.id)"><i  class="fas fa-pencil-alt pointer" style="font-size:9px;color:#999;"></i></span>
                      </span>
                      <span v-else>
                        <v-autocomplete
                          :value="order.deliveryWeek"
                          :items="settings.weeksArrayDates"
                          @change="v => {inlineSaveField(order.id,'deliveryWeek',v);deliveryWeekEdit = {}}"
                          autocomplete="off"
                          hide-details
                          
                          class="avecor-select pa-0 ma-0"
                          style="font-size:9px !important;"
                        />
                      </span>
                      <!-- <div class="orders-custom-field" style="color:rgba(0,0,0,.38);">{{order.deliveryWeek}}</div> -->
                    </v-col>
                    <v-col sm="1" class="px-1">
                      <div class="orders-custom-field" style="color:rgba(0,0,0,.38);">{{order.billingReferenceDetails}}</div>
                      <!-- <v-text-field
                        :value="order.billingReferenceDetails"
                        @change="v => inlineSaveField(order.id,'billingReferenceDetails',v)"
                        class="avecor-select"
                      ></v-text-field> -->
                    </v-col>
                    
                  </v-row>
                </v-col>
                <v-col sm="7">
                  <v-row no-gutters>
                    <v-col sm="9">
                      <v-row no-gutters>
                        <v-col sm="2" class="pr-1">
                          <div class="orders-custom-field" style="color:rgba(0,0,0,.38);white-space: pre-wrap;">{{order.orderSummary}}</div>
                        </v-col>
                        <v-col sm="3" class="pr-1">
                          <v-textarea
                            v-if="!order.viaSearch && orders[order.id]"
                            :value="orders[order.id].orderComments"
                            @change="v => inlineSaveField(order.id,'orderComments',v)"
                            single-line
                            rows=1
                            :auto-grow="autogrow"
                            class="avecor-select"
                          ></v-textarea>
                          <v-textarea
                            v-else-if="order.viaSearch && searchOrders[order.id]"
                            :value="searchOrders[order.id].orderComments"
                            single-line
                            :disabled="true"
                            rows=1
                            :auto-grow="autogrow"
                            class="avecor-select"
                          ></v-textarea>
                          
                        </v-col>
                        <v-col sm="3" class="pr-1" v-if="staff[user.uid] !== undefined && (staff[user.uid].isAdmin || staff[user.uid].role == 'office' || staff[user.uid].role == 'warehouse')">
                          <v-textarea
                            v-if="!order.viaSearch && orders[order.id]"
                            :value="orders[order.id].officeOrderComments"
                            @change="v => inlineSaveField(order.id,'officeOrderComments',v)"
                            single-line
                            rows=1
                            :auto-grow="autogrow"
                            class="avecor-select"
                          ></v-textarea>
                          <v-textarea
                            v-else-if="order.viaSearch && searchOrders[order.id]"
                            :value="searchOrders[order.id].officeOrderComments"
                            @change="v => inlineSaveHistoryField(order.id,'officeOrderComments',v)"
                            single-line
                            :disabled="true"
                            rows=1
                            :auto-grow="autogrow"
                            class="avecor-select"
                          ></v-textarea>
                          <!-- order.viaSearch -->
                        </v-col>
                        <v-col sm="3" class="pr-1 pt-1"  > 
                          <div v-if="orders[order.id] && orders[order.id].activityLog">
                            <div v-for="(h,i) in getLatestOpStatusesFromActivityLogo(order.id,order.viaSearch)" :key="h.id+'_hi'" class="orders-custom-field" style="color:rgba(0,0,0,1);padding-top:0px;font-size:9px;">
                              <div>
                                
                                <div v-if="!orders[order.id].activityLog[i-1] || (orders[order.id].activityLog[i].oldStatus !== orders[order.id].activityLog[i-1].oldStatus || orders[order.id].activityLog[i].newStatus !== orders[order.id].activityLog[i-1].newStatus || orders[order.id].activityLog[i].date !== orders[order.id].activityLog[i-1].date)">
                                  <i class="fas fa-square-full" :style="h.newStatus ? 'font-size:8px;color:'+settings.orderStatusColors[h.newStatus] : 'font-size:8px;color:#ccc'"></i>
                                  <span class="pl-1" style="font-weight:600">{{customFormatter(h.date,false)}}</span>
                                  <span class="pl-1" style="font-weight:600" v-if="h.whichStatus === 'orderStatus'">
                                    {{h.oldStatus && settings.orderedProductStatusObject[h.oldStatus] ? settings.orderedProductStatusObject[h.oldStatus].text : ''}}
                                    ➔
                                    {{h.newStatus && settings.orderedProductStatusObject[h.newStatus] ? settings.orderedProductStatusObject[h.newStatus].text : ''}}
                                  </span>
                                  <span class="pl-1" style="font-weight:600" v-else-if="h.whichStatus === 'orderInvoiceStatus'">
                                    {{h.oldStatus && settings.orderedProductInvoiceStatusObject[h.oldStatus] ? settings.orderedProductInvoiceStatusObject[h.oldStatus].text : ''}}
                                    ➔
                                    {{h.newStatus && settings.orderedProductInvoiceStatusObject[h.newStatus] ? settings.orderedProductInvoiceStatusObject[h.newStatus].text : ''}}
                                  </span>
                                  <span>
                                    
                                  </span>
                                </div>
                                <div class="pl-4 activity-log-item">
                                  <span v-if="h.pName.length > 60">{{h.pName.substr(0,60) + '...'}}</span>
                                  <span v-else>{{h.pName}}</span>
                                  <i v-if="!order.viaSearch" class="far fa-trash-alt ml-1 delete-log" style="font-size:9px;color:#555;cursor:pointer;" @click="deleteActivityFromLog(order.id,h.id)"></i>
                                </div>
                              </div>
                            </div>
                            <div class="mt-4">
                              <div v-for="(h) in getLatestOrderEmailsFromActivityLogo(order.id,orders[order.id].activityLog)" :key="h.id+'_hi'" class="orders-custom-field" style="color:rgba(0,0,0,1);padding-top:0px;font-size:9px;">
                                <div v-if="h.success">
                                  <i class="far fa-envelope" style="font-size:9px;" ></i>
                                  <span class="pl-1">{{customFormatter(h.date,false)}}</span>
                                  <span v-if="h.typeOfSend === 'order_confirmation'" class="pl-1">{{settings.typesOfEmailSends[h.typeOfSend] ? settings.typesOfEmailSends[h.typeOfSend].fi +' lähetetty ' : ''}}{{h.isToCustomer ? 'asiakkaalle' : 'myyjälle'}}</span>
                                  <span v-else class="pl-1">{{settings.typesOfEmailSends[h.typeOfSend] ? settings.typesOfEmailSends[h.typeOfSend].fi +' lähetetty ' : ''}}</span>
                                </div>
                              </div>
                            </div>
                            <div v-if="orderHasExtraLogs(orders[order.id].activityLog)" class="text-center">
                              <v-btn v-if="!ordersShowAllLogs.includes(order.id)" @click="ordersShowAllLogs.push(order.id)" color="#000000" dark class="avecor-button-global small-add-button mr-3">Näytä kaikki logit</v-btn>
                              <v-btn v-else @click="ordersShowAllLogs = ordersShowAllLogs.filter(id => id !== order.id)" color="#000000" dark class="avecor-button-global small-add-button mr-3">Tiivistä logit</v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col sm="3">
                      <v-row no-gutters>
                        <v-col sm="8" class="pl-1 pt-1">
                          <div style="margin-bottom:6px;border:1px solid #ccc;padding-left:2px;">
                            <div style="line-height:12px;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Tuotteet</div>
                              <div style="color:rgba(0,0,0,.6);font-size:9px;display:inline-block;">{{Number(order.total) + '€'}}</div>
                            </div>
                            <div style="border-bottom:1px dashed #ccc;line-height:12px;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Toimitus</div>
                              <div style="color:rgba(0,0,0,.6);font-size:9px;display:inline-block;">{{order.deliveryCharge + '€'}}</div>
                            </div>
                            <div style="padding-top:2px;line-height:12px;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Yhteensä</div>
                              <div style="color:rgba(0,0,0,.6);font-size:9px;display:inline-block;">{{(Number(order.total) + Number(order.deliveryCharge)).toFixed(2) + '€'}}</div>
                            </div>
                          </div>

                          <div style="margin-top:6px;margin-bottom:6px;border:1px solid #ccc;padding-left:2px;line-height:12px;">
                            <div v-if="!order.isOrderSalespersonMarginDisabled" style="font-size:9px;font-weight:600;border-bottom:1px dashed #ccc;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:60%;">Myyj. kate tilaus</div>
                              <div style="display:inline-block;background:#f3f3f3;font-size:0px;width:38%">
                                <input 
                                  v-if="!order.isOrderSalespersonMarginDisabled"
                                  :disabled="order.viaSearch || order.isOrderSalespersonMarginDisabled"
                                  :value="order.salespersonMargin"
                                  @change="v => inlineSaveField(order.id,'salespersonMargin',v,true)"
                                  type="text"
                                  style="display: inline-block; background: rgb(243, 243, 243); position: relative;"
                                  class="orders-input-cell" 
                                >
                              </div>
                            </div>
                            <div v-else>
                              <div style="border-bottom:1px dashed #ccc;">
                                <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Toimitus kate</div>
                                <div style="font-size:9px;color:rgba(0,0,0,0.6);padding-left:0px;display:inline-block;">{{ order.deliveryMargin }}€</div>
                              </div>
                              <div style="border-bottom:1px dashed #ccc;">
                                <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Myyj. kate lask.</div>
                                <div style="font-size:9px;color:rgba(0,0,0,0.6);padding-left:0px;display:inline-block;">{{ order.salespersonMarginViaOps }}€</div>
                              </div>
                              <div style="border-bottom:1px dashed #ccc;">
                                <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Toim. kate lask.</div>
                                <div style="font-size:9px;color:rgba(0,0,0,0.6);padding-left:0px;display:inline-block;">{{ order.officeMarginViaOps }}€</div>
                              </div>
                              <div style="">
                                <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Katekerroin</div>
                                <v-icon :size="7" style="padding-top:2px;" :color="order.marginRateColor">fas fa-square-full</v-icon>
                                <div style="font-size:9px;color:rgba(0,0,0,0.6);padding-left:0px;display:inline-block;">{{ order.marginRate }}</div>
                              </div>
                            </div>
                          </div>

                          <div style="margin-top:6px;margin-bottom:6px;border:1px solid #ccc;padding-left:2px;line-height:12px;">
                            <div>
                              <div style="font-size:9px;font-weight:600;display:inline-block;width:90px;">
                                <span>Netv. id</span>
                                <!-- <a v-if="order.netvisorKey" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/order.aspx?id='+order.netvisorKey" target="_blank">
                                  <i style="padding-left:1px;color:blue;font-size:7px;" class="fas fa-external-link-alt" />
                                </a> -->
                                <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100"  v-if="(!order.viaSearch && !order.netvisorKey && !order.netvisorId) || (!order.viaSearch && order.netvisorKey && order.netvisorId)">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" >
                                      <v-icon 
                                        :size="8"
                                        style="padding-left:1px;color:blue;"
                                        @click="syncOrderToNetvisor(order.id,'production')"
                                      >
                                        fas fa-exchange-alt
                                      </v-icon>
                                    </span>
                                  </template>
                                  <div style="font-size:11px;background:#FFF;padding:10px;">
                                    <div>Synkronoi Netvisorin tuotantoympäristöön.</div>
                                    <br>
                                    <div><b>Login-sivu </b><a class="pointer" href="https://login.netvisor.fi/fi" target="_blank">https://login.netvisor.fi/fi</a></div>
                                  </div>
                                </v-menu>
                              </div>
                              <div style="font-size:0px;display:inline-block;">
                                <!-- Disabloitu myös Henri ja Sami -->
                                <span v-if="order.netvisorKey || order.netvisorId" class="orders-info-box-links">
                                  <span  @click="copyToClipboard(order.netvisorId)" class="pointer">{{order.netvisorId}}</span>
                                  <a target="_blank" v-if="order.netvisorKey" style="border-left:1px solid #ccc;padding-left:2px;" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/order.aspx?id='+order.netvisorKey" >
                                    <i style="color:#fff;padding-left:1px;font-size:7px;" class="fas fa-external-link-alt" />
                                  </a>
                                </span>
                                <!-- <input 
                                  :disabled="order.viaSearch || !allAccess || user.uid === 'zNBbbWRgacVUU3TU06kTSLesn872' || user.uid === 'CfssvG9CYWWCoLSkeoR6FVXy6K72'"
                                  :value="order.netvisorId"
                                  @change="v => inlineSaveField(order.id,'netvisorId',v,true)"
                                  type="text"
                                  style="display: inline-block; background: rgb(243, 243, 243); position: relative;"
                                  class="orders-input-cell" 
                                > -->
                              </div>
                            </div>
                            <div style="border-top:1px dashed #ccc;">
                              <div style="font-size:9px;font-weight:600;display:inline-block;width:90px;" >
                                <span>Netv. laskut</span>
                                <i class="far fa-window-maximize pointer" v-if="!order.viaSearch" style="padding-left:3px;font-size:7px;" @click="orderInvoicingModalEnv = 'production';orderInvoicingModalVisible = true;orderInvoicingModalOrderId = order.id;"></i>
                              </div>
                              <!-- @click="$store.dispatch('deleteOrderOrInvoiceNetvisor', {env:'development',invoiceType:'order',orderId:orderInvoicingModalOrderId,netvisorKey:orders[orderInvoicingModalOrderId].netvisorKey_test_env})" -->
                              <div style="font-size:0px;display:inline-block;">
                                <span v-if="order.invoices">
                                  <span v-if="order.invoices[iKey].invoiceNumber" v-for="iKey in Object.keys(order.invoices)" :key="iKey+'_invoice'" class="orders-info-box-links" >
                                    <span style="border-right:1px solid #ccc;padding-right:2px;" @click="copyToClipboard(order.invoices[iKey].invoiceNumber)" class="pointer">{{order.invoices[iKey].invoiceNumber}}</span>
                                    <a target="_blank" :href="'https://suomi.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+iKey" >
                                      <i style="color:#fff;padding-left:1px;font-size:7px;" class="fas fa-external-link-alt" />
                                    </a>
                                  </span>
                                  <!-- <a v-if="orders[order.id].invoices[iKey].invoiceNumber" v-for="iKey in Object.keys(orders[order.id].invoices)" :key="iKey+'_invoice'" class="orders-info-box-links" target="_blank" :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+iKey" >
                                    {{orders[order.id].invoices[iKey].invoiceNumber}}
                                    <i style="padding-left:1px;font-size:7px;" class="fas fa-external-link-alt" />
                                  </a> -->
                                </span>
                              </div>
                            </div>
                            <div v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' || 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="border-top:1px dashed #ccc;">
                              <div style="font-size:9px;font-weight:600;display:inline-block;width:90px;">
                                <span>Netv.test</span>
                                
                                <v-menu open-on-hover bottom offset-y nudge-bottom="10" close-delay="100" v-if="!order.viaSearch">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" >
                                      <v-icon 
                                        :size="8"
                                        style="padding-right:1px;color:blue;"
                                        @click="syncOrderToNetvisor(order.id,'development')"
                                      >
                                        fas fa-exchange-alt
                                      </v-icon>
                                    </span>
                                  </template>
                                  <div style="font-size:11px;background:#FFF;padding:10px;">
                                    <div>Synkronoi Netvisorin testiympäristöön.</div>
                                    <br>
                                    <div>Testiympäristön tiedot:</div>
                                    <div><b>Login-sivu </b><a class="pointer" href="https://koulutus.netvisor.fi/" target="_blank">https://koulutus.netvisor.fi/</a></div>
                                    <div class="pointer" @click="copyToClipboard('avecor.demo')"><b>Käyttäjätunnus: </b>avecor.demo</div>
                                    <div class="pointer" @click="copyToClipboard(' Vaihda0102')"><b>Salasana: </b> Vaihda0102</div>
                                  </div>
                                </v-menu>
                              </div>
                              <div style="font-size:0px;display:inline-block;">
                                <a v-if="order.netvisorKey_test_env" class="orders-info-box-links" target="_blank" :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/order.aspx?id='+order.netvisorKey_test_env" >
                                  {{order.netvisorId_test_env}}
                                  <i style="padding-left:1px;font-size:7px;" class="fas fa-external-link-alt" />
                                </a>
                                <!-- <input 
                                  :disabled="order.viaSearch"
                                  :value="order.netvisorId_test_env"
                                  @change="v => inlineSaveField(order.id,'netvisorId_test_env',v, true)"
                                  type="text"
                                  style="display: inline-block; background: rgb(243, 243, 243); position: relative;font-size:7px !important;line-height:8px !important;"
                                  class="orders-input-cell" 
                                > -->
                              </div>
                            </div>
                            <div v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" style="border-top:1px dashed #ccc;">
                              <div style="font-size:9px;font-weight:600;display:inline-block;width:90px;" >
                                <span>Net.test laskut</span>
                                <i class="far fa-window-maximize pointer" v-if="!order.viaSearch" style="padding-left:3px;font-size:7px;" @click="orderInvoicingModalOrderId = order.id;orderInvoicingModalEnv = 'development';orderInvoicingModalVisible = true;"></i>
                              </div>
                              
                              <div style="font-size:9px;display:inline-block;">
                                <span v-if="order.invoicesTest">
                                  <span v-if="order.invoicesTest[iKey].invoiceNumber" v-for="iKey in Object.keys(order.invoicesTest)" :key="iKey+'_invoice'" class="orders-info-box-links" >
                                    <span style="border-right:1px solid #ccc;padding-right:2px;" @click="copyToClipboard(order.invoicesTest[iKey].invoiceNumber)" class="pointer">{{order.invoicesTest[iKey].invoiceNumber}}</span>
                                    <a target="_blank" :href="'https://koulutus.netvisor.fi/evo/accounting/salesledger/invoice.aspx?id='+iKey" >
                                      <i style="color:#fff;padding-left:1px;font-size:7px;" class="fas fa-external-link-alt" />
                                    </a>
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                          

                          
                          <div v-if="ordersData[order.id].invoices && allAccess" style="margin-bottom:6px;border:1px solid #ccc;padding-left:2px;line-height:12px;">
                            <div style="border-bottom:1px dashed #ccc;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:90px;">Netv. lasku (alviton)</div>
                              <div style="font-size:9px;color:rgba(0,0,0,0.6);padding-left:0px;display:inline-block;">{{ order.invoicesOrderInvoiceAmountWithoutVat + '€' }}€</div>
                            </div>
                            <div style="border-bottom:1px dashed #ccc;display:flex;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:80px">Laskutettu</div>
                              <div :style="';font-size:9px;display:inline-block;padding-top:1px;flex-grow: 1'">
                                <div :style="order.invoicedPercentageCssStyle+';font-size:9px;display:inline-block;padding-top:1px;width:100%;'">{{order.invoicedPercentage + '%'}}</div>
                                <div style="color:rgba(0,0,0,0.6);font-size:8px;">{{ order.invoicesSumWithoutVat + ' / ' + order.invoicesOrderInvoiceAmountWithoutVat+ '€' }}</div>
                              </div>
                            </div>
                            <div style="display:flex;">
                              <div style="font-weight:600;font-size:9px;display:inline-block;width:80px;">Maksettu</div>
                              <div :style="';font-size:9px;display:inline-block;padding-top:1px;flex: 1'">
                                <div :style="order.paidPercentageCssStyle+';font-size:9px;display:inline-block;padding-top:1px;width:100%;'">{{order.paidPercentage + '%'}}</div>
                                <div style="color:rgba(0,0,0,0.6);font-size:8px;">{{ order.invoicesPaidSumWithoutVat + ' / ' + order.invoicesOrderInvoiceAmountWithoutVat+ '€' }}</div>
                              </div>
                            </div>
                          </div>
                        </v-col>
                        <v-col sm="3" class="pr-1 pt-1 text-right">
                          <div v-if="ordersData[order.id] !== undefined && ordersData[order.id].orderedProducts !== undefined">
                            <div v-for="(opKey, index) in Object.keys(ordersData[order.id].orderedProducts)" :key="'op-status-'+opKey+index">
                              <!-- <v-icon 
                                v-if="ordersData[order.id].orderedProducts[opKey].warehouseStatus"
                                :color="ordersData[order.id].orderedProducts[opKey].warehouseStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].warehouseStatus] : '#ccc'"
                                :size="10"
                                style="padding-right:5px;"
                              >
                                fas fa-square-full
                              </v-icon>
                              <v-icon 
                                v-else
                                :size="10"
                                style="padding-right:5px;color:transparent"
                              >
                                fas fa-square-full
                              </v-icon> -->
                              <v-icon 
                                :color="ordersData[order.id].orderedProducts[opKey].deliveryStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].deliveryStatus] : '#ccc'"
                                :size="8"
                                style="padding-right:2px;"
                              >
                                fas fa-square-full
                              </v-icon>
                              <v-icon 
                                v-if="!order.sample"
                                :color="ordersData[order.id].orderedProducts[opKey].invoiceStatus ? settings.orderStatusColors[ordersData[order.id].orderedProducts[opKey].invoiceStatus] : '#ccc'"
                                :size="8"
                                style="padding-right:0px;"
                              >
                                fas fa-square-full
                              </v-icon>
                            </div>
                          </div>
                        </v-col>
                        <v-col sm="1" class="pl-1 pt-1">
                          <PaymentStatus  :order="ordersData[order.id]" /><!-- v-if="ordersData[order.id].invoices !== undefined && ordersData[order.id].invoicesAllPaid !== undefined" -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-lazy>
      </div>

      <div style="padding-top:40px;padding-bottom:500px;width:100%" class="text-center">
        <v-row no-gutters class="" v-if="searchInProgress">
          <v-col cols="12" offset-sm3 class="text-center" >
            <div style="color:#F36638;"><b>Haku käynnissä...</b></div>
            <div class="lds-facebook" style="scale:0.6"><div></div><div></div><div></div></div>
          </v-col>
        </v-row>
        <!-- <span v-if="user.uid ==='p2VRFkTz4JUzqkGoTPUt4CWQAxa2'">
          <v-btn v-if="ordersSearch.trim() !== ''" @click="fetchExtraData()" color="#000000" dark class="avecor-button-global add-button mr-3">Hae vanhempia tilauksia</v-btn>
          <span>{{companyIdsToUseInSearch}}</span>
        </span> -->
      </div>
    </v-container>
    <SendEmailsProgress :batchSendDetails="batchSendDetails" :typeOfSendBatchSend="typeOfSendBatchSend"/>
    <InvoiceOrderModal></InvoiceOrderModal>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import { Printd } from 'printd'
import firebase from 'firebase'
import OrderExpand from './OrderExpand'
import PaymentStatus from './PaymentStatus'
import PinnedOrders from './PinnedOrders'
import SendEmailsProgress from './SendEmailsProgress'
import InvoiceOrderModal from './InvoiceOrderModal'
import shared from './../../shared'
import axios from 'axios'

export default {
    components: {
      OrderExpand,
      PinnedOrders,
      SendEmailsProgress,
      InvoiceOrderModal,
      PaymentStatus
    },
    props: ['filterCompanyId'],
    created(){
      this.createVariationName = shared.createVariationName
      this.createVariationAvecorSku = shared.createVariationAvecorSku
      this.createVariationNameDataIncluded = shared.createVariationNameDataIncluded
      this.createVariationAvecorSkuDataIncluded = shared.createVariationAvecorSkuDataIncluded
      this.syncOrderToNetvisor = shared.syncOrderToNetvisor
      this.generateDeliveryMarginsByOrder = shared.generateDeliveryMarginsByOrder
    },
    data: () => ({
      orderTableKey:4588995,
      numberOfFoundOrders:0,
      numberOfFoundOrdersFromHistory:0,
      searchInProgress:false,
      batchSendDetails:[],
      ordersWithExtraLogs:[],
      ordersShowAllLogs:[],
      typeOfSendBatchSend:null,
      allStatusOrdersSelected:false,
      ordersSearchWithinSelectedStatus:false,
      showOnlyHistoryOrders:false,
      deliveryWeekEdit:{},
      henkkaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_henripotila_A4.pdf'),
      hannaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_hanna-liukkonen_A4.pdf'),
      jarkkoUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_jarkko-tunturi_A4.pdf'),
      juhaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_juha-aaltonen_A4.pdf'),
      atteUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_atte-palonen_A4.pdf'),
      hennaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_henna-simpanen_A4.pdf'),
      janneUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_janne-jussila_A4.pdf'),//
      katriUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_katri-martiskainen_A4.pdf'),//
      markkuUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_markku-nuutinen_A4.pdf'),//
      samiUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_sami-maunu_A4.pdf'),//
      timoUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_timo-kekale_A4.pdf'),//
      janiUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_jani-sinervo_A4.pdf'),//
      camillaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_camilla-nyman_A4.pdf'),//
      tuukkaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_tuukka-smura_A4.pdf'),//
      janitaUrl:require('../../assets/salesperson-leaflets/Kiitoskortti_Avecor_janita-kauhanen _A4.pdf'),//
      

      invoicesTimePeriod:'threeMonths',
      batchUpdateItems:{},
      toggle_null:null,
      printIframe:null,
      numberOfWaitingInfoOrders:0,
      numberOfWaitingInfoOrderedProducts:0,
      numberOfDeadlineOrders:0,
      numberOfAvecorOrders:0,
      
      numberOfPendingOrders:0,
      numberOfFittingOrders:0,
      numberOfSalespersonSampleOrders:0,
      numberOfReclamationOrders:0,
      
      numberOfHighCriticalOrders:0,
      numberOfMediumCriticalOrders:0,

      numberOfNotInvoicedOrders:0,
      numberOfNotInvoicedOrderededProducts:0,
      numberOfNotShippedOrders:0,
      numberOfNotShippedOrderededProducts:0,
      numberOfOrders:0,
      numberOfNewOrders: 0,
      numberOfProcessLaterOrders:0,
      numberOfCompileProductsOrders:0,
      numberOfLogoRequestedOrders:0,
      numberOfLogoReminderSentOrders:0,
      numberOfSendProductsToPrintOrders:0,
      numberOfDraftOrderedOrders:0,
      numberOfDraftOrderedReminderOrders:0,
      numberOfDraftSentToCustomerOrders:0,
      numberOfDraftReminderOrders:0,
      numberOfSalesRequestedToContactOrders:0,
      numberOfOrderCreatedOrders:0,
      numberOfOrderCreatedRemindersOrders:0,
      numberOfAwaitingBatchOrders:0,
      numberOfProductsArrivedToWarehouseOrders:0,
      numberOfIncompleteShelfOrders:0,
      numberOfOrderLaterIncompleteShelfOrders:0,
      numberOfProductsShippedOrders:0,
      numberOfInvoiceOrders:0,
      
      numberOfOrderedProducts:0,
      numberOfNewOrderedProducts: 0,
      numberOfProcessLaterOrderedProducts:0,
      numberOfCompileProductsOrderedProducts:0,
      numberOfLogoRequestedOrderedProducts:0,
      numberOfLogoReminderSentOrderedProducts:0,
      numberOfSendProductsToPrintOrderedProducts:0,
      numberOfDraftOrderedOrderedProducts:0,
      numberOfDraftSentToCustomerOrderedProducts:0,
      numberOfDraftReminderOrderedProducts:0,
      numberOfSalesRequestedToContactOrderedProducts:0,
      numberOfOrderCreatedOrderedProducts:0,
      numberOfOrderCreatedRemindersOrderedProducts:0,
      numberOfAwaitingBatchOrderedProducts:0,
      numberOfProductsArrivedToWarehouseOrderedProducts:0,
      numberOfIncompleteShelfOrderedProducts:0,
      numberOfOrderLaterIncompleteShelfOrderedProducts:0,
      numberOfProductsShippedOrderedProducts:0,
      numberOfInvoiceOrderedProducts:0,
          
      activeOrdersData:{},
      numberOfOrdersVisible:50,
      ordersData:{},
      productsData:{},
      orderExpansions:{},
      showTable:false,
      isEditing: false,
      selected: ["Avecor Oy"],
      selections: {},
      pagination: {'sortBy': 'created_at', 'descending': true, 'rowsPerPage': 15, 'sortable':false},
      rowsPerPageItems:[15,30],
      dialog: false,
      productDialog: false,
      newOrderDialog: false,
      selectedOrderId: null,
      selectedCompanyId: null,
      whichOrdersToShow: "notReady",
      orderResponsibility: "new", //"allNotShipped",
      staffEmails:[],
      table: null,
      autogrow: true,
      search: '',
      companyIdsToUseInSearch:[],
      editedIndex: -1,
      addedDatePickerMenuMaster: false,
      latestToCustomerDatePickerMenuMaster : false,
      latestToCustomerDatePickerMenu: false,
      date: new Date().toISOString().substr(0, 10)
    }),
    watch: {
      orderResponsibility : {
        handler(val){
          if(val === 'awaitingBatch') {
            this.generateProductsData()
          }
        }
      },
      allAccess:{
        handler(val) {
          if(val && this.isWarehouse){
            this.orderResponsibility = "productsArrivedToWarehouse"
          }
          
        }
      },
      windowWidth:{
        handler(newWidth, oldWidth) {
          console.log("updated")
          if(newWidth < 600) this.device = "mobile"
          if(newWidth >= 600) this.device = "desktop"
        }
      },
      orderedProducts: {
        handler(val){
          this.generateOrdersData()
        },
        deep: true
      },
      orders: {
        handler(val){
          this.generateOrdersData()
          //this.updateCompaniesWithLatestOrderDate()
        },
        deep: true
      },
      productVariations: {
        handler(val){
          this.generateOrdersData()
          this.generateProductsData()
          //this.updateCompaniesWithLatestOrderDate()
        },
        deep: true
      },
      wholesaleCompanies:{
        handler(val){
          this.generateProductsData()
        },
        deep: true
      },
      loaded:{
        handler(val){
          this.generateOrdersData()
        },
      }
    },
    mounted() {
      if(this.isWarehouse) {
        this.orderResponsibility = "productsArrivedToWarehouse" //"allNotShipped"
        console.log(this.isWarehouse)
        console.log(this.orderResponsibility)
      }
      else if(this.isOffice) {
        this.orderResponsibility = "new"
      }
      else if(this.isSales) {
        this.orderResponsibility = "allNotShipped"
      }
      //orderResponsibility: "new", //"allNotShipped",
      this.ordersSearch = this.ordersSearchTerm
      this.generateOrdersData()
      for (const key of Object.keys(this.staff)) {
        this.staff[key].email !== undefined ? this.staffEmails.push(this.staff[key].email) : ''
      }

      //this.addStickyHeaders('orders-table',50)

      /* // When the user scrolls the page, execute myFunction 
      window.onscroll = function() {myFunction()};

      // Get the header
      var header = document.getElementById("orders-table-headers");

      // Get the offset position of the navbar
      var sticky = header.offsetTop;

      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      function myFunction() {
        if (window.pageYOffset > sticky) {
          header.classList.add("orders-table-headers-sticky");
        } else {
          header.classList.remove("orders-table-headers-sticky");
        }
      } */

    },
    beforeDestroy() {
      this.ordersData = {}
    },
    
    computed: {
      ...mapFields({
        searchOrders:'searchOrders',
        searchOrderedProducts:'searchOrderedProducts',
        device:'device',
        isSyncOrderToNetvisorActive:"isSyncOrderToNetvisorActive",
        settings:"settings",
        user:"user",
        ordersSearch:"settings.ordersSearch",
        ordersSearchTerm:"settings.ordersSearchTerm",
        companies:"company.companies",
        contacts:"contact.contacts",
        products:"product.products",
        isSales:'settings.isSales',
        isOffice:'settings.isOffice',
        isWarehouse:'settings.isWarehouse',
        wholesaleCompanies:'wholesaleCompany.wholesaleCompanies',
        printShops:"printShop.printShops",
        orderedProducts:"orderedProduct.orderedProducts",
        productVariations:"productVariation.productVariations",
        staff:"staff.staff",
        orders:"order.orders",
        //companySelectedInModel:"settings.companySelectedInModel",
        //productCatalog:"product.products",
        //selectedOrderCompanyId:"views.orders.selectedOrder.companyId",
        pinnedOrdersInOrders:"views.orders.pinnedOrders",
        selectedOrderOrderId:"views.orders.selectedOrder.orderId",
        loaded:"settings.loaded",
        sendProgressVisible:"modals.orders.sendProgress.visible",
        orderInvoicingModalVisible:"modals.orders.invoicing.visible",
        orderInvoicingModalOrderId:"modals.orders.invoicing.orderId",
        orderInvoicingModalEnv:"modals.orders.invoicing.env",
      }),
      
      /* companies(){return this.$store.state.company.companies},
      orderedProducts(){return this.$store.state.orderedProduct.orderedProducts},
      productVariations(){return this.$store.state.productVariation.productVariations},
      products(){return this.$store.state.product.products}, */
      getOrdersSearchClasses(){
        if(this.ordersSearch && this.searchInProgress) return 'table-search avecor-no-underline orders-search-hint-orange' 
        else if(this.ordersSearch && !this.searchInProgress) return 'table-search avecor-no-underline orders-search-hint-green'
        else return 'table-search avecor-no-underline small-hint'
      },
      ordersSearchHint(){
        if(this.ordersSearch){
          if(this.searchInProgress) return `Haetaan tilauksia historiasta....`
          else return `Haku valmis. Hakutulosten määärä: ${this.numberOfFoundOrders}, joista ${this.numberOfFoundOrdersFromHistory} löytyi historiadatasta.`
        }
        else return 'Käytä hakutekstin alussa tunnisteita historiahakua varten. "hn:" => netvisor idllä haku, "ht:" => tuotenimellä haku,  "hy:" => yrityksen nimellä haku.'
      },
      ordersAll(){
        return {...this.orders, ...this.searchOrders}
      },
      getProducts(){
        var products = []
        console.log(this.productsData)
        Object.keys(this.productsData).forEach(pId =>{
          products.push(this.productsData[pId])
        })
        products.sort((a,b)=>{
          if(!a.name) return 0
          if(!b.name) return 0
          var nameA= a.name.toLowerCase(), nameB=b.name.toLowerCase();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        return products
      },
      getBatches(){
        var batches = []
        Object.keys(this.productsData).forEach(pId =>{
          var p = this.productsData[pId]
          Object.keys(p.productVariations).forEach(pvId => {
            var pv = p.productVariations[pvId]
            Object.keys(pv.batches)

          })
        })
        return batches
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      getNumberOfHighCriticalOrders(){
        var highCriticalOrders = 0
        var criticalOrders = {}
        var o
        for (const key of Object.keys(this.ordersData)) {
          o = this.ordersData[key]
          for (const key2 of Object.keys(o.orderedProducts)) {
        /* Object.keys(this.ordersData).map(function(key, index) {
          var o = ordersData[key]
          Object.keys(o.orderedProducts).map(function(key2, index) { */
            var latestToCustomerDate = null
            o.orderedProducts[key2].latestToCustomer !== undefined ? latestToCustomerDate = new Date(o.orderedProducts[key2].latestToCustomer) : ""
            var dateNow = new Date()
            var oneDay = 24*60*60*1000;
            if (latestToCustomerDate !== null){
              var diffDays = Math.round(Math.abs((dateNow.getTime() - latestToCustomerDate.getTime())/(oneDay)));
              if (diffDays <= 14) {
                if (typeof o.invoiceStatuses === "undefined" 
                        || o.invoiceStatuses.includes("invoiced")){}
                else {        
                  if (this.orderResponsibility === "office" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "anuToivanen" && o.orderResponsible == "wcMZF1c4vsMZAmCsXzSDDwh4PJd2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "kirsiIkonen" && o.orderResponsible == "kIPBYRhld0bYpA4VmSzDLtwh4Dc2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "susannaHartikainen" && o.orderResponsible == "ZFD0Kai7eKOwgkviPXcpR6FlMb53" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "assistant" && o.orderResponsible == "p2VRFkTz4JUzqkGoTPUt4CWQAxa2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "warehouse" && (typeof o.currentResponsibles !== "undefined" && o.currentResponsibles.includes("varasto"))) {
                    highCriticalOrders += 1
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                }
              }
            }
          }
        }
        return Object.keys(criticalOrders).length
      },
      getNumberOfMediumCriticalOrders(){
        var mediumCriticalOrders = 0
        var criticalOrders = {}
        var o
        for (const key of Object.keys(this.ordersData)) {
          o = this.ordersData[key]
          for (const key2 of Object.keys(o.orderedProducts)) {
            var latestToCustomerDate = null
            o.orderedProducts[key2].latestToCustomer !== undefined ? latestToCustomerDate = new Date(o.orderedProducts[key2].latestToCustomer) : ""
            var dateNow = new Date()
            var oneDay = 24*60*60*1000;
            if (latestToCustomerDate !== null){
              var diffDays = Math.round(Math.abs((dateNow.getTime() - latestToCustomerDate.getTime())/(oneDay)));
              if (diffDays > 14 && diffDays < 28) {
                if (typeof o.invoiceStatuses === "undefined" 
                        || o.invoiceStatuses.includes("invoiced")){}
                else {        
                  if (this.orderResponsibility === "office" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "anuToivanen" && o.orderResponsible == "wcMZF1c4vsMZAmCsXzSDDwh4PJd2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "kirsiIkonen" && o.orderResponsible == "kIPBYRhld0bYpA4VmSzDLtwh4Dc2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "susannaHartikainen" && o.orderResponsible == "ZFD0Kai7eKOwgkviPXcpR6FlMb53" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "assistant" && o.orderResponsible == "p2VRFkTz4JUzqkGoTPUt4CWQAxa2" && (typeof o.currentResponsibles === "undefined" || o.currentResponsibles.includes("office"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                  else if (this.orderResponsibility === "warehouse" && (typeof o.currentResponsibles !== "undefined" && o.currentResponsibles.includes("varasto"))) {
                    criticalOrders[key] !== undefined ? criticalOrders[key] += 1 :  criticalOrders[key] = 1
                  }
                }
              }
              
            }
          } 
        }
        return Object.keys(criticalOrders).length
      },
      getColorStatuses(){
        return Object.keys(this.settings.orderStatusColors).map(function(status, index){
          return status
        })
      },
      getOrders(){
        var selectedOrders = []
        this.numberOfFoundOrders = 0
        this.numberOfFoundOrdersFromHistory = 0
        //var t = this
        var d = new Date();
        d.setMonth(d.getMonth() - 3);
        const threeMonthsPriorInSeconds = d.getTime() / 1000
        this.numberOfOrders = 0
        this.numberOfPendingOrders = 0
        this.numberOfFittingOrders = 0
        this.numberOfSalespersonSampleOrders = 0
        this.numberOfHighCriticalOrders = 0
        this.numberOfMediumCriticalOrders = 0
        this.numberOfPendingOrders = 0
        this.numberOfReclamationOrders = 0
        this.numberOfFittingOrders = 0
        this.numberOfNotInvoicedOrders = 0
        this.numberOfNotShippedOrders = 0
        this.numberOfNewOrders = 0
        this.numberOfProcessLaterOrders = 0
        this.numberOfWaitingInfoOrders = 0
        this.numberOfDeadlineOrders = 0
        this.numberOfAvecorOrders = 0
        this.numberOfCompileProductsOrders = 0
        this.numberOfLogoRequestedOrders=0
        this.numberOfLogoReminderSentOrders=0
        this.numberOfSendProductsToPrintOrders = 0
        this.numberOfDraftOrderedOrders = 0
        this.numberOfDraftOrderedReminderOrders = 0
        this.numberOfDraftSentToCustomerOrders = 0
        this.numberOfDraftReminderOrders = 0
        this.numberOfSalesRequestedToContactOrders = 0
        this.numberOfOrderCreatedOrders = 0
        this.numberOfOrderCreatedRemindersOrders = 0
        this.numberOfAwaitingBatchOrders = 0
        this.numberOfProductsArrivedToWarehouseOrders = 0
        this.numberOfIncompleteShelfOrders = 0
        this.numberOfOrderLaterIncompleteShelfOrders = 0
        this.numberOfProductsShippedOrders = 0
        this.numberOfInvoiceOrders = 0
        
        this.numberOfOrderedProducts = 0
        this.numberOfPendingOrderedProducts = 0
        this.numberOfSampleOrderedProducts = 0
        this.numberOfNotInvoicedOrderededProducts = 0
        this.numberOfNotShippedOrderededProducts = 0
        this.numberOfNewOrderedProducts = 0
        this.numberOfProcessLaterOrderedProducts = 0
        this.numberOfWaitingInfoOrderedProducts = 0
        this.numberOfCompileProductsOrderedProducts = 0
        this.numberOfLogoRequestedOrderedProducts = 0
        this.numberOfLogoReminderSentOrderedProducts = 0
        this.numberOfSendProductsToPrintOrderedProducts = 0
        this.numberOfDraftOrderedOrderedProducts = 0
        this.numberOfDraftSentToCustomerOrderedProducts = 0
        this.numberOfDraftReminderOrderedProducts = 0
        this.numberOfSalesRequestedToContactOrderedProducts = 0
        this.numberOfOrderCreatedOrderedProducts = 0
        this.numberOfOrderCreatedRemindersOrderedProducts = 0
        this.numberOfAwaitingBatchOrderedProducts = 0
        this.numberOfProductsArrivedToWarehouseOrderedProducts = 0
        this.numberOfIncompleteShelfOrderedProducts = 0
        this.numberOfOrderLaterIncompleteShelfOrderedProducts = 0
        this.numberOfProductsShippedOrderedProducts = 0
        this.numberOfInvoiceOrderedProducts = 0

        var allInvoiced = true
        var allInvoicedOrCancelled = true
        var allShipped = true
        var allCancelled = true
        var allShippedOrCancelled = true
        var oneDay = 24*60*60*1000;
        var o,op,latestToCustomerDate,dateNow,diffDays,criticalityProcessedForOrder
        console.log("START")
        for (const key of Object.keys(this.ordersData)) {
          o = this.ordersData[key]
          if(this.showOnlyHistoryOrders && !o.viaSearch) continue
          //if(this.staff[this.user.uid].role === 'sales' && (o.salespersonId !== this.user.uid && !this.staff[this.user.uid].isAdmin)) continue
          allInvoicedOrCancelled = true
          allInvoiced = true
          allShipped = true
          allCancelled = true
          allShippedOrCancelled = true
          
          o.orderStatuses.forEach(os => {
            if(os !== "productsShipped" && os !== 'samplesShipped'){
              allShipped = false
              if((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample)){
                //this.numberOfNotShippedOrderededProducts += 1
              }
            } 
            if(os !== "productsShipped" && os !== 'samplesShipped' && os !== "cancelled"){
              allShippedOrCancelled = false
            }
            if(os !== "cancelled"){
              allCancelled = false
            }
          })
          o.orderAndInvoiceStatuses.forEach(ois => {
            if(ois !== "productsShipped_invoiced" && !ois.includes('cancelled_')){
              allInvoicedOrCancelled = false
            }
          })
          o.invoiceStatuses.forEach(is => {
            if(is !== "invoiced"){
              allInvoiced = false
              if((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && !o.areAllArchived && !allCancelled){
                this.numberOfNotInvoicedOrderededProducts += 1
              }
            } 
          })
          if(!allInvoiced && !allCancelled && (o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && (o.reclaimed === undefined || !o.reclaimed) && !o.areAllArchived){ 
            this.numberOfNotInvoicedOrders += 1
          }
          if(!allShipped && (o.pending === undefined || !o.pending) && (o.reclaimed === undefined || !o.reclaimed) && !o.areAllArchived && !allCancelled){ 
            this.numberOfNotShippedOrders += 1
          }
          /* IN CASE COUNT ONLY ALL SHIPPED ORDERS */
          /* if(allShipped && !allInvoiced && (o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && (o.reclaimed === undefined || !o.reclaimed) && !o.areAllArchived){ 
            this.numberOfProductsShippedOrders += 1
          } */
          // this.orderResponsibility === "productsShipped" && allShipped && !allInvoiced) {selectedOrders.push(o)
          this.numberOfOrders += 1
          this.numberOfOrderedProducts += o.orderedProducts ? Object.keys(o.orderedProducts).length : 0
          if(o.pending !== undefined && o.pending && !o.areAllArchived){this.numberOfPendingOrders += 1}
          if(o.avecorOrder !== undefined && o.avecorOrder && !o.areAllArchived){this.numberOfAvecorOrders += 1}
          if(o.reclaimed !== undefined && o.reclaimed){this.numberOfReclamationOrders += 1}
          if(o.deadline !== undefined && o.deadline && !o.areAllArchived) this.numberOfDeadlineOrders += 1
          if(o.sample && (o.orderStatuses.includes("new") || o.orderStatuses.includes("productsTransferredToPackage")) && !o.areAllArchived && !o.allInvoiced) {
            this.numberOfFittingOrders += 1
            this.numberOfProductsArrivedToWarehouseOrders += 1
            this.numberOfProductsArrivedToWarehouseOrderedProducts += Object.keys(o.orderedProducts).length
          }
          if(o.salespersonSample !== undefined && o.salespersonSample && !o.allShipped && !o.areAllArchived) this.numberOfSalespersonSampleOrders += 1
          
          if ((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && (o.reclaimed) && !allInvoiced  && !o.areAllArchived){
            o.invoiceStatuses.includes("invoice") ? this.numberOfInvoiceOrders += 1 : 0
            o.invoiceStatuses.forEach(is => {
              if(is === "invoice") this.numberOfInvoiceOrderedProducts += 1
            })
          }
          
          if ((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && (o.reclaimed === undefined || !o.reclaimed) && !allInvoiced  && !o.areAllArchived){
            criticalityProcessedForOrder = false
            
            Object.keys(o.orderedProducts).forEach( opId => {
              op = o.orderedProducts[opId]
              
              if(op.latestToCustomer !== undefined){
                latestToCustomerDate = new Date(op.latestToCustomer)
                dateNow = new Date()
                
                if (latestToCustomerDate !== null){
                  diffDays = Math.round(Math.abs((dateNow.getTime() - latestToCustomerDate.getTime())/(oneDay)));
                  if (diffDays <= 14) {
                    if(!criticalityProcessedForOrder) this.numberOfHighCriticalOrders += 1
                    criticalityProcessedForOrder = true
                  }
                  else if (diffDays > 14 && diffDays < 28) {
                    if(criticalityProcessedForOrder) this.numberOfMediumCriticalOrders += 1
                    criticalityProcessedForOrder = true
                  }
                }
              }
            })
                       
            // CURRENT STATUSES
            o.orderStatuses.includes("new") ? this.numberOfNewOrders += 1 : 0
            o.orderStatuses.includes("processLater") ? this.numberOfProcessLaterOrders += 1 : 0
            o.orderStatuses.includes("compileProducts") ? this.numberOfCompileProductsOrders += 1 : 0
            o.orderStatuses.includes("logoRequested") ? this.numberOfLogoRequestedOrders += 1 : 0
            o.orderStatuses.includes("logoReminderSent") ? this.numberOfLogoReminderSentOrders += 1 : 0

            o.orderStatuses.includes("sendProductsToPrint") ? this.numberOfSendProductsToPrintOrders += 1 : 0
            o.orderStatuses.includes("draftOrdered") ? this.numberOfDraftOrderedOrders += 1 : 0
            o.orderStatuses.includes("draftOrderedReminder") ? this.numberOfDraftOrderedReminderOrders += 1 : 0
            o.orderStatuses.includes("draftSentToCustomer") ? this.numberOfDraftSentToCustomerOrders += 1 : 0
            o.orderStatuses.includes("draftReminder1") ? this.numberOfDraftReminderOrders += 1 : 0
            o.orderStatuses.includes("draftReminder2") ? this.numberOfDraftReminderOrders += 1 : 0
            o.orderStatuses.includes("salesRequestedToContact") || o.orderStatuses.includes("salesRequestedToContactForLogo") || o.orderStatuses.includes("salesRequestedToContactForDraft") ? this.numberOfSalesRequestedToContactOrders += 1 : 0
            o.orderStatuses.includes("orderCreated") ? this.numberOfOrderCreatedOrders += 1 : 0
            o.orderStatuses.includes("orderCreatedReminder") ? this.numberOfOrderCreatedRemindersOrders += 1 : 0
            o.orderStatuses.includes("orderCreatedToPrintShop") ? this.numberOfOrderCreatedOrders += 1 : 0
            o.orderStatuses.includes("incompleteShelf") ? this.numberOfIncompleteShelfOrders += 1 : 0
            o.orderStatuses.includes("orderLaterIncompleteShelf") ? this.numberOfOrderLaterIncompleteShelfOrders += 1 : 0
            o.orderStatuses.includes("awaitingBatch") ? this.numberOfAwaitingBatchOrders += 1 : 0
            o.orderStatuses.includes("productsArrivedToWarehouse") ? this.numberOfProductsArrivedToWarehouseOrders += 1 : 0
            //o.orderStatuses.includes("productsShipped") ? this.numberOfProductsShippedOrders += 1 : 0
            o.orderAndInvoiceStatuses.includes('productsShipped_invoice') || o.orderAndInvoiceStatuses.includes('productsShipped_doNotInvoice') ? this.numberOfProductsShippedOrders += 1 : 0
            

            o.invoiceStatuses.includes("invoice") ? this.numberOfInvoiceOrders += 1 : 0
            /* if(o.orderAndInvoiceStatuses.includes('productsShipped_invoice') || o.orderAndInvoiceStatuses.includes('productsShipped_doNotInvoice')) {
              console.log('COUNTER',o.companyName, o.orderAndInvoiceStatuses)
            } */

            
            o.orderStatuses.includes("waitingInfo") ? this.numberOfWaitingInfoOrders += 1 : 0
            o.orderStatuses.forEach(os => {
              if(os === "new") this.numberOfNewOrderedProducts += 1
              else if(os === "processLater") this.numberOfProcessLaterOrderedProducts += 1
              else if(os === "compileProducts") this.numberOfCompileProductsOrderedProducts += 1
              else if(os === "logoRequested") this.numberOfLogoRequestedOrderedProducts += 1
              else if(os === "logoReminderSent") this.numberOfLogoReminderSentOrderedProducts += 1
              else if(os === "sendProductsToPrint") this.numberOfSendProductsToPrintOrderedProducts += 1
              else if(os === "draftOrdered") this.numberOfDraftOrderedOrderedProducts += 1
              else if(os === "draftSentToCustomer") this.numberOfDraftSentToCustomerOrderedProducts += 1
              else if(os === "draftReminder1") this.numberOfDraftReminderOrderedProducts += 1
              else if(os === "draftReminder2") this.numberOfDraftReminderOrderedProducts += 1
              else if(os === "salesRequestedToContact") this.numberOfSalesRequestedToContactOrderedProducts += 1
              else if(os === "salesRequestedToContactForLogo") this.numberOfSalesRequestedToContactOrderedProducts += 1
              else if(os === "salesRequestedToContactForDraft") this.numberOfSalesRequestedToContactOrderedProducts += 1
              else if(os === "orderCreated") this.numberOfOrderCreatedOrderedProducts += 1
              else if(os === "orderCreatedReminder") this.numberOfOrderCreatedRemindersOrderedProducts += 1
              else if(os === "orderCreatedToPrintShop") this.numberOfOrderCreatedOrderedProducts += 1
              else if(os === "incompleteShelf") this.numberOfIncompleteShelfOrderedProducts += 1
              else if(os === "orderLaterIncompleteShelf") this.numberOfOrderLaterIncompleteShelfOrderedProducts += 1
              else if(os === "awaitingBatch") this.numberOfAwaitingBatchOrderedProducts += 1
              else if(os === "productsArrivedToWarehouse") this.numberOfProductsArrivedToWarehouseOrderedProducts += 1
              //else if(!allInvoiced && allShipped && os === "productsShipped") this.numberOfProductsShippedOrderedProducts += 1
              //else if(!allInvoiced && os === "productsShipped") this.numberOfProductsShippedOrderedProducts += 1
              
              else if(os === "waitingInfo") this.numberOfWaitingInfoOrderedProducts += 1
            })
            o.orderAndInvoiceStatuses.forEach(ois => {
              if(ois === "productsShipped_invoice") this.numberOfProductsShippedOrderedProducts += 1
              if(ois === "productsShipped_doNotInvoice") this.numberOfProductsShippedOrderedProducts += 1
            })
            o.invoiceStatuses.forEach(is => {
              if(is === "invoice") this.numberOfInvoiceOrderedProducts += 1
            })
          }


          if(o.reclaimed){
            o.orderAndInvoiceStatuses.includes('productsShipped_invoice') ? this.numberOfProductsShippedOrders += 1 : 0
            o.orderAndInvoiceStatuses.includes('productsShipped_doNotInvoice') ? this.numberOfProductsShippedOrders += 1 : 0
            o.orderAndInvoiceStatuses.forEach(ois => {
              if(ois === "productsShipped_invoice") this.numberOfProductsShippedOrderedProducts += 1
              if(ois === "productsShipped_doNotInvoice") this.numberOfProductsShippedOrderedProducts += 1
            })
          }

          var marginRateColor = "#000"
          var marginRate = '--'
          if(o.salespersonMarginViaOpsDefined){
            /* console.log("IN DEFINED") */
            var margin = 0
            if(o.marginViaOpsForMarginRate) margin = o.marginViaOpsForMarginRate
            /* if(o.officeMarginViaOps) margin = o.officeMarginViaOps
            else if (o.salespersonMarginViaOps) margin = o.salespersonMarginViaOps */
            //var margin = o.salespersonMarginViaOps
            marginRate = (Number(o.total)/(Number(o.total)-Number(margin))).toFixed(2)
            /* if(o.netvisorId === '15170'){
              console.log({total:o.total,margin,marginRate,netvisorId:o.netvisorId})
            } */
            
            //console.log(marginRate)
            if (marginRate < 2) marginRateColor = "#DE3164"
            else if (marginRate >= 2 && marginRate <= 2.5) marginRateColor = "#FFBF00"
            else if(marginRate > 2.5) marginRateColor = "#2ECC40"
          }
            
           
          
          o = {...o, marginRateColor,marginRate}

          if(o.id === this.selectedOrderOrderId) {selectedOrders.push(o); continue;}


          var orderTextsToSearch = ""
          if(this.user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2') orderTextsToSearch += o.id
          if(o.orderSummary !== undefined) orderTextsToSearch += o.orderSummary
          if(o.orderSummaryIds !== undefined) orderTextsToSearch += o.orderSummaryIds
          if(this.companies[o.companyId] !== undefined) orderTextsToSearch += this.companies[o.companyId].companyId
          if(o.companyName !== undefined) orderTextsToSearch += o.companyName
          if(o.productsWholesaleNames !== undefined) orderTextsToSearch += o.productsWholesaleNames
          if(o.productsEnglishNames !== undefined) orderTextsToSearch += o.productsEnglishNames
          
          if(o.contactPhone !== undefined) orderTextsToSearch += o.contactPhone
          if(o.contactEmail !== undefined) orderTextsToSearch += o.contactEmail
          if(o.companyAddress !== undefined) orderTextsToSearch += o.companyAddress
          if(o.contactName !== undefined) orderTextsToSearch += o.contactName
          if(o.netvisorId !== undefined) orderTextsToSearch += o.netvisorId
          if(o.billingReferenceDetails !== undefined) orderTextsToSearch += o.billingReferenceDetails
          if(o.printShops !== undefined) orderTextsToSearch += o.printShops
          if(o.wholesaleCompanies !== undefined) orderTextsToSearch += o.wholesaleCompanies
          if(o.salespersonFirstName !== undefined) orderTextsToSearch += o.salespersonFirstName
          if(this.orders[key] && this.orders[key].officeOrderComments !== undefined) orderTextsToSearch += this.orders[key].officeOrderComments
          if(this.orders[key] && this.orders[key].orderComments !== undefined) orderTextsToSearch += this.orders[key].orderComments
          orderTextsToSearch = orderTextsToSearch.toLowerCase().trim()
          var ordersSearch = this.ordersSearch
          if(ordersSearch.includes('hn:')) ordersSearch = ordersSearch.split('hn:')[1]
          if(ordersSearch.includes('hy:')) ordersSearch = ordersSearch.split('hy:')[1]
          if(ordersSearch.includes('ht:')) ordersSearch = ordersSearch.split('ht:')[1]

          var searchSplit = ordersSearch.toLowerCase().trim().split(' ')

          var searchWordsFound = true
          searchSplit.forEach(k =>{
            if(!orderTextsToSearch.includes(k)) searchWordsFound = false
          })

          if (ordersSearch !== "" && !this.ordersSearchWithinSelectedStatus){
            if(searchWordsFound) {
                if (this.staff[this.user.uid].isAdmin) {this.numberOfFoundOrders += 1; if(o.viaSearch) this.numberOfFoundOrdersFromHistory +=1; selectedOrders.push(o)}
                else if (this.staff[this.user.uid].role === 'warehouse' ) {this.numberOfFoundOrders += 1; if(o.viaSearch) this.numberOfFoundOrdersFromHistory +=1; selectedOrders.push(o)}
                else if (this.staff[this.user.uid].role === 'office' ) {this.numberOfFoundOrders += 1; if(o.viaSearch) this.numberOfFoundOrdersFromHistory +=1; selectedOrders.push(o)}
                else if(this.staff[this.user.uid].role === 'sales' && o.salespersonId === this.user.uid) {this.numberOfFoundOrders += 1; if(o.viaSearch) this.numberOfFoundOrdersFromHistory +=1; selectedOrders.push(o)}
            }
          }
          else{
            // CHECK STATUS FILTER
            if(this.ordersSearchWithinSelectedStatus){
              if(!searchWordsFound) {
                continue
                /* if (this.staff[this.user.uid].isAdmin) selectedOrders.push(o)
                else if (this.staff[this.user.uid].role === 'warehouse' ) selectedOrders.push(o)
                else if (this.staff[this.user.uid].role === 'office' ) selectedOrders.push(o)
                else if(this.staff[this.user.uid].role === 'sales' && o.salespersonId === this.user.uid) selectedOrders.push(o) */
              }
            }
              

            /* MAKSETUT */
            if (this.orderResponsibility === "paid" && o.invoicesAllPaid) {selectedOrders.push(o)} // && !allInvoiced
            
            // IF ALL ARCHIVED, ONLY SHOW IN ARCHIVED VIEW
            if(o.areAllArchived){
              if(this.orderResponsibility === "archived") selectedOrders.push(o)
              continue
            }
            if (this.orderResponsibility === "notPaid" && o.invoicesAllPaid === false && o.invoices && Object.keys(o.invoices).length > 0) {selectedOrders.push(o)} // && !allInvoiced
            
            /* ODOTTAVAT */
            if (this.orderResponsibility === "pending" && o.pending){selectedOrders.push(o)}
            /* REKLAMAATIOT */
            else if (this.orderResponsibility === "reclamations" && o.reclaimed){selectedOrders.push(o)}
            /* DEADLINE */
            else if (this.orderResponsibility === "deadline" && o.deadline){selectedOrders.push(o)}
            /* AVECOR TILAUKSET */
            else if (this.orderResponsibility === "avecorOrders" && o.avecorOrder){selectedOrders.push(o)}
            /* SOVITUSPAKETIT */
            else if (this.orderResponsibility === "samples" && o.sample && (o.orderStatuses.includes("new") || o.orderStatuses.includes("productsTransferredToPackage") && !o.areAllArchived && !o.allInvoiced) ){selectedOrders.push(o)}
            /* MYYJIEN MALLITILAUKSET */
            else if (this.orderResponsibility === "salespersonSamples" && o.salespersonSample){selectedOrders.push(o)}
            /* ARKISSTOIDUT */
            else if (this.orderResponsibility === "archived" && o.isAtLeastOneArchived) {selectedOrders.push(o)} // && !allInvoiced

            

            /* UUSI */
            if((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample)){
              if (this.orderResponsibility === "new" && o.orderStatuses.includes("new")) {selectedOrders.push(o)}  // && !allInvoiced
            }


            if((o.pending === undefined || !o.pending) && (o.reclaimed === undefined || !o.reclaimed) && !o.areAllArchived){
              /* TUOTTEET SAAPUNUT VARASTOON */
              if (this.orderResponsibility === "productsArrivedToWarehouse" && (o.orderStatuses.includes("productsArrivedToWarehouse") 
                || (o.sample && (o.orderStatuses.includes("new") || o.orderStatuses.includes("productsTransferredToPackage")) ))) {
                  selectedOrders.push(o)
                }
            }
            


            //if ((o.pending === undefined || !o.pending) && (o.sample === undefined || !o.sample) && (o.reclaimed === undefined || !o.reclaimed) && !allInvoiced  && !o.areAllArchived){
            if ((o.pending === undefined || !o.pending)  && !o.areAllArchived){ //&& (o.sample === undefined || !o.sample)  && (o.reclaimed === undefined || !o.reclaimed) 
              /* KAIKKI  */
              //if (this.orderResponsibility === "all"){ selectedOrders.push(o) }
              /* KAIKKI EI LASKUTETUT */
              
              if (this.orderResponsibility === "allNotShipped" && !allShipped && !allCancelled && !allShippedOrCancelled){ selectedOrders.push(o) }
              /* TILAUS MYÖHEMMIN */
              else if (this.orderResponsibility === "processLater" && o.orderStatuses.includes("processLater")) {selectedOrders.push(o)} // && !allInvoiced
              /* DEADLINE */
              //else if (this.orderResponsibility === "deadline" && o.orderStatuses.includes("deadline") && !allInvoiced) {selectedOrders.push(o)} 
              
              /* WAITING INFO */
              else if (this.orderResponsibility === "waitingInfo" && o.orderStatuses.includes("waitingInfo")) {selectedOrders.push(o)} // && !allInvoiced
              /* KOONTI PERJANTAINA */
              else if (this.orderResponsibility === "compileProducts" && o.orderStatuses.includes("compileProducts")) {selectedOrders.push(o)} // && !allInvoiced
              /* LOGO PYYDETTY ASIAKKAALTA */
              else if (this.orderResponsibility === "logoRequested" && o.orderStatuses.includes("logoRequested")) {selectedOrders.push(o)} // && !allInvoiced
              /* LOGO MUISTUTUS LÄHETETTY */
              else if (this.orderResponsibility === "logoReminderSent" && o.orderStatuses.includes("logoReminderSent")) {selectedOrders.push(o)} // && !allInvoiced
              /* LÄHETÄ TUOTTEET MERKKAAMOON */
              else if (this.orderResponsibility === "sendProductsToPrint" && o.orderStatuses.includes("sendProductsToPrint")) {selectedOrders.push(o)} // && !allInvoiced
              /* VEDOS TILATTU TOIMITTAJALTA */
              else if (this.orderResponsibility === "draftOrdered" && o.orderStatuses.includes("draftOrdered")) {selectedOrders.push(o)} // && !allInvoiced
              /* VEDOS MUISTUTUS TOIMITTAJALTA */
              else if (this.orderResponsibility === "draftOrderedReminder" && o.orderStatuses.includes("draftOrderedReminder")) {selectedOrders.push(o)} // && !allInvoiced
              
              /* VEDOS LÄHETETTY ASIAKKAALLE */
              else if (this.orderResponsibility === "draftSentToCustomer" && o.orderStatuses.includes("draftSentToCustomer")) {selectedOrders.push(o)} // && !allInvoiced
              /* MUISTUTUS 1 LÄHETETTY ASIAKKAALLE */
              else if (this.orderResponsibility === "draftReminder1" && o.orderStatuses.includes("draftReminder1")) {selectedOrders.push(o)} // && !allInvoiced
              /* MUISTUTUS 2 LÄHETETTY ASIAKKAALLE */
              else if (this.orderResponsibility === "draftReminder2" && o.orderStatuses.includes("draftReminder2")) {selectedOrders.push(o)} // && !allInvoiced
              /* MYYJAA PYYDETTY KONTAKTOIMAAN */
              else if (this.orderResponsibility === "salesRequestedToContact" && (o.orderStatuses.includes("salesRequestedToContact") || o.orderStatuses.includes("salesRequestedToContactForLogo") || o.orderStatuses.includes("salesRequestedToContactForDraft"))) {selectedOrders.push(o)} // && !allInvoiced
              /* TILAUS TEHTY TOIMITTAJALLE / MERKKAAMOLLE */
              else if (this.orderResponsibility === "orderCreated" && o.orderStatuses.includes("orderCreated")) {selectedOrders.push(o)} // && !allInvoiced
              else if (this.orderResponsibility === "orderCreatedReminder" && o.orderStatuses.includes("orderCreatedReminder")) {selectedOrders.push(o)} // && !allInvoiced
              else if (this.orderResponsibility === "orderCreated" && o.orderStatuses.includes("orderCreatedToPrintShop")) {selectedOrders.push(o)} // && !allInvoiced
              /* ODOTTAA ERÄÄ */
              else if (this.orderResponsibility === "awaitingBatch" && o.orderStatuses.includes("awaitingBatch")) {selectedOrders.push(o)} // && !allInvoiced
              /* KESKENERÄISET HYLLY */
              else if (this.orderResponsibility === "incompleteShelf" && o.orderStatuses.includes("incompleteShelf")) {selectedOrders.push(o)} // && !allInvoiced

              /* TILAUS MYÖHEMMIN / KESKENERÄISET */
              else if (this.orderResponsibility === "orderLaterIncompleteShelf" && o.orderStatuses.includes("orderLaterIncompleteShelf")) {selectedOrders.push(o)} // && !allInvoiced
              
              /* TUOTTEET LÄHETETTY ASIAKKAALLE */
              else if ( (this.orderResponsibility === "productsShipped" && (o.orderAndInvoiceStatuses.includes("productsShipped_invoice") || o.orderAndInvoiceStatuses.includes("productsShipped_doNotInvoice")) ) ) {
                selectedOrders.push(o)
              } 

              /* SAA LASKUTTAA */
              else if (this.orderResponsibility === "invoice" && o.invoiceStatuses.includes("invoice")) { selectedOrders.push(o) } 

              else if (this.orderResponsibility === "cancelled" && o.orderStatuses.includes("cancelled") ) {selectedOrders.push(o)} // && o.orderStatuses.includes("productsShipped")
              
              else if (this.orderResponsibility === "toBeReturned" && o.sample && o.orderStatuses.includes("samplesShipped")) {selectedOrders.push(o)} // && o.orderStatuses.includes("productsShipped")
              else if (this.orderResponsibility === "returned" && o.sample && o.orderStatuses.includes("samplesReturned")) {selectedOrders.push(o)} // && o.orderStatuses.includes("productsShipped")
              
              /* LASKUTETTU <3kk */
              if (this.orderResponsibility === "invoicedAll" && o.invoiceStatuses !== undefined){
                //if (o.invoiceStatuses.includes("invoiced") && o.created_at.seconds > threeMonthsPriorInSeconds) {
                if(this.invoicesTimePeriod === 'threeMonths'){
                  if (allInvoiced && allInvoicedOrCancelled && o.created_at.seconds > threeMonthsPriorInSeconds) {  
                    selectedOrders.push(o)
                  }
                }
                else{
                  if (allInvoiced) {  selectedOrders.push(o)}
                }
              }
              /* LASKUTETU >3kk  => NOT USED ANYMORE*/
              else if (this.orderResponsibility === "invoicedGreaterThanThreeMonths" && o.invoiceStatuses !== undefined){
                //if (o.invoiceStatuses.includes("invoiced") && o.created_at.seconds <= threeMonthsPriorInSeconds) {
                if (allInvoiced && allInvoicedOrCancelled && o.created_at.seconds <= threeMonthsPriorInSeconds) {
                  selectedOrders.push(o)
                }
              }
            }
            //REKLAMAATIOT
            if (o.reclaimed){ //&& (o.sample === undefined || !o.sample)  && (o.reclaimed === undefined || !o.reclaimed) 
              // if ( (this.orderResponsibility === "productsShipped" && (o.orderAndInvoiceStatuses.includes("productsShipped_invoice") || o.orderAndInvoiceStatuses.includes("productsShipped_doNotInvoice")) ) ) {
              if ( (this.orderResponsibility === "productsShipped" && (o.orderAndInvoiceStatuses.includes("productsShipped_invoice") || o.orderAndInvoiceStatuses.includes("productsShipped_doNotInvoice")) ) ) {
                selectedOrders.push(o)
              }
              else if ( (this.orderResponsibility === "invoice" && (o.invoiceStatuses.includes("invoice")) ) ) {
                selectedOrders.push(o)
              }
              if (this.orderResponsibility === "invoicedAll" && o.invoiceStatuses !== undefined){
                //if (o.invoiceStatuses.includes("invoiced") && o.created_at.seconds > threeMonthsPriorInSeconds) {
                if(this.invoicesTimePeriod === 'threeMonths'){
                  if (allInvoiced && allInvoicedOrCancelled && o.created_at.seconds > threeMonthsPriorInSeconds) {  
                    selectedOrders.push(o)
                  }
                }
                else{
                  if (allInvoiced) {  selectedOrders.push(o)}
                }
              }

            }
          }
        }


        return selectedOrders//.slice(from,this.numberOfOrdersVisible)
      },
      getOrderResponsibles(){
        var orderResponsibles = this.settings.orderResponsibles
        return Object.keys(this.settings.orderResponsibles).reduce(function(result, key) {
          result.push({...orderResponsibles[key]});
          return result;
        }, []);
      },
      getOfficeStaff(){
        var staff = this.staff
        var officeStaff = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if (s.role.includes('office')) officeStaff.push({text:s.firstName, id:s.id})
          return s
        })
        return officeStaff
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        return salespersons
      },
    },
    methods: {
      setAllInvoicesPaidToFalse(){
        var num = 0
        var totalOrders = 0
        Object.keys(this.orders).forEach(oId => {
          var o = this.orders[oId]
          if(o.sample) return
          if(!o.netvisorId) return
          var created = new Date(o.created_at.seconds*1000)
          // new Date('2024-07-31')
          if(created > new Date(2024, 3, 31, 23, 59, 59)){
            if(o.invoicesAllPaid === undefined) totalOrders += 1
            if(o.invoicesAllPaid === undefined && num < 20) {
              //console.log(o)
              num+= 1
              this.$store.dispatch('order/set', {
                id:oId,
                invoicesAllPaid:false
              })
            }
          }
          
        })
        console.log('total: ' + totalOrders)
      },
      janiOrders(){
        var salesperson = 'GJ51vbQ1pLNNJMeKc4896QKdjVr1' // JANI
        var opIdsToUpdate = []
        var oIdsToUpdate = []

        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          var o = this.orders[op.orderId]
          var salespersonFromCompany = this.companies[o.companyId].salesperson
          var salespersonFromOp = op.salesperson
          var oId = op.orderId
          if(salespersonFromCompany === salesperson && salespersonFromOp !== salesperson && oId){
            opIdsToUpdate.push(opId)
            if(!oIdsToUpdate.includes(oId)) oIdsToUpdate.push(oId)
          }
        })

        console.log(opIdsToUpdate)
        console.log(oIdsToUpdate)
        
        // ORDERS
        oIdsToUpdate.forEach(oId => {
          this.$store.dispatch('order/set', {
            id:oId,
            salesperson
          })
        })
        // ORDERED PRODUCTS
        opIdsToUpdate.forEach(opId => {
          this.$store.dispatch('orderedProduct/set', {
            id:opId,
            salesperson
          })
        }) 

      },
      transferOrders(){
        var oIdsToUpdate = {}
        var cIdsToUpdate = {}
        var totalOIds = {}
        var opIdsToUpdate = {}
        var totalOpIds = {}
        var totalcIds = {}
        var num = 0
        var oNum = 0
        var cNum = 0
        
        var fromSalesperson = 'bWKOZFPQiyU04skj2CYYSTuo40A2' // HENNA
        var toSalesperson = 'WEKfjCcgRvcKWX4nnUqMwsFpeaP2' // KATRI

        Object.keys(this.companies).forEach(cId => {
          var c = this.companies[cId]
          if(c && c.salesperson && c.salesperson === fromSalesperson){
            if(cNum < 500) cIdsToUpdate[cId] = toSalesperson
            totalcIds[cId] = toSalesperson
            cNum++
          }
        })
        
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          if(op && op.orderId && op.salesperson && op.salesperson === fromSalesperson){
            if(num < 500) opIdsToUpdate[opId] = toSalesperson
            totalOpIds[opId] = toSalesperson
            num++
          }
        })

        Object.keys(this.orders).forEach(oId => {
          var o = this.orders[oId]
          if(o && o.salesperson && o.salesperson === fromSalesperson){
            if(oNum < 500) oIdsToUpdate[oId] = toSalesperson
            totalOIds[oId] = toSalesperson
            oNum++
          }
        })
        
        console.log(opIdsToUpdate)
        //console.log(oIdsToUpdate)
        console.log(cIdsToUpdate)
        
        console.log('Yrityks: ' + cNum)
        console.log('Tilauksia: ' + oNum)
        console.log('Tuoteilauksia: ' + num)
        
        
        Object.keys(cIdsToUpdate).forEach(cId => {
          var salesperson = cIdsToUpdate[cId]
          console.log(cId,salesperson)
          //if(cId === 'ZoLPzlf2Hakf9zd5V68X'){ // pjsshddlNccizPWJjGyS
            this.$store.dispatch('company/set', {
              id:cId,
              salesperson
            })
          //}
          
        })
        // ORDERS
        Object.keys(oIdsToUpdate).forEach(oId => {
          var salesperson = oIdsToUpdate[oId]
          //console.log(oId,salesperson)
          this.$store.dispatch('order/set', {
            id:oId,
            salesperson
          })
        })
        // ORDERED PRODUCTS
        Object.keys(opIdsToUpdate).forEach(opId => {
          var salesperson = opIdsToUpdate[opId]
          //console.log(opId,salesperson)
          this.$store.dispatch('orderedProduct/set', {
            id:opId,
            salesperson
          })
        })

      },
      
      // BEFORE RUNNING UNCOMMENT THE STATUSES WITHIN ORDER SUMMARY
      async addToGoogleContacts(){
        var contacts = {}
        var miko_contacts = {}
        var db = firebase.firestore();
        var t= this
        var googleContacts = {}
        const snapshot = await db.collection('googleContacts').get()
        for(var i = 0; i < snapshot.docs.length;i++){
          var doc = snapshot.docs[i]
          googleContacts[doc.id] = doc.data()
        }
        
        /* var contactsBySalesperson = {}
        for(var i = 0; i < snapshot.docs.length;i++){
          var doc = snapshot.docs[i]
          if(contactsBySalesperson[doc.id.split("__")[0]]) contactsBySalesperson[doc.id.split("__")[0]] += 1
          else contactsBySalesperson[doc.id.split("__")[0]] = 1
        }
        console.log(contactsBySalesperson) */
        
        // LOOP TRHOUGH CONTACTS
        Object.keys(this.contacts).forEach(contactId => {
          var c = this.contacts[contactId]
          if(!c.email || c.email.trim() === '') return
          if(c.email.includes('avecor')) return
          var email = c.email.trim()
          email = email.toLowerCase()
          
          var companyId = c.companyId
          //if(companyId !== 'RJBwwPtWNCC59Zm6aMyU') return // ONLY ONE TEST ACCOUNT
          var company = this.companies[companyId]
          if(!company) return
          var phone = c.phone ? c.phone : ''
          phone = phone.trim().replace(" ","").replace(" ","").replace("-","")
          
          var salespersonId = company.salesperson
          if(salespersonId === 'zPFY35K13WV7Ayo68l5umKdnXyH2') return // JARKKO POIS
          if(salespersonId === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2') return // MIKO POIS
          if(!this.staff[salespersonId]) return
          if(this.staff[salespersonId].isExit) return  // EXITIT POIS
          var salespersonFirstName = this.staff[salespersonId].firstName
          var salespersonEmail = this.staff[salespersonId].email

          var firstName = c.firstName ? c.firstName.trim().replace(" ","") : ''
          var lastName = c.lastName ? c.lastName.trim().replace(" ","") : ''
          if(!firstName && !lastName) return
          var contactName = firstName.trim()+'_'+lastName.trim()
          contactName = contactName.toLowerCase()
          var id = salespersonId+'__'+contactName
          
          if(contacts[id]) {
            contacts[id].pairs.push(companyId+'__'+contactId)
            return
          }
          if(googleContacts[id]) return
          var googleContact = googleContacts[id]
          var etag = googleContact && googleContact.etag ? googleContact.etag : ''
          var resourceName = googleContact && googleContact.resourceName ? googleContact.resourceName : ''
          
          contacts[id] = {
            id,
            contactId:contactId,
            companyId:companyId,
            pairs:[companyId+'__'+contactId],
            firstName,
            lastName,
            phone:phone,
            email:email,
            companyName:company ? company.companyName : '',
            deliveryAddress:company.deliveryAddress,
            deliveryPostalCode:company.deliveryPostalCode,
            deliveryCity:company.deliveryCity,
            deliveryCountry:company.deliveryCountry,
            comments:'',
            userUid:salespersonId,
            userEmail:salespersonEmail,
            salespersonUid:salespersonId,
            salespersonFirstName:salespersonFirstName,
            etag,
            resourceName,
            numberOfOrders:0,
            updateNeeded:etag ? true : false
          }
          // MIKOLLE MYÖS
          if(salespersonId !== 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2') {
            var miko_id = 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'+'__' + contactName  

            if(miko_contacts[miko_id]) {
              miko_contacts[miko_id].pairs.push(companyId+'__'+contactId)
              return
            }
            var googleContact = googleContacts[miko_id]
            var etag = googleContact && googleContact.etag ? googleContact.etag : ''
            var resourceName = googleContact && googleContact.resourceName ? googleContact.resourceName : ''
            
            miko_contacts[miko_id] = {
              id:miko_id,
              contactId:contactId,
              companyId:companyId,
              pairs:[companyId+'__'+contactId],
              firstName,
              lastName,
              phone:phone,
              email:email,
              companyName:company ? company.companyName : '',
              deliveryAddress:company.deliveryAddress,
              deliveryPostalCode:company.deliveryPostalCode,
              deliveryCity:company.deliveryCity,
              deliveryCountry:company.deliveryCountry,
              comments:'',
              userUid:'y9ZVH4HpzFWuS9TzONQUJadQZ4T2',
              userEmail:'miko.kahlos@avecor.fi',
              salespersonUid:salespersonId,
              salespersonFirstName:salespersonFirstName,
              etag,
              resourceName,
              numberOfOrders:0,
              updateNeeded:etag ? true : false
            }
          }
        })
        // ADD ORDER DATA
        for (const oId of Object.keys(this.ordersData)) {
          var o = this.ordersData[oId]
          var c = this.contacts[o.contactId]
          var firstName = c.firstName ? c.firstName.trim().replace(" ","") : ''
          var lastName = c.lastName ? c.lastName.trim().replace(" ","") : ''
          if(!firstName && !lastName) continue
          var contactName = firstName.trim()+'_'+lastName.trim()
          contactName = contactName.toLowerCase()
          var summary = o.orderSummary
          var email = o.contactEmail
          var id = o.salespersonId+'__'+contactName
          //if(o.salespersonId === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2') console.log({email,summary,key})
          if(email && summary && contacts[id]){
            contacts[id].numberOfOrders += 1
            var orderDate = this.customFormatter(o.created_at)
            if(contacts[id].comments) contacts[id].comments += '\n' + 'TILAUS ' +orderDate + '\n' + summary
            else contacts[id].comments = 'TILAUS '+orderDate + '\n' + summary

            var miko_id = 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'+'__'+contactName
            if(miko_contacts[miko_id]){
              miko_contacts[miko_id].numberOfOrders += 1
              if(miko_contacts[miko_id].comments) miko_contacts[miko_id].comments += '\n' + 'TILAUS ' +orderDate + '\n' + summary
              else miko_contacts[miko_id].comments = 'TILAUS '+orderDate + '\n' + summary
            }
          }

        }
        // FILTER OUT THE CONTACTS WANTED
        var numberOfContacts = 400
        var contactsAdded = 0
        var contactsToAdd = {}
        console.log('Contacts left to sync: ' +Object.keys(contacts).length)
        Object.keys(contacts).forEach(id => {
          if(contacts[id].numberOfOrders > 0){
            if(contactsAdded >= numberOfContacts) return 
            //if(contacts[id].userUid !== 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2') return
            //if(contacts[id].userUid !== 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2') return
            //if(contacts[id].userUid !== 'GTNKFjWUHNhcAJVbORirRPNvCnv1') return
            contactsAdded += 1
            contactsToAdd[id] = contacts[id]
            //console.log(id)
            var miko_id = 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2'+'__'+id.split("__")[1]
            contactsAdded += 1
            contactsToAdd[miko_id] = miko_contacts[miko_id]
          }
        })
        
        console.log(contactsToAdd)

        // ADD TO FIREVASE
        if(Object.keys(contactsToAdd).length > 0){
          var t = this
          var batch = db.batch();
          Object.keys(contactsToAdd).forEach(key => {
            //console.log(contactsToAdd[key])
            var googleContactsRef = db.collection('googleContacts').doc(key)
            batch.set(googleContactsRef, { 
              id:key,
              ...contactsToAdd[key]
            }, { merge: true })
          })
          batch.commit().then(() => {
            t.$store.dispatch('showSnack', { snack:true, snackTimeout:800, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          });
        }
      },

      deleteActivityFromLog(oId,aId){
        if(this.orders[oId]){
          if (confirm('Haluatko varmasti poistaa logitiedon?')) {
            var activityLog = JSON.parse(JSON.stringify(this.orders[oId].activityLog))
            activityLog = activityLog.filter(a => a.id !== aId)
            console.log(activityLog)
            this.$store.dispatch('order/set', {
              id:oId,
              activityLog
            }) 
          }
        }
      },
      orderHasExtraLogs(activityLog){
        var hasExtraLogs = false
        var processedOpIds = []
        activityLog.filter(h => {
          if(h.type === 'op_status_update'){
            processedOpIds.push(h.opId)
            if(processedOpIds.includes(h.opId)) hasExtraLogs = true
          }
        })
        var newLog = activityLog.filter(h => {
          return h.type == 'email_sent'
        })
        if(newLog.length > 3) hasExtraLogs = true
        return hasExtraLogs
      },
      getLatestOpStatusesFromActivityLogo(orderId,viaSearch) {
        var latestStatuses = []
        var processedOpIds = []
        var activityLog = []
        if(!viaSearch && this.orders[orderId] && this.orders[orderId].activityLog) activityLog = this.orders[orderId].activityLog
        else if (this.searchOrders[orderId] && this.searchOrders[orderId].activityLog) activityLog = this.searchOrders[orderId].activityLog
        activityLog.filter(h => {
          if(h.type === 'op_status_update'){
            if(this.ordersShowAllLogs.includes(orderId)) latestStatuses.push(h)
            else{
              if(!processedOpIds.includes(h.opId)) latestStatuses.push(h)
              processedOpIds.push(h.opId)
            }
          }
        })
        return latestStatuses
      },
      getLatestOrderEmailsFromActivityLogo(orderId,activityLog) {
        var newLog = activityLog.filter(h => {
          return h.type == 'email_sent'
        })
        if(this.ordersShowAllLogs.includes(orderId)) return newLog
        else return newLog.slice(0, 3)
      },
      deselectAllOrders(){
        this.batchUpdateItems = {};
        this.allStatusOrdersSelected = false
      },
      selectAllOrdersInStatus(){
         this.getOrders.forEach(o => !o.viaSearch ? this.batchUpdateItems[o.id] = true : '');
         this.allStatusOrdersSelected = true
      },
      
      setDeliveryWeekOrder(orderId){
        this.deliveryWeekEdit = {[orderId]: true}
      },
      changeResp(status){
        this.orderResponsibility = status
        console.log(this.orderResponsibility)
        console.log(status)
      },
      getSortedBatches(batches){
        var arrivingBatches = []
        var arrivedBatches = []
        
        Object.keys(batches).forEach(batchId => {
          if(this.showAllBatches) batches[batchId].status === "batchOrdered" || batches[batchId].status === "batchPartiallyShelfed" ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
          //else batches[batchId].status === "batchOrdered" && this.getOrderableInBatch(batches[batchId]) > 0 ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
          else batches[batchId].status === "batchOrdered" && this.getStockInBatch(batches[batchId]) > 0 ? arrivingBatches.push({id:batchId,...batches[batchId]}) : ''
        })
        
        Object.keys(batches).forEach(batchId => {
          if(this.showAllBatches) (batches[batchId].status === "batchArrivedToWarehouse" || batches[batchId].status === "batchShelfed") ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          //else batches[batchId].status === "batchArrivedToWarehouse" && this.getOrderableInBatch(batches[batchId]) > 0 ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          else {
            (batches[batchId].status === "batchArrivedToWarehouse" || batches[batchId].status === "batchShelfed") && this.getStockInBatch(batches[batchId]) > 0 ? arrivedBatches.push({id:batchId,...batches[batchId]}) : ''
          }
        })
        //console.log(arrivedBatches)
        
        arrivedBatches.sort(function(a,b){
          return new Date(a.arrivalDate) - new Date(b.arrivalDate)
        });
        //console.log(arrivedBatches)
        arrivingBatches.sort(function(a,b){
          return new Date(a.estimatedArrivalDate) - new Date(b.estimatedArrivalDate)
        });
        var unallocatedExists = false
        var batchesReturned = [...arrivedBatches, ...arrivingBatches]
        return batchesReturned
      },
      batchUpdateOrder(action){
        try {
          var m = ''
          var newStatusUser = this.user.uid
          if(action === 'clearSelections'){
            //console.log("CLEAR")
            this.batchUpdateItems = {}
            this.allStatusOrdersSelected = false
          }
          else if(action === 'pendingOn'){
            console.log("PENDING ON")
            m = 'Haluatko varmasti asettaa \"odottava\"" tilan tilauksiin?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(!id) return
                if(this.ordersData[id].pending){}
                else{
                  var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                  this.$store.dispatch('order/set', {
                    id:id,
                    pending:true,
                  }) 
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'pendingOff'){
            console.log("PENDING OFF")
            m = 'Haluatko varmasti poistaa \"odottava\" tilan tilauksilta?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(!id) return
                if(!this.ordersData[id].pending){}
                else{
                  var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                  this.$store.dispatch('order/set', {
                    id:id,
                    pending:false,
                  }) 
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'archive'){
            m = 'Haluatko varmasti arkistoida tilaukset?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(this.ordersData[id] && this.ordersData[id].orderedProducts && Object.keys(this.ordersData[id].orderedProducts).length > 0){
                  Object.keys(this.ordersData[id].orderedProducts).forEach(opId => {
                    if(this.ordersData[id].orderedProducts[opId].archived){}
                    else{
                      var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        archived:true,
                      }) 
                    }
                  })
                  this.$store.dispatch('order/set', {
                    id:id,
                    pending:false
                  }) 
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'shippedAndInvoiced'){
            m = 'Haluatko varmasti asettaa tilausten tuotteet lähetetty ja laskutettu tilaan?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(this.ordersData[id] && this.ordersData[id].orderedProducts && Object.keys(this.ordersData[id].orderedProducts).length > 0){
                  Object.keys(this.ordersData[id].orderedProducts).forEach(opId => {
                    //Object.keys(this.ordersData[id].orderedProducts[opId])
                    //console.log(this.ordersData[id].orderedProducts[opId])
                    var isShipped = false
                    var isInvoiced = false
                    if(this.ordersData[id].orderedProducts[opId].deliveryStatus && this.ordersData[id].orderedProducts[opId].deliveryStatus === 'productsShipped'){
                      isShipped = true
                    }
                    if(this.ordersData[id].orderedProducts[opId].invoiceStatus && this.ordersData[id].orderedProducts[opId].invoiceStatus === 'invoiced'){
                      isInvoiced = true
                    }

                    if(isShipped && isInvoiced){}
                    else if(isShipped && !isInvoiced){
                      var newInvoiceDate = firebase.firestore.Timestamp.fromDate(new Date());
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        whenToInvoice:newInvoiceDate,
                        whenToInvoiceUser:newStatusUser,
                        orderInvoiceStatus:'invoiced',
                      })

                    }
                    else if(!isShipped && isInvoiced){
                      // PÄIVITÄ SALDOT
                      var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        orderStatus:'productsShipped',
                        shippedUser:newStatusUser,
                        shippedDate:newShippedDate,
                      }) 
                    }
                    else { // NOT SHIPPED OR INVOICED
                      // PÄIVITÄ SALDOT
                      var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                      var newInvoiceDate = firebase.firestore.Timestamp.fromDate(new Date());
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        orderStatus:'productsShipped',
                        shippedUser:newStatusUser,
                        shippedDate:newShippedDate,
                        whenToInvoice:newInvoiceDate,
                        whenToInvoiceUser:newStatusUser,
                        orderInvoiceStatus:'invoiced',
                      })
                    }
                    if(!isShipped){
                      var op = this.orderedProducts[opId]
                      var pv = this.productVariations[op.productVariationId]
                      console.log("MOVED TO PRODUCT SHIPPED")
                      var newStockAmount = 0
                      if(pv.warehoused){ 
                        if(op.print && pv.subtractAlsoPrintShopStock) {
                          console.log(pv)
                          var printShopStock = pv.printShopStock === undefined ? 0 : pv.printShopStock
                          var newPrintShopStockAmount = Number(printShopStock) - Number(op.printQuantity)
                          var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
                          var newStockAmount = Number(avecorStock) - Number(op.quantity)
                          console.log(op.productVariationId,newPrintShopStockAmount,newStockAmount)
                          this.store.dispatch('productVariation/set', {
                            id:op.productVariationId,
                            printShopStock:newPrintShopStockAmount,
                            avecorStock:newStockAmount,
                          })
                        }
                        else {
                          console.log(pv)
                          var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
                          var newStockAmount = Number(avecorStock) - Number(op.quantity)
                          this.$store.dispatch('productVariation/set', {
                            id:op.productVariationId,
                            avecorStock:newStockAmount,
                          })
                          console.log(op.productVariationId,newStockAmount)
                        }
                      }
                    }
                  })
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'shipped'){
            m = 'Haluatko varmasti asettaa tilausten tuotteet lähetetty tilaan?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(this.ordersData[id] && this.ordersData[id].orderedProducts && Object.keys(this.ordersData[id].orderedProducts).length > 0){
                  Object.keys(this.ordersData[id].orderedProducts).forEach(opId => {
                    //Object.keys(this.ordersData[id].orderedProducts[opId])
                    //console.log(this.ordersData[id].orderedProducts[opId])
                    if(this.ordersData[id].orderedProducts[opId].deliveryStatus && this.ordersData[id].orderedProducts[opId].deliveryStatus === 'productsShipped'){}
                    else{
                      var newShippedDate = firebase.firestore.Timestamp.fromDate(new Date());
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        orderStatus:'productsShipped',
                        shippedUser:newStatusUser,
                        shippedDate:newShippedDate,
                        orderInvoiceStatus:'invoice'
                      })
                    
                      var op = this.orderedProducts[opId]
                      var pv = this.productVariations[op.productVariationId]
                      console.log("MOVED TO PRODUCT SHIPPED")
                      var newStockAmount = 0
                      if(pv.warehoused){ 
                        if(op.print && pv.subtractAlsoPrintShopStock) {
                          console.log(pv)
                          var printShopStock = pv.printShopStock === undefined ? 0 : pv.printShopStock
                          var newPrintShopStockAmount = Number(printShopStock) - Number(op.printQuantity)
                          var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
                          var newStockAmount = Number(avecorStock) - Number(op.quantity)
                          console.log(op.productVariationId,newPrintShopStockAmount,newStockAmount)
                          this.store.dispatch('productVariation/set', {
                            id:op.productVariationId,
                            printShopStock:newPrintShopStockAmount,
                            avecorStock:newStockAmount,
                          })
                        }
                        else {
                          console.log(pv)
                          var avecorStock = pv.avecorStock === undefined ? 0 : pv.avecorStock
                          var newStockAmount = Number(avecorStock) - Number(op.quantity)
                          this.$store.dispatch('productVariation/set', {
                            id:op.productVariationId,
                            avecorStock:newStockAmount,
                          })
                          console.log(op.productVariationId,newStockAmount)
                        }
                      }
                    }
                  })
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'invoiced'){
            m = 'Haluatko varmasti asettaa tilausten tuotteet laskutettu tilaan?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(this.ordersData[id] && this.ordersData[id].orderedProducts && Object.keys(this.ordersData[id].orderedProducts).length > 0){
                  Object.keys(this.ordersData[id].orderedProducts).forEach(opId => {
                    //Object.keys(this.ordersData[id].orderedProducts[opId])
                    var newInvoiceDate = firebase.firestore.Timestamp.fromDate(new Date());
                    if(this.ordersData[id].orderedProducts[opId].invoiceStatus && this.ordersData[id].orderedProducts[opId].invoiceStatus === 'invoiced'){}
                    else{
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        whenToInvoice:newInvoiceDate,
                        whenToInvoiceUser:newStatusUser,
                        orderInvoiceStatus:'invoiced',
                      }) 
                    }
                  })
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
          else if(action === 'cancelled'){
            m = 'Haluatko varmasti asettaa tilausten tuotteet peruttu tilaan?'
            if (confirm(m)) {
              Object.keys(this.batchUpdateItems).forEach(id => {
                if(this.ordersData[id] && this.ordersData[id].orderedProducts && Object.keys(this.ordersData[id].orderedProducts).length > 0){
                  var newCancelledDate = firebase.firestore.Timestamp.fromDate(new Date());
                  Object.keys(this.ordersData[id].orderedProducts).forEach(opId => {
                    //Object.keys(this.ordersData[id].orderedProducts[opId])
                    var newInvoiceDate = firebase.firestore.Timestamp.fromDate(new Date());
                    if(this.ordersData[id].orderedProducts[opId].invoiceStatus && this.ordersData[id].orderedProducts[opId].invoiceStatus === 'invoiced'){}
                    else{
                      this.$store.dispatch('orderedProduct/set', {
                        id:opId,
                        orderStatus:'cancelled',
                        cancelledUser:newStatusUser,
                        cancelledDate:newCancelledDate,
                      }) 
                    }
                  })
                }
              })
              this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
          }
        }
        catch(e){
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:e.message, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      },
      updateBatchSelectionForItem(id){
        var batchUpdateItems = JSON.parse(JSON.stringify(this.batchUpdateItems))
        if(batchUpdateItems[id]) delete batchUpdateItems[id]
        else batchUpdateItems[id] = true
        this.batchUpdateItems = batchUpdateItems
      },
      printPDF (url) {
        var iframe = this.printIframe;
        if (!this.printIframe) {
          iframe = this.printIframe = document.createElement('iframe');
          document.body.appendChild(iframe);

          iframe.style.display = 'none';
          iframe.onload = function() {
            setTimeout(function() {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        iframe.src = url;
      },
      
      toggleArchive(item) {
        let {areAllArchived, ...y} = item;
        var m = ''
        if(areAllArchived) {m = 'Haluatko varmasti poistaa arkistointi tilan?'}
        else {m = 'Haluatko varmasti arkistoida tilauksen?'}
        if (confirm(m)) {
          Object.keys(item.orderedProducts).forEach(opId => {
            //console.log({areAllArchived:item.areAllArchived,isAtLeastOneArchived:item.isAtLeastOneArchived})
            //console.log(opId)
            if(item.areAllArchived) this.$store.dispatch('orderedProduct/set', {id:opId, archived:false})
            else this.$store.dispatch('orderedProduct/set', {id:opId, archived:true})
          })
          console.log(item.id)
          if(item.id && !item.areAllArchived){
            this.$store.dispatch('order/set', {
              id:item.id,
              pending:false
            })
          }
          /*  */
        }
      },
      togglePending(item){
        let {pending, ...y} = item;
        var m = ''
        if(pending) {m = 'Haluatko varmasti poistaa odottaa tietoa tilan?'}
        else {m = 'Haluatko varmasti laittaa tilauksen tilaan odottaa tietoa?'}
        if (confirm(m)) {
          pending = item.pending !== undefined ? item.pending : false
          pending = !pending
          this.$store.dispatch('order/set', {id:item.id,pending}).then(
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          )
        }
        
      },
      toggleSample(item){
        let {sample, ...y} = item;
        var m = ''
        if(sample) {m = 'Haluatko varmasti poistaa sovituspaketit asiakkaalle tilan?'}
        else {m = 'Haluatko varmasti asetttaa tilauksen tilaan sovituspaketit asiakkaalle?'}
        if (confirm(m)) {
          sample = item.sample !== undefined ? item.sample : false
          sample = !sample
          this.$store.dispatch('order/set', {id:item.id,sample})
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      toggleSalespersonSample(item){
        let {salespersonSample, ...y} = item;
        var m = ''
        if(salespersonSample) {m = 'Haluatko varmasti poistaa myyjien mallitilaukset tilan?'}
        else {m = 'Haluatko varmasti asetttaa tilauksen tilaan myyjien mallitilaukset?'}
        if (confirm(m)) {
          salespersonSample = item.salespersonSample !== undefined ? item.salespersonSample : false
          salespersonSample = !salespersonSample
          this.$store.dispatch('order/set', {id:item.id,salespersonSample})
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      toggleReclaimed(item){
        let {reclaimed, ...y} = item;
        var m = ''
        if(reclaimed) {m = 'Haluatko varmasti poistaa tilauksen tilasta reklamaatiot/selvitettävät?'}
        else {m = 'Haluatko varmasti asetttaa tilauksen tilaan reklamaatiot/selvitettävät?'}
        if (confirm(m)) {
          reclaimed = item.reclaimed !== undefined ? item.reclaimed : false
          reclaimed = !reclaimed
          this.$store.dispatch('order/set', {id:item.id,reclaimed})
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
      },
      toggleDeadline(item){
        let {deadline, ...y} = item;
        deadline = item.deadline !== undefined ? item.deadline : false
        deadline = !deadline
        this.$store.dispatch('order/set', {id:item.id,deadline})
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      toggleAvecorOrder(item){
        var avecorOrder = item.avecorOrder !== undefined ? item.avecorOrder : false
        avecorOrder = !avecorOrder
        this.$store.dispatch('order/set', {id:item.id,avecorOrder})
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      sendEmailToSelected(recipient,typeOfSend){
        var sends = []
        console.log("HERE")
        Object.keys(this.batchUpdateItems).forEach(orderId => {
          var contactId = this.orders[orderId].contactId
          var companyId = this.orders[orderId].companyId
          var netvisorId = this.orders[orderId].netvisorId
          var companyName = this.companies[companyId].companyName
          var opIds = Object.keys(this.ordersData[orderId].orderedProducts)

          // DRAFT REMINDER WHOLESALE
          if(typeOfSend === 'draft_reminder_wholesale'){
            opIds.forEach(opId => {
              var op = this.orderedProducts[opId]
              var printFormats = op.printFormats
              var p = this.products[op.productId]
              var pv = this.productVariations[op.productVariationId]
              var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
              if(op.print && op.orderStatus === 'draftOrdered'){
                var p = this.products[op.productId]
                var contactFound = false
                var partnerName = ""
                var partnerType = ""
                var toEmail = ""
                var printFormat = ""
                var contactNotFoundMessage = ""
                
                if(p.printShops && p.printShops.length > 0){
                  for(var i = 0; i < p.printShops.length; i++){
                    var psId = p.printShops[i]
                    if(psId === 'PnveNKH73jpkdLkYXEIa'){ // TUKKURIN OMA
                      if(p.wholesaleCompany && this.wholesaleCompanies[p.wholesaleCompany]){
                        var wc = this.wholesaleCompanies[p.wholesaleCompany]
                        var contact = this.getWholesaleContact(wc)
                        contactFound = contact.contactFound
                        toEmail = contact.toEmail
                        partnerType = "Tukkuri"
                        partnerName = wc.name
                        if(!contactFound) contactNotFoundMessage = "Tukkurille ei ole määritelty tilaussähköpostia tai tilauskontaktihenkilöä."
                        break;
                      }
                    }
                    else{ //
                      var ps = this.printShops[psId]
                      var contact = this.getPrintShopContact(op,ps,p)
                      toEmail = contact.toEmail
                      partnerType = "Merkkaamo"
                      partnerName = ps.name
                      contactFound = contact.contactFound
                      contactNotFoundMessage = contact.contactNotFoundMessage
                      if(contactFound) break;
                    }
                  }
                }
                else {contactNotFoundMessage = "Tuotteelle ei ole määritelty merkkaamoja.";}

                var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,['draftOrdered'])
                var existingSendToSameEmailFound = false
                var id = Math.random().toString(36).substr(2, 9);
                sends = sends.map(s => {
                  if(s.toEmail === toEmail && s.orderId === orderId){
                    existingSendToSameEmailFound = true
                    return {...s,opFilter:[...s.opFilter,{opId,printFormat,productName}]}
                  }
                  else return s
                })
                if(!existingSendToSameEmailFound) sends.push({id,contactFound,...lastSendDetails,contactNotFoundMessage,orderId,netvisorId,companyId,contactId,opIds,opFilter:[{opId,printFormat,productName}],recipient,typeOfSend,companyName,toEmail,partnerName,partnerType,customer:false})
                
              }
              else return
            })
          }
          // LOGO REMINDER (CUSTOMER)
          else if (typeOfSend === 'logo_reminder'){
            var id = Math.random().toString(36).substr(2, 9);
            var statuses = ['logoRequested','logoReminderSent']
                        
            var printDetails = this.getCustomerEmailForPrints(orderId)
            if(orderId === "fQSdbIxtoPaVSs3vM7DS") console.log(printDetails)
            var toEmail = printDetails.toEmail
            var contactFound = printDetails.contactFound
            var contactNotFoundMessage = printDetails.contactNotFoundMessage

            var productFound = false
            var opFilter = []
            opIds.forEach(opId => {
              var op = this.orderedProducts[opId]
              if(statuses.includes(op.orderStatus)){
                var p = this.products[op.productId]
                var pv = this.productVariations[op.productVariationId]
                var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
                opFilter.push({opId,printFormat:'',productName})
                productFound = true
              }
            })
            var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend,'material_request'],recipient,statuses)
            if(productFound) sends.push({id,contactFound,contactNotFoundMessage,...lastSendDetails,orderId,netvisorId,companyId,contactId,opIds,opFilter,recipient,typeOfSend,companyName,toEmail,customer:true})
          }
          // DRAFT REMINDER CUSTOMER
          else if (typeOfSend === 'draft_reminder_customer'){ // CUSTOMER
            var id = Math.random().toString(36).substr(2, 9);
            var statuses = ['draftSentToCustomer','draftReminder1']
            
            var printDetails = this.getCustomerEmailForPrints(orderId)
            var toEmail = printDetails.toEmail
            var contactFound = printDetails.contactFound
            var contactNotFoundMessage = printDetails.contactNotFoundMessage
            
            var productFound = false
            var opFilter = []
            opIds.forEach(opId => {
              var op = this.orderedProducts[opId]
              if(statuses.includes(op.orderStatus)){
                var p = this.products[op.productId]
                var pv = this.productVariations[op.productVariationId]
                var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
                opFilter.push({opId,printFormat:'',productName})
                productFound = true
              }
            })
            var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,statuses)
            if(productFound) sends.push({id,contactFound,contactNotFoundMessage,...lastSendDetails,orderId,netvisorId,companyId,contactId,opIds,opFilter,recipient,typeOfSend,companyName,toEmail,customer:true})
          }
          // SALES ASKED TO CONCACT FOR LOGO
          else if(typeOfSend === 'sales_asked_to_contact_for_logo'){ // SALES
            var id = Math.random().toString(36).substr(2, 9);
            var statuses = ['logoReminderSent','salesRequestedToContactForLogo']
            var toEmail = ''
            var contactFound = false
            var productFound = false
            var contactNotFoundMessage = ''
            if(this.staff[this.orders[orderId].salesperson] && this.staff[this.orders[orderId].salesperson].email) {
              var s = this.staff[this.orders[orderId].salesperson]
              var toEmail = s.email
              contactFound = true
            }
            else contactNotFoundMessage = "Myyjän sähköpostia ei ole määritelty."
            var opFilter = []
            opIds.forEach(opId => {
              var op = this.orderedProducts[opId]
              if(statuses.includes(op.orderStatus)){
                var p = this.products[op.productId]
                var pv = this.productVariations[op.productVariationId]
                var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
                opFilter.push({opId,printFormat:'',productName})
                productFound = true
              }
            })
            var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,statuses)
            if(productFound) sends.push({id,contactFound,contactNotFoundMessage,...lastSendDetails,orderId,netvisorId,companyId,contactId,opIds,opFilter,recipient,typeOfSend,companyName,toEmail,customer:false})
          }
          // SALES ASKED TO CONTACT FOR DRAFT
          else if(typeOfSend === 'sales_asked_to_contact_for_draft'){ // SALES
            var id = Math.random().toString(36).substr(2, 9);
            var statuses = ['draftReminder1','salesRequestedToContactForDraft']
            var toEmail = ''
            var contactFound = false
            var productFound = false
            var contactNotFoundMessage = ''
            if(this.staff[this.orders[orderId].salesperson] && this.staff[this.orders[orderId].salesperson].email) {
              var s = this.staff[this.orders[orderId].salesperson]
              var toEmail = s.email
              contactFound = true
            }
            else contactNotFoundMessage = "Myyjän sähköpostia ei ole määritelty."
            var opFilter = []
            opIds.forEach(opId => {
              var op = this.orderedProducts[opId]
              if(statuses.includes(op.orderStatus)){
                var p = this.products[op.productId]
                var pv = this.productVariations[op.productVariationId]
                var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
                opFilter.push({opId,printFormat:'',productName})
                productFound = true
              }
            })            
            var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,statuses)
            if(productFound) sends.push({id,contactFound,contactNotFoundMessage,...lastSendDetails,orderId,netvisorId,companyId,contactId,opIds,opFilter,recipient,typeOfSend,companyName,toEmail,customer:false})
          }
          // ORDER CREATED REMINDER
          else if(typeOfSend === 'order_created_reminder_wholesale'){ // WHOLESALE
            var statuses = ['orderCreated','orderCreatedReminder']

            opIds.forEach(opId => {
              var id = Math.random().toString(36).substr(2, 9);
              var op = this.orderedProducts[opId]
              var p = this.products[op.productId]
              var pv = this.productVariations[op.productVariationId]
              var productName = p.name.fi + ' - ' + this.createVariationName(pv,true)
              if(op.print && statuses.includes(op.orderStatus)){ //  op.orderStatus === 'orderCreated'
                var p = this.products[op.productId]
                var contactFound = false
                var partnerName = ""
                var partnerType = ""
                var toEmail = ""
                var printFormat = ""
                var contactNotFoundMessage = ""
                
                if(p.printShops && p.printShops.length > 0){
                  for(var i = 0; i< p.printShops.length; i++){
                    var psId = p.printShops[i]  
                    if(psId === 'PnveNKH73jpkdLkYXEIa'){ // TUKKURIN OMA
                      if(p.wholesaleCompany && this.wholesaleCompanies[p.wholesaleCompany]){
                        var wc = this.wholesaleCompanies[p.wholesaleCompany]
                        var contact = this.getWholesaleContact(wc)
                        contactFound = contact.contactFound
                        toEmail = contact.toEmail
                        partnerType = "Tukkuri"
                        partnerName = wc.name
                        if(!contactFound) contactNotFoundMessage = "Tukkurille ei ole määritelty tilaussähköpostia tai tilauskontaktihenkilöä."
                        break;
                      }
                    }
                    else{ //
                      var ps = this.printShops[psId]
                      var contact = this.getPrintShopContact(op,ps,p)
                      toEmail = contact.toEmail
                      partnerType = "Merkkaamo"
                      partnerName = ps.name
                      contactFound = contact.contactFound
                      contactNotFoundMessage = contact.contactNotFoundMessage
                      if(contactFound) break
                    }
                  }
                }
                else {contactNotFoundMessage = "Tuotteelle ei ole määritelty merkkaamoja.";}

                var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,['orderCreated'])
                var existingSendToSameEmailFound = false
                var id = Math.random().toString(36).substr(2, 9);
                sends = sends.map(s => {
                  if(s.toEmail === toEmail && s.orderId === orderId){
                    existingSendToSameEmailFound = true
                    return {...s,opFilter:[...s.opFilter,{opId,printFormat,productName}]}
                  }
                  else return s
                })
                
                if(!existingSendToSameEmailFound) sends.push({id,contactFound,...lastSendDetails,contactNotFoundMessage,orderId,netvisorId,companyId,contactId,opIds,opFilter:[{opId,printFormat,productName}],recipient,typeOfSend,companyName,toEmail,partnerName,partnerType,customer:false})
                
              }
              else if (!op.print && statuses.includes(op.orderStatus)) { //  op.orderStatus === 'orderCreated'
                if(p.wholesaleCompany && this.wholesaleCompanies[p.wholesaleCompany]){
                  var wc = this.wholesaleCompanies[p.wholesaleCompany]
                  var contact = this.getWholesaleContact(wc)
                  contactFound = contact.contactFound
                  toEmail = contact.toEmail ? contact.toEmail.trim() : ''
                  partnerType = "Tukkuri"
                  partnerName = wc.name
                  if(!contactFound) contactNotFoundMessage = "Tukkurille ei ole määritelty tilaussähköpostia tai tilauskontaktihenkilöä."
                }
                var existingSendToSameEmailFound = false
                sends = sends.map(s => {
                  if(s.toEmail === toEmail && s.orderId === orderId){
                    existingSendToSameEmailFound = true
                    return {...s,opFilter:[...s.opFilter,{opId,printFormat,productName}]}
                  }
                  else return s
                })
                var lastSendDetails = this.getLastSend(orderId,toEmail,[typeOfSend],recipient,['orderCreated'])
                if(!existingSendToSameEmailFound) sends.push({id,contactFound,...lastSendDetails,contactNotFoundMessage,orderId,netvisorId,companyId,contactId,opIds,opFilter:[{opId,printFormat,productName}],recipient,typeOfSend,companyName,toEmail,partnerName,partnerType,customer:false})
              }
            })
          }
        })
        
        this.typeOfSendBatchSend = typeOfSend
        this.batchSendDetails = sends
        this.sendProgressVisible = false
        this.sendProgressVisible = true
        //
      },
      getCustomerEmailForPrints(orderId){
        /* if(this.companies[this.orders[orderId].companyId] && this.companies[this.orders[orderId].companyId].clientPrintDetailsEmail && this.companies[this.orders[orderId].companyId].clientPrintDetailsEmail.trim() !== '' && this.isValidEmail(this.companies[this.orders[orderId].companyId].clientPrintDetailsEmail.trim())){
          var toEmail = this.companies[this.orders[orderId].companyId].clientPrintDetailsEmail.trim()
          return {contactFound:true, toEmail,contactNotFoundMessage:''}
        } */
        var order = this.orders[orderId]
        if(this.contacts[order.contactId].sendDraftsToSalesperson && this.staff[order.salesperson]) {
          var toEmail = this.staff[order.salesperson].email.trim()
          return {contactFound:true, toEmail, contactNotFoundMessage:''}
        }
        if (this.contacts[order.contactId] && this.contacts[order.contactId].clientPrintDetailsEmail && this.contacts[order.contactId].clientPrintDetailsEmail.trim() !== '' && this.isValidEmail(this.contacts[this.orders[orderId].contactId].clientPrintDetailsEmail.trim())){
          var toEmail = this.contacts[order.contactId].clientPrintDetailsEmail.trim()
          return {contactFound:true, toEmail:this.contacts[order.contactId].clientPrintDetailsEmail,contactNotFoundMessage:''}
        }
        else if(this.contacts[order.contactId] && this.contacts[order.contactId].email && this.contacts[order.contactId].email.trim() !== '' && this.isValidEmail(this.contacts[this.orders[orderId].contactId].email.trim())){
          var toEmail = this.contacts[order.contactId].email.trim()
          return {contactFound:true, toEmail,contactNotFoundMessage:''}
        }
        return {contactFound:false,toEmail:'',contactNotFoundMessage:'Asiakkaan sähköpostia ei ole määritelty tai se on virheellinen.'}
      },
      isValidEmail(value){
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value)
      },
      getPrintShopContact(op,ps,p){
        var toEmail = ''
        var contactFound = false
        var contactNotFoundMessage = ''
        var printFormat = ''
        if(p.printShops.length > 1){
          if(op.printFormats && op.printFormats.length > 0){

            op.printFormats.forEach(pf => {
              if(ps.printFormats.includes(pf)){
                printFormat = pf
                if(ps.orderEmail && ps.orderEmail.trim() !== '') {
                  toEmail = ps.orderEmail
                  contactFound = true
                }
                else{
                  contactNotFoundMessage = "Merkkaamon tilaussähköpostia ei ole määritelty.";
                }
                return
              }
            })
            if(!contactFound) {contactNotFoundMessage = "Tuotteelle valittu merkkaustavalla ei löytynyt vastaavaa merkkaamoa tuotetiedoista.";}
          }
          else if(op.printOptions && op.printOptions.length > 0){
            var po = op.printOptions[0]
            var ids = po.split('__')
            if(ids[0] === 'product'){
              var oId = ids[1]
              console.log("FETCHING PS INFO DATA FROM PRODUCT")
              p.prices.options.forEach(o => {
                if(o.id === oId) {
                  var psId = o.printShop
                  if(this.printShops[psId] && this.printShops[psId].orderEmail){
                    toEmail = ps.orderEmail
                    contactFound = true
                  }
                  else{
                    contactNotFoundMessage = "Merkkaamon tilaussähköpostia ei ole määritelty.";
                  }
                }
              })
            }
            else if(ids[0] === 'printShop'){
              var psId = ids[1]
              if(this.printShops[psId] && this.printShops[psId].orderEmail){
                toEmail = ps.orderEmail
                contactFound = true
              }
              else{
                contactNotFoundMessage = "Merkkaamon tilaussähköpostia ei ole määritelty.";
              }
            }
          }
          else {contactNotFoundMessage = "Tuotetilaukselle ei ole määritelty merkkaustapaa.";}
        }
        // IF ONLY ONE PRINT SHOP, THEN WE USE THE 
        else {
          if(ps.orderEmail && ps.orderEmail.trim() !== '') {
            toEmail = ps.orderEmail
            contactFound = true
          }
          else contactNotFoundMessage = "Merkkaamon tilaussähköpostia ei ole määritelty.";
          
        }
        return {contactFound,toEmail,printFormat,contactNotFoundMessage}
      },
      getWholesaleContact(wc){
        var toEmail = ''
        var contactFound = false
        if(wc.orderEmail && wc.orderEmail.trim() !== ''){
          toEmail = wc.orderEmail
          contactFound = true
        }
        else if(wc.partnerContacts) {
          Object.keys(wc.partnerContacts).forEach(cId => {
            var c = wc.partnerContacts[cId]
            if(c.contactType === 'ordersContact' && c.email && c.email.trim() !== '') {
              contactFound = true
              toEmail = c.email 
            }
          })
        }
        return {contactFound,toEmail}
      },
      getLastSend(orderId,toEmail,typesOfSend,recipient,statuses){
        var lastSend = ''
        var daysSinceLastSend = ""
        if(this.orders[orderId] && this.orders[orderId].activityLog){
          var activityLog = this.orders[orderId].activityLog
          for(var i = 0; i < activityLog.length; i++){
            var h = activityLog[i]
            if(h.type == "email_sent" && toEmail === h.toEmail && typesOfSend.includes(h.typeOfSend)) {
              lastSend = h.date;
              break;
            }
          }
          if(lastSend){
            var lastSendAsDate = ''
            try{
              if (lastSend.seconds) {lastSendAsDate = new Date(lastSend.seconds*1000);}
              else if (lastSend._seconds) {lastSendAsDate = new Date(lastSend._seconds*1000);}
              daysSinceLastSend = Math.round((new Date() - lastSendAsDate)/(1000 * 60 * 60 * 24))
              lastSend = this.customFormatter(lastSend)
            }
            catch(e){console.log(e)}
          }
        
          // SET LAST SEND DATE ON OP STATUS UPDATE - ONLY FOR PARTNERS AND CUSTOMERS BECAUSE OFFICE SENDS FIRST SENDS THEMSELVES
          if(!lastSend && recipient !== 'salesperson'){
            for(var i = 0; i < activityLog.length; i++){
              var h = activityLog[i]
              if(h.type == "op_status_update" && statuses.includes(h.newStatus)) {
                lastSend = h.date;
                break;
              }
            }
            if(lastSend){
              var lastSendAsDate = ''
              try{
                if (lastSend.seconds) {lastSendAsDate = new Date(lastSend.seconds*1000);}
                else if (lastSend._seconds) {lastSendAsDate = new Date(lastSend._seconds*1000);}
                daysSinceLastSend = Math.round((new Date() - lastSendAsDate)/(1000 * 60 * 60 * 24))
                lastSend = this.customFormatter(lastSend)
              }
              catch(e){console.log(e)}
            }
          }
        }
        return {lastSend,daysSinceLastSend}
      },
      sendEmail(orderId,recipient,typeOfSend){
        var self = this
        return new Promise(async function(resolve, reject) {
          try{
            var companyId = self.orders[orderId].companyId
            var contactId = self.orders[orderId].contactId
            var email = ''
            var toEmail = ''
            var fromEmail = ''
            var customer = false
            var s = self.staff[self.orders[orderId].salesperson]
            if(recipient === 'salesperson'){
              if(s) {
                toEmail = s.email
                fromEmail = s.email
              }
            }
            else if (recipient === 'user') {toEmail = self.user.email; fromEmail = self.user.email}
            else if (recipient === 'miko') {toEmail = "miko.kahlos@avecor.fi"; fromEmail = "miko.kahlos@avecor.fi"}
            else if (recipient === 'customer' && self.contacts[contactId] && self.contacts[contactId].email) {
              if (confirm('Haluatko varmasti lähettää asiakkaalle?')) {
                toEmail = self.contacts[contactId].email
                fromEmail = s.email
                customer = true
              }
              else return
            }
            if(typeOfSend === 'material_request'){
              fromEmail = "logo@avecor.fi"  
            }
            
            if(toEmail && fromEmail){
              self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Viestiä lähetetään osoitteeseen "+toEmail+".", snackButtonText: "OK", errorType:"", snackColor:'deep-blue'})
              var opIds = []
              Object.keys(self.orderedProducts).forEach(key => {
                var op = self.orderedProducts[key]
                if(op.orderId === orderId) opIds.push(key)
              })
              
              self.$store.dispatch('sendMessageServerSide', {
                toEmail:toEmail,
                fromEmail:fromEmail,
                customer,
                opIds,
                companyId,
                contactId,
                orderId,
                typeOfSend
              })
            }
            else {
              self.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Sähköpostia ei voitu määrittää.", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            }
          }
          catch (e){
            reject(e)
          }
        })
        
      },
      getButtonStyle(status){
        if(this.orderResponsibility === status && (this.orderResponsibility === 'allNotShipped' || this.orderResponsibility === 'samples' || this.orderResponsibility === 'pending' || this.orderResponsibility === 'toBeReturned' || this.orderResponsibility === 'returned'
           || this.orderResponsibility === 'invoicedAll' || this.orderResponsibility === 'invoicedGreaterThanThreeMonths')){
          return 'border-color:#000;border:2px solid #000 !important;font-weight:600;' 
        }
        
        /* if (this.orderResponsibility === 'paid')  return 'border-color:#000;border:2px solid #000 !important;font-weight:600; background:2ECC40'//99;'
        else  */
        if (this.orderResponsibility === status) {
          if(status === 'paid') return 'color:#000;border-color:#000;border:2px solid #000 !important;font-weight:600; background:'+this.settings.orderStatusColors[status]+';'
          
          else return 'border-color:#000;border:2px solid #000 !important;font-weight:600; background:'+this.settings.orderStatusColors[status]+'99;'
        } 
        else {
          if(status === 'paid') return 'color:#000;background:'+this.settings.orderStatusColors[status]
          else return 'background:'+this.settings.orderStatusColors[status]+'99'
        }
        
      },
      inlineSaveField(orderId,field,value,isInputField){
        if(isInputField) value = value.target.value
        if (field === "salespersonMargin") {
          value = value.replace(",", ".")
          if(this.orders[orderId].officeMargin){
            this.$store.dispatch('order/set', {
              id:orderId,
              salespersonMargin:value
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))  
          }
          else {
            this.$store.dispatch('order/set', {
              id:orderId,
              salespersonMargin:value,
              officeMargin:value
            })
            .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
          }
        }
        else {
          if (field === "officeMargin") value = value.replace(",", ".") 
          this.$store.dispatch('order/set', {
            id:orderId,
            [field]:value
          })
          .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
        }
      },
      async setLoadOnStartForOrder(order,loadOnStart){
        var ops = []
        Object.keys(order.orderedProducts).forEach(opId => {
          ops.push(opId)
        })
        
        
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Palautetaan tilausta historiasta...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
        try{
          var url = this.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/setOrderLoadOnStart': 'https://us-central1-avecor-709ff.cloudfunctions.net/setOrderLoadOnStart'
          let res = await axios.post(url,
            { orderId:order.id, ops, loadOnStart },
          );
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          //this.orderTableKey += 1 
        }
        catch(e){
          var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:4000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }
      
        /* var db = firebase.firestore();
        console.log({oId:order.id, ops:order.orderedProducts})
        Object.keys(order.orderedProducts).forEach(opId => {
          console.log(opId)
          db.collection('orderedProducts').doc(opId).set({ 
            loadOnStart
          }, { merge: true })
        })
        console.log(order.id)
        db.collection('orders').doc(order.id).set({ 
          loadOnStart
        }, { merge: true }) */
      },
      toggleHistoryReclaimed(item){
        let {reclaimed, ...y} = item;
        var db = firebase.firestore();
        var t = this
        var m = ''
        if(reclaimed) {m = 'Haluatko varmasti poistaa tilauksen tilasta reklamaatiot/selvitettävät?'}
        else {m = 'Haluatko varmasti asetttaa tilauksen tilaan reklamaatiot/selvitettävät?'}
        if (confirm(m)) {
          reclaimed = reclaimed !== undefined ? item.reclaimed : false
          reclaimed = !reclaimed
          db.collection('orders').doc(item.id).set({ 
            reclaimed
          }, { merge: true })
          .then(function() {
            t.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
          })
        }
      },
      inlineSaveHistoryField(orderId,field,value,isInputField){
        var db = firebase.firestore();
        var t = this
        db.collection('orders').doc(orderId).set({ 
          [field]:value
        }, { merge: true })
        .then(function() {
          t.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Tallennettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        })
      },
      updateCompaniesWithLatestOrderDate(){
        var latestOrders = {}
        for (const key of Object.keys(this.orders)) {
          var order = this.orders[key]
          if (order.companyId === undefined) {
            //console.log(order)
          }
          else {
            if(this.companies[order.companyId] === undefined) {console.log(order); continue }
            if(latestOrders[order.companyId] === undefined){
              latestOrders[order.companyId] = {latestOrderDate:this.customFormatter(order.created_at),orders:1}
              if(order.companyId==="0wCAHdczmYsKfbMwuC5O"){
                //console.log(latestOrders[order.companyId].latestOrderDate)
              }
            } 
            else {
              latestOrders[order.companyId].orders = latestOrders[order.companyId].orders + 1
              var a = this.customFormatter(latestOrders[order.companyId].latestOrderDate)
              var b = this.customFormatter(order.created_at)
              //if(order.companyId==="0wCAHdczmYsKfbMwuC5O"){
                //console.log(b)
                if(b>a){
                  latestOrders[order.companyId].latestOrderDate = b
                  //console.log({id:order.id,latestOrderDate:latestOrders[order.companyId].latestOrderDate,orders:latestOrders[order.companyId].orders,a,b})
                }
              //}
            }
          }
        }
        //console.log({latestOrderDate:latestOrders["0wCAHdczmYsKfbMwuC5O"].latestOrderDate,orders:latestOrders["0wCAHdczmYsKfbMwuC5O"].orders})
        console.log(latestOrders)
        var num = 0
        var t = this
        for (const key of Object.keys(latestOrders)) {
          //console.log(this.companies[key])
          var company = t.companies[key]
          if(company === undefined) {console.log(latestOrders[key]); continue }

          if (company.latestOrderDate === undefined || company.totalOrders === undefined) {
            var latestOrderDate = latestOrders[key].latestOrderDate
            var totalOrders = latestOrders[key].orders
            //console.log({latestOrderDate,totalOrders})
            if(num < 100){
              this.$store.dispatch('company/set', {
                id:key,
                totalOrders,
                latestOrderDate
              })
            }  
          }
          else {
            //console.log(company)
            continue
          }
          
          num = num + 1
        }
      },
      getOrderRowClasses(id){
        if(this.ordersData[id] === undefined) return ""
        var ops = this.ordersData[id].orderedProducts
        var classes = "avecor-order-row"
        if(this.batchUpdateItems[id]){
          classes += " avecor-selected-order-row"
        }
        else {
          Object.keys(ops).map(function(key, index) {
            var latestToCustomer = ops[key].latestToCustomer
            var latestToCustomerDate = null
            latestToCustomer !== undefined ? latestToCustomerDate = new Date(latestToCustomer) : ""
            var dateNow = new Date()
            var oneDay = 24*60*60*1000;
            if (latestToCustomerDate !== null){
              var diffDays = Math.round(Math.abs((dateNow.getTime() - latestToCustomerDate.getTime())/(oneDay)));
              if (diffDays > 14 && diffDays < 28) classes += " avecor-order-criticality-medium"
              else if (diffDays <= 14) {classes += " avecor-order-criticality-high"}
            }
          })
        }
        return classes
      },
      setSalespersonForOrderedProducts(){
        var opIdsToUpdate = {}
        var opIdsToUpdate2 = {}
        var totalOpIds = {}
        var num = 0
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          if(op && op.orderId && this.orders[op.orderId] && this.orders[op.orderId].salesperson && !op.salesperson){
            if(num < 500) opIdsToUpdate[opId] = this.orders[op.orderId].salesperson
            if(num >= 500 & num < 1000) opIdsToUpdate2[opId] = this.orders[op.orderId].salesperson
            totalOpIds[opId] = this.orders[op.orderId].salesperson
            num++
          }
        })
        
        console.log(opIdsToUpdate)
        console.log(opIdsToUpdate2)
        
        console.log(num)
        
        
        Object.keys(opIdsToUpdate).forEach(opId => {
          var salesperson = opIdsToUpdate[opId]
          //console.log(opId,salesperson)
          this.$store.dispatch('orderedProduct/set', {
            id:opId,
            salesperson
          })
        })

        setTimeout(() => {
          Object.keys(opIdsToUpdate2).forEach(opId => {
            var salesperson = opIdsToUpdate2[opId]
            //console.log(opId,salesperson)
            this.$store.dispatch('orderedProduct/set', {
              id:opId,
              salesperson
            })
          })
        },2000)
        
        //console.log(opIdsToUpdate)
      },
      setAdditionaDetailsOrderedProducts(){
        var opIdsToUpdate = {}
        var opIdsToUpdate2 = {}
        var totalOpIds = {}
        var num = 0
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = this.orderedProducts[opId]
          if(op && op.isWarehousedProduct === undefined){
            var isWarehousedProduct = this.productVariations[op.productVariationId] && this.productVariations[op.productVariationId].warehoused ? true : false
            if(num < 500) opIdsToUpdate[opId] = isWarehousedProduct
            if(num >= 500 & num < 1000) opIdsToUpdate2[opId] = isWarehousedProduct
            totalOpIds[opId] = isWarehousedProduct
            num++
          }
        })
        
        console.log(opIdsToUpdate)
        console.log(opIdsToUpdate2)
        console.log(num)
        
        Object.keys(opIdsToUpdate).forEach(opId => {
          var isWarehousedProduct = opIdsToUpdate[opId]
          //console.log(opId,salesperson)
          this.$store.dispatch('orderedProduct/set', {
            id:opId,
            isWarehousedProduct
          })
        })
        
        setTimeout(() => {
          Object.keys(opIdsToUpdate2).forEach(opId => {
            var isWarehousedProduct = opIdsToUpdate2[opId]
            //console.log(opId,salesperson)
            this.$store.dispatch('orderedProduct/set', {
              id:opId,
              isWarehousedProduct
            })
          })
        },2000)
      },
      async fetchExtraData(){
        
          if(this.searchOrders[this.selectedOrderOrderId]) this.selectedOrderOrderId = ""

          this.searchInProgress = true
          var search = this.ordersSearch.toLowerCase().trim()
          var split = null
          var searchType = null
          if(search.includes("ht:")) { searchType = 'products'; split = search.split("ht:") }
          if(search.includes("hy:")) { searchType = 'companies'; split = search.split("hy:") }
          if(search.includes("hn:")) { searchType = 'netvisorId'; split = search.split("hn:") }
          if(search.includes("hmid:")) { searchType = 'salespersonId'; split = search.split("hmid:") }

          

          if(split && split.length > 1 && searchType) {
            this.searchOrders = {}
            this.searchOrderedProducts = {}
            this.generateOrdersData()
            search = split[1]
            search = search.trim()
          
            var searchOrders = {}
            var searchOrderedProducts = {}
            var searchProductsOrders = {}
            var searchProductsOrderedProducts = {}
            
            var foundOrders = {}
            /* if(isNaN(Number(search))) searchType = 'companies'
            else searchType = 'netvisorId' */
            var db = firebase.firestore();
            
            if(searchType === 'salespersonId'){
              console.log("Getting orders for salesperson:")
              console.log(search)
              const snapshot = await db.collection("orders").where('salesperson', '==', 'xf3wThbQ6RNPyl0Cxg5mPxtS6Tq2').get()
              for(var i = 0; i < snapshot.docs.length;i++){
                var doc = snapshot.docs[i]
                var data = doc.data()
                console.log(data)
                foundOrders[doc.id] = {...data,viaSearch:true}
              }
              for(const oId in foundOrders){
                if(!this.ordersData[oId]) searchOrders[oId] = foundOrders[oId]
              }
              for(const oId in searchOrders){
                const snapshot = await db.collection("orderedProducts").where('orderId', '==', oId).get()
                for(var i = 0; i < snapshot.docs.length;i++){
                  var doc = snapshot.docs[i]
                  var data = doc.data()
                  searchOrderedProducts[doc.id] = {...data,viaSearch:true}
                }
              }

            }
            // PRODUCTS
            else if(searchType === 'products'){
              if(search.length < 5 ) {
                alert("Historiahaussa hakutekstin oltava yli 4 kirjainta")
                this.searchInProgress = false
                return
              }
              var productIdsToUseInSearch = []
              Object.keys(this.products).forEach(pId => {
                var p = this.products[pId]
                var pName = p.name && p.name.fi ? p.name.fi.toLowerCase() : ''
                pName.includes(search) ? productIdsToUseInSearch.push(p.id) : ''
              })
              
              for(const pId of productIdsToUseInSearch){
                const snapshot = await db.collection("orderedProducts").where('productId', '==', pId).get()
                for(var i = 0; i < snapshot.docs.length;i++){
                  var doc = snapshot.docs[i]
                  var data = doc.data()
                  if(!this.orderedProducts[doc.id]) searchProductsOrderedProducts[doc.id] = {...data,viaSearch:true}
                }
              }

              for(const opId in searchProductsOrderedProducts){
                var oId = searchProductsOrderedProducts[opId].orderId
                if(searchProductsOrders[oId]) continue
                //console.log("Getting order "+oId+" for op:" + opId)
                const doc = await db.collection("orders").doc(oId).get()
                if(doc.exists){
                  var data = doc.data()
                  searchProductsOrders[doc.id] = {...data,viaSearch:true}
                }
              }
              //console.log(searchProductsOrderedProducts)
              //console.log(searchProductsOrders)
            }
            // COMPANIES
            else if(searchType === 'companies'){
              var companyIdsToUseInSearch = []
              Object.keys(this.companies).forEach(cId => {
                var c = this.companies[cId]
                var companyName = c.companyName.toLowerCase()
                companyName.includes(search) ? companyIdsToUseInSearch.push(c.id) : ''
              })
              
              for(const cId of companyIdsToUseInSearch){
                console.log("Getting orders for company:" + cId)
                const snapshot = await db.collection("orders").where('companyId', '==', cId).get()
                for(var i = 0; i < snapshot.docs.length;i++){
                  var doc = snapshot.docs[i]
                  var data = doc.data()
                  var oId = doc.id
                  if(!this.ordersData[oId]) searchOrders[oId] = {...data,viaSearch:true}
                  //foundOrders[doc.id] = {...data,viaSearch:true}
                }
              }
              
              /* NOT NEEDED */
              /* for(const oId in foundOrders){
                if(!this.ordersData[oId]) searchOrders[oId] = foundOrders[oId]
              } */
              for(const oId in searchOrders){
                const snapshot = await db.collection("orderedProducts").where('orderId', '==', oId).get()
                for(var i = 0; i < snapshot.docs.length;i++){
                  var doc = snapshot.docs[i]
                  var data = doc.data()
                  searchOrderedProducts[doc.id] = {...data,viaSearch:true}
                }
              }
            }
            // NETVISOR ID
            else if(searchType === 'netvisorId'){
              if(search.length < 1 ) {
                alert("Historiahaussa netvisor id:n oltava vähintään 3 numeroa")
                this.searchInProgress = false
                return
              }
              if(isNaN(Number(search))){
                alert("Historiahaussa netvisor id:n oltava numero")
                this.searchInProgress = false
                return
              }
              console.log("Getting orders for netvisorid:" + search)
              const snapshot = await db.collection("orders").where('netvisorId', '==', search).get()
              for(var i = 0; i < snapshot.docs.length;i++){
                var doc = snapshot.docs[i]
                var data = doc.data()
                foundOrders[doc.id] = {...data,viaSearch:true}
              }
              for(const oId in foundOrders){
                if(!this.ordersData[oId]) searchOrders[oId] = foundOrders[oId]
              }
              for(const oId in searchOrders){
                const snapshot = await db.collection("orderedProducts").where('orderId', '==', oId).get()
                for(var i = 0; i < snapshot.docs.length;i++){
                  var doc = snapshot.docs[i]
                  var data = doc.data()
                  searchOrderedProducts[doc.id] = {...data,viaSearch:true}
                }
              }
            }

            this.searchOrders = {...searchOrders, ...searchProductsOrders}
            this.searchOrderedProducts = {...searchOrderedProducts, ...searchProductsOrderedProducts}
            this.generateOrdersData()
          }
          else {
            this.searchOrders = {}
            this.searchOrderedProducts = {}
            this.generateOrdersData()
          }

          this.searchInProgress = false
          //this.companyIdsToUseInSearch = foundOrders
        
      },
      generateOrdersData(){
        var ordersData = {}
        
        var deliveryMarginsByOrder = this.generateDeliveryMarginsByOrder()
        /* var opCopy = JSON.parse(JSON.stringify(this.orderedProducts))
        var oCopy = JSON.parse(JSON.stringify(this.orderedProducts)) */
        var orders = { ...this.searchOrders, ...this.orders}
        var orderedProducts = {...this.searchOrderedProducts,...this.orderedProducts}
        //console.log(orderedProducts)
        
        if (!this.loaded) return ordersData
        var op,pv
        
        for (const key of Object.keys(orderedProducts)) {
          op = orderedProducts[key]
          pv = this.productVariations[op.productVariationId] !== undefined ? this.productVariations[op.productVariationId] : {}
          if(orders[op.orderId] === undefined){
            console.log("GENERATING ORDERS: ORDER NOT FOUND FOR ORDER ID: "+ op.orderId +" VIA OP ID: " + op.id) 
            continue
          } 

          //continue
          if(this.companies[orders[op.orderId].companyId] === undefined) {
            console.log("HRE")
            console.log("GENERATING ORDERS: COMPANY NOT FOUND ID: " + orders[op.orderId].companyId + " ORDERD ID: " +op.orderId) 
            continue
          }
          
          
          //if(this.filterCompanyId !== undefined && orders[op.orderId].companyId !== this.filterCompanyId) { return {}}
          typeof ordersData[op.orderId] === "undefined" ? ordersData[op.orderId] = {} : ""
          //typeof productsData[pv.productId] === "undefined" ? productsData[pv.productId] = {} : ""
          Object.defineProperty(ordersData, op.orderId, { configurable: false });
          


          ordersData[op.orderId].viaSearch = op.viaSearch ? true : false
          ordersData[op.orderId].id = op.orderId
          ordersData[op.orderId].orderedProducts === undefined ? ordersData[op.orderId].orderedProducts = {} : ""
          ordersData[op.orderId].invoiceStatuses === undefined ? ordersData[op.orderId].invoiceStatuses = [] : ""
          ordersData[op.orderId].orderStatuses === undefined ? ordersData[op.orderId].orderStatuses = [] : ""
          ordersData[op.orderId].orderAndInvoiceStatuses === undefined ? ordersData[op.orderId].orderAndInvoiceStatuses = [] : ""
          ordersData[op.orderId].currentResponsibles === undefined ? ordersData[op.orderId].currentResponsibles = [] : ""
          
          
          if (orders[op.orderId].created_at !== undefined && orders[op.orderId].created_at.seconds !== undefined){
            ordersData[op.orderId].created_at = orders[op.orderId].created_at
          }
          else if (orders[op.orderId].created_at !== undefined && orders[op.orderId].created_at.seconds === undefined) {
            var seconds = new Date(orders[op.orderId].created_at).getTime()/1000
            ordersData[op.orderId].created_at = {seconds}
            //console.log(ordersData[op.orderId].created_at)
            //console.log(op.orderId)
          }
          else ordersData[op.orderId].created_at = ""

          ordersData[op.orderId].isOrderSalespersonMarginDisabled = true
          try {
            var orderDate = new Date(ordersData[op.orderId].created_at.seconds * 1000)
            var limitDate = new Date(2024,8,30,23,59,0)
            if(orderDate < limitDate) ordersData[op.orderId].isOrderSalespersonMarginDisabled = false
          }
          catch(e){
            console.log("INVALID DATE FOR ORDER ID " +op.orderId)
          }
        
        
          //orders[op.orderId].created_at !== undefined ? ordersData[op.orderId].created_at = orders[op.orderId].created_at : ordersData[op.orderId].created_at = ''
          
          var total = 0
          try{
            if(op.orderStatus !== 'cancelled'){
              total = Number(op.printQuantity)*Number(op.unitPrintPrice) 
                + Number(op.quantity)*Number(op.unitPrice) 
                + Number(op.numberOfPositionings)*Number(op.pricePerPositioning) 
            }
            //total = total.toFixed(2)
            if(isNaN(total) ) total = 0
            else total = total.toFixed(2)
            ordersData[op.orderId].total === undefined ? ordersData[op.orderId].total = total : ordersData[op.orderId].total = (Number(ordersData[op.orderId].total) + Number(total)).toFixed(2)
          }
          catch(e){
            ordersData[op.orderId].total === undefined ? ordersData[op.orderId].total = total : ordersData[op.orderId].total = (Number(ordersData[op.orderId].total) + Number(total)).toFixed(2)
          }
          ordersData[op.orderId].deliveryCharge = orders[op.orderId].deliveryCharge
          ordersData[op.orderId].billingReferenceDetails = orders[op.orderId].billingReferenceDetails !== undefined ? orders[op.orderId].billingReferenceDetails : ''
          
          ordersData[op.orderId].printShops === undefined ? ordersData[op.orderId].printShops = '' : ''
          if(this.products[op.productId] && this.products[op.productId].printShops && Array.isArray(this.products[op.productId].printShops)){
            this.products[op.productId].printShops.forEach(shop => {
              this.$store.state.printShop && this.$store.state.printShop.printShops && this.$store.state.printShop.printShops[shop] ? ordersData[op.orderId].printShops += this.$store.state.printShop.printShops[shop].name +", " : ""
            })
          }
          ordersData[op.orderId].wholesaleCompanies === undefined ? ordersData[op.orderId].wholesale = '' : ''
          var wc = this.products[op.productId] && this.$store.state.wholesaleCompany && this.$store.state.wholesaleCompany.wholesaleCompanies && this.$store.state.wholesaleCompany.wholesaleCompanies[this.products[op.productId].wholesaleCompany] ? this.$store.state.wholesaleCompany.wholesaleCompanies[this.products[op.productId].wholesaleCompany] : undefined
          ordersData[op.orderId].wholesaleCompanies += wc ? wc.wholesaleCode + ' ' + wc.name : ''  
          ordersData[op.orderId].productsWholesaleNames ? '' : ordersData[op.orderId].productsWholesaleNames = ""
          ordersData[op.orderId].productsEnglishNames ? '' : ordersData[op.orderId].productsEnglishNames = ""
          ordersData[op.orderId].productsWholesaleNames += this.products[op.productId] && this.products[op.productId].name.wholesale ? this.products[op.productId].name.wholesale : ''
          ordersData[op.orderId].productsEnglishNames += this.products[op.productId] && this.products[op.productId].name.en ? this.products[op.productId].name.en : ''


          ordersData[op.orderId].orderSummary === undefined ? ordersData[op.orderId].orderSummary = '' : ''
          var opNumber = Object.keys(ordersData[op.orderId].orderedProducts) ? Object.keys(ordersData[op.orderId].orderedProducts).length + 1 : 1
          ordersData[op.orderId].orderSummary += opNumber +'. '
          ordersData[op.orderId].orderSummary += this.products[op.productId] !== undefined ? this.products[op.productId].name.fi : ''

          var variationName = this.createVariationName(pv,true)
          ordersData[op.orderId].orderSummary += ' - ' + variationName
          var sku = this.createVariationAvecorSku(pv.id)
          ordersData[op.orderId].orderSummary += ' (' +sku+ ')'
          
          ordersData[op.orderId].orderSummary += '\n➔ ' + op.quantity + ' x ' + op.unitPrice +'€ '
          if(op.print){
            if(op.printFormats){
              var pfNames = ''
              op.printFormats.forEach(pf => {
                this.settings.printFormatsObject[pf] ? pfNames += this.settings.printFormatsObject[pf].fi : ''
              })
              if(op.unitPrintPrice) ordersData[op.orderId].orderSummary += ' | Merk. ' + op.printQuantity + ' x ' + op.unitPrintPrice +'€ '
              if(pfNames) ordersData[op.orderId].orderSummary += ' (' +pfNames + ')'
            }
          }
          var orderStatus = this.settings.orderedProductStatusObject[op.orderStatus] ? this.settings.orderedProductStatusObject[op.orderStatus].text : ''
          /* var blocks = ""
          if(op.orderStatus === 'new') blocks = '■□□'
          if(op.orderStatus !== 'new') blocks = '■■□'
          if(op.orderStatus === 'productsShipped') blocks = '■■■'
          ordersData[op.orderId].orderSummary += '\n'+blocks+' ' + orderStatus */
          ordersData[op.orderId].orderSummary +='\n'

          
          ordersData[op.orderId].orderSummaryIds === undefined ? ordersData[op.orderId].orderSummaryIds = '' : ''
          var avecorSku = this.products[pv.productId] && this.products[pv.productId].avecorSku ? this.products[pv.productId].avecorSku : ''

          //var colorCode = pv.colorCode && this.settings.colors[pv.colorCode] ? pv.colorCode : ''
          ordersData[op.orderId].orderSummaryIds += avecorSku + '-' + pv.colorCode ? pv.colorCode : ''
          ordersData[op.orderId].orderSummaryIds += pv.wholesaleSku ? pv.wholesaleSku + ' ' : ''
          //ordersData[op.orderId].orderSummary = orders[op.orderId].orderSummary
          //ordersData[op.orderId].orderSummaryIds = orders[op.orderId].orderSummaryIds
          var order = orders[op.orderId]
          ordersData[op.orderId].salespersonMargin = order.salespersonMargin
          
          // DELIVERY MARGIN
          if(deliveryMarginsByOrder[op.orderId] && ordersData[op.orderId].salespersonMarginViaOps === undefined){
            ordersData[op.orderId].salespersonMarginViaOps = deliveryMarginsByOrder[op.orderId].deliveryMargin
            ordersData[op.orderId].deliveryMargin = deliveryMarginsByOrder[op.orderId].deliveryMargin
          }
          else if (ordersData[op.orderId].salespersonMarginViaOps === undefined) ordersData[op.orderId].salespersonMarginViaOps = 0
          
          if(deliveryMarginsByOrder[op.orderId] && ordersData[op.orderId].officeMarginViaOps === undefined){
            ordersData[op.orderId].officeMarginViaOps = deliveryMarginsByOrder[op.orderId].deliveryMargin
            ordersData[op.orderId].deliveryMargin = deliveryMarginsByOrder[op.orderId].deliveryMargin
          }
          else if (ordersData[op.orderId].officeMarginViaOps === undefined) ordersData[op.orderId].officeMarginViaOps = 0

          if(deliveryMarginsByOrder[op.orderId] && ordersData[op.orderId].marginViaOpsForMarginRate === undefined){
            ordersData[op.orderId].marginViaOpsForMarginRate = deliveryMarginsByOrder[op.orderId].deliveryMargin
          }
          else if (ordersData[op.orderId].marginViaOpsForMarginRate === undefined) ordersData[op.orderId].marginViaOpsForMarginRate = 0

          var marginViaOpsForMarginRate = 0
          if (op.confirmedMargin) marginViaOpsForMarginRate = Number(op.confirmedMargin)
          else if (op.salespersonMargin) marginViaOpsForMarginRate = Number(op.salespersonMargin)
          ordersData[op.orderId].marginViaOpsForMarginRate += marginViaOpsForMarginRate

          var salespersonMarginViaOp = isNaN(Number(op.salespersonMargin)) ? 0 : Number(op.salespersonMargin)
          ordersData[op.orderId].salespersonMarginViaOps += salespersonMarginViaOp
          ordersData[op.orderId].salespersonMarginViaOps = ordersData[op.orderId].salespersonMarginViaOps.toFixed(2)
          ordersData[op.orderId].salespersonMarginViaOps = Number(ordersData[op.orderId].salespersonMarginViaOps)
          if(ordersData[op.orderId].salespersonMarginViaOpsDefined === undefined) ordersData[op.orderId].salespersonMarginViaOpsDefined = true
          if(op.salespersonMargin === undefined || op.salespersonMargin === null) ordersData[op.orderId].salespersonMarginViaOpsDefined = false

          var officeMarginViaOp = isNaN(Number(op.confirmedMargin)) ? 0 : Number(op.confirmedMargin)
          ordersData[op.orderId].officeMarginViaOps += officeMarginViaOp
          ordersData[op.orderId].officeMarginViaOps = ordersData[op.orderId].officeMarginViaOps.toFixed(2)
          ordersData[op.orderId].officeMarginViaOps = Number(ordersData[op.orderId].officeMarginViaOps)

          ordersData[op.orderId].orderResponsible = order.orderResponsible
          
          ordersData[op.orderId].netvisorId = order.netvisorId ? order.netvisorId :''
          ordersData[op.orderId].netvisorKey = order.netvisorKey ? order.netvisorKey : ''
          ordersData[op.orderId].netvisorId_test_env = order.netvisorId_test_env ? order.netvisorId_test_env : ''
          ordersData[op.orderId].netvisorKey_test_env = order.netvisorKey_test_env ? order.netvisorKey_test_env : ''
          ordersData[op.orderId].netvisorId_invoice_test_env = order.netvisorId_invoice_test_env ? order.netvisorId_invoice_test_env : ''
          ordersData[op.orderId].netvisorKey_invoice_test_env = order.netvisorKey_invoice_test_env ? order.netvisorKey_invoice_test_env : ''
          ordersData[op.orderId].companyId = order.companyId
          ordersData[op.orderId].deliveryWeek = order.deliveryWeek ? order.deliveryWeek : ''
          // ------- CLIENT PRINT DETAILS ------
          ordersData[op.orderId].clientPrintDetailsEmail = ''
          if(this.companies[order.companyId] && this.companies[order.companyId].clientPrintDetailsEmail){
            ordersData[op.orderId].clientPrintDetailsEmail = this.companies[order.companyId].clientPrintDetailsEmail
          }
          else if (this.contacts[order.contactId] && this.contacts[order.contactId].clientPrintDetailsEmail){
            ordersData[op.orderId].clientPrintDetailsEmail = this.contacts[order.contactId].clientPrintDetailsEmail
          }
          else if(this.contacts[order.contactId]) ordersData[op.orderId].clientPrintDetailsEmail = this.contacts[order.contactId].email
          if(this.contacts[order.contactId].sendDraftsToSalesperson && this.staff[order.salesperson]) ordersData[op.orderId].clientPrintDetailsEmail = this.staff[order.salesperson].email
          // ----------------------------------
          ordersData[op.orderId].pending = order.pending !== undefined ? order.pending : false
          ordersData[op.orderId].avecorOrder = order.avecorOrder !== undefined ? order.avecorOrder : false
          ordersData[op.orderId].shopifyOrder = order.shopifyOrder !== undefined ? order.shopifyOrder : false
          ordersData[op.orderId].deadline = order.deadline !== undefined ? order.deadline : false
          ordersData[op.orderId].sample = order.sample !== undefined ? order.sample : false
          ordersData[op.orderId].salespersonSample = order.salespersonSample !== undefined ? order.salespersonSample : false
          ordersData[op.orderId].reclaimed = order.reclaimed !== undefined ? order.reclaimed : false
          ordersData[op.orderId].companyName = this.companies[order.companyId] !== undefined ? this.companies[order.companyId].companyName : ""
          ordersData[op.orderId].totalOrders = this.companies[order.companyId] !== undefined ? this.companies[order.companyId].totalOrders : 1
          // INVOICE DATA
          ordersData[op.orderId].invoices = order.invoices ? order.invoices : undefined
          ordersData[op.orderId].invoicesTest = order.invoicesTest ? order.invoicesTest : undefined
          ordersData[op.orderId].invoicesAllPaid = order.invoicesAllPaid !== undefined ? order.invoicesAllPaid : undefined
          ordersData[op.orderId].invoicesPaidDate = order.invoicesPaidDate ? order.invoicesPaidDate : null
          ordersData[op.orderId].invoicesVatPercentage = order.invoicesVatPercentage !== undefined ? order.invoicesVatPercentage : "-"
          ordersData[op.orderId].invoicesSumWithVat = order.invoicesSumWithVat !== undefined ? order.invoicesSumWithVat : 0
          ordersData[op.orderId].invoicesSumWithVat = this.formatAmount(ordersData[op.orderId].invoicesSumWithVat)
          ordersData[op.orderId].invoicesSumWithoutVat = order.invoicesSumWithoutVat !== undefined ? order.invoicesSumWithoutVat : 0
          ordersData[op.orderId].invoicesSumWithoutVat = this.formatAmount(ordersData[op.orderId].invoicesSumWithoutVat)
          ordersData[op.orderId].invoicesPaidSumWithVat = order.invoicesPaidSumWithVat !== undefined ? order.invoicesPaidSumWithVat : 0
          ordersData[op.orderId].invoicesPaidSumWithVat = this.formatAmount(ordersData[op.orderId].invoicesPaidSumWithVat)
          ordersData[op.orderId].invoicesPaidSumWithoutVat = order.invoicesPaidSumWithoutVat !== undefined ? order.invoicesPaidSumWithoutVat : 0
          ordersData[op.orderId].invoicesPaidSumWithoutVat = this.formatAmount(ordersData[op.orderId].invoicesPaidSumWithoutVat)
          ordersData[op.orderId].invoicesOrderInvoiceAmountWithVat = order.invoicesOrderInvoiceAmountWithVat !== undefined ? order.invoicesOrderInvoiceAmountWithVat : 'n/a'
          ordersData[op.orderId].invoicesOrderInvoiceAmountWithVat = this.formatAmount(ordersData[op.orderId].invoicesOrderInvoiceAmountWithVat)
          ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat = order.invoicesOrderInvoiceAmountWithoutVat !== undefined ? order.invoicesOrderInvoiceAmountWithoutVat : 'n/a'
          ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat = this.formatAmount(ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat)
          ordersData[op.orderId].invoicesSumNotPaidWithVat = order.invoicesSumNotPaidWithVat !== undefined ? order.invoicesSumNotPaidWithVat : 'n/a'
          ordersData[op.orderId].invoicesSumNotPaidWithVat = this.formatAmount(ordersData[op.orderId].invoicesSumNotPaidWithVat)
          ordersData[op.orderId].invoicesSumNotPaidWithoutVat = order.invoicesSumNotPaidWithoutVat !== undefined ? order.invoicesSumNotPaidWithoutVat : 'n/a'
          ordersData[op.orderId].invoicesSumNotPaidWithoutVat = this.formatAmount(ordersData[op.orderId].invoicesSumNotPaidWithoutVat)
          
          

          ordersData[op.orderId].paidPercentage = ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat !== 'n/a' ? ordersData[op.orderId].invoicesPaidSumWithoutVat / ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat : 0
          ordersData[op.orderId].paidPercentage = (ordersData[op.orderId].paidPercentage * 100).toFixed(1)
          ordersData[op.orderId].paidPercentageCssStyle = "padding-left:2px;background-color:#A8A8A8;"
          ordersData[op.orderId].paidPercentageColor = "#A8A8A8"
          if(ordersData[op.orderId].paidPercentage > 0 && ordersData[op.orderId].paidPercentage < 100) {
            ordersData[op.orderId].paidPercentageCssStyle = "padding-left:2px;background-color:#ff982e"
            ordersData[op.orderId].paidPercentageColor = "#ff982e"
          }
          else if (ordersData[op.orderId].paidPercentage >= 100) {
            ordersData[op.orderId].paidPercentageCssStyle = "padding-left:2px;background-color:#2ECC40;color:#FFF;"
            ordersData[op.orderId].paidPercentageColor = "#2ECC40"
          }
          
          //ordersData[op.orderId].invoicedPercentage = ordersData[op.orderId].invoicesOrderInvoiceAmountWithVat !== 'n/a' ? ordersData[op.orderId].invoicesSumWithVat / ordersData[op.orderId].invoicesOrderInvoiceAmountWithVat : 0
          ordersData[op.orderId].invoicedPercentage = ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat !== 'n/a' ? ordersData[op.orderId].invoicesSumWithoutVat / ordersData[op.orderId].invoicesOrderInvoiceAmountWithoutVat : 0

          ordersData[op.orderId].invoicedPercentage = (ordersData[op.orderId].invoicedPercentage * 100).toFixed(1)
          ordersData[op.orderId].invoicedPercentageCssStyle = "padding-left:2px;background-color:#A8A8A8;"
          ordersData[op.orderId].invoicedPercentageColor = "#A8A8A8"
          if(ordersData[op.orderId].invoicedPercentage > 0 && ordersData[op.orderId].invoicedPercentage < 100) {
            ordersData[op.orderId].invoicedPercentageCssStyle = "padding-left:2px;background-color:#ff982e"
            ordersData[op.orderId].invoicedPercentageColor = "#ff982e"
          }
          else if (ordersData[op.orderId].invoicedPercentage >= 100) {
            ordersData[op.orderId].invoicedPercentageCssStyle = "padding-left:2px;background-color:#2ECC40;color:#FFF;"
            ordersData[op.orderId].invoicedPercentageColor = "#2ECC40"
          }
          //((order.invoicesPaidSumWithVat / order.invoicesOrderInvoiceAmountWithVat) * 100).toFixed(2)
          //((order.invoicesSumWithVat / order.invoicesOrderInvoiceAmountWithVat) * 100).toFixed(2)

          try{
            var company = this.companies[order.companyId]
            ordersData[op.orderId].companyAddress = company.deliveryAddress + " " + company.deliveryPostalCode + ", " + company.deliveryCity + " " + company.deliveryCountry
          } catch(e){ 
            ordersData[op.orderId].companyAddress = ""
          }
          if(!this.contacts[order.contactId]) {
            console.log("CONTACT NOT FOUND")
            console.log("ORDER ID: " +op.orderId)
            console.log("SALESPERSON:" + order.salesperson)
          }
          ordersData[op.orderId].contactName = this.contacts[order.contactId] ? this.contacts[order.contactId].firstName + " " + this.contacts[order.contactId].lastName : ''
          ordersData[op.orderId].contactId = order.contactId
          ordersData[op.orderId].contactEmail = this.contacts[order.contactId] ? this.contacts[order.contactId].email : ''
          ordersData[op.orderId].contactPhone = this.contacts[order.contactId] ? this.contacts[order.contactId].phone : ''
          ordersData[op.orderId].salespersonId = order.salesperson
          order.originalSalesperson &&  this.staff[order.originalSalesperson] ? ordersData[op.orderId].salespersonId = order.originalSalesperson : ''

          !this.staff[ordersData[op.orderId].salespersonId] ? console.log(order) : ''
          ordersData[op.orderId].salespersonFirstName = this.staff[ordersData[op.orderId].salespersonId].firstName
          
          


          //address
          //ordersData[op.orderId].salespersonLastName = this.staff[order.salesperson].lastName
          op.orderInvoiceStatus !== undefined ? ordersData[op.orderId].invoiceStatuses.push(op.orderInvoiceStatus) : ordersData[op.orderId].invoiceStatuses.push("emptyStatus")
          this.settings.orderedProductStatusObject[op.orderStatus] ? ordersData[op.orderId].currentResponsibles.push(this.settings.orderedProductStatusObject[op.orderStatus].nextStepResponsible) : ''
          !this.settings.orderedProductStatusObject[op.orderStatus] ? console.log(op) : ''
          op.orderStatus !== undefined ? ordersData[op.orderId].orderStatuses.push(op.orderStatus) : ordersData[op.orderId].orderStatuses.push("emptyStatus")
          op.orderStatus !== undefined && op.orderInvoiceStatus !== undefined ? ordersData[op.orderId].orderAndInvoiceStatuses.push(op.orderStatus+'_'+op.orderInvoiceStatus) : ordersData[op.orderId].orderAndInvoiceStatuses.push("emptyStatus")
          var opArchived = op.archived ? true : false
          if(ordersData[op.orderId].allOrderStatusesNew === undefined) ordersData[op.orderId].allOrderStatusesNew = true
          if(op.orderStatus && op.orderStatus !== 'new') ordersData[op.orderId].allOrderStatusesNew = false

          ordersData[op.orderId].orderedProducts[op.id] = {id: op.id, warehoused:false, archived:opArchived,latestToCustomer:op.latestToCustomer, deliveryStatus:op.orderStatus, invoiceStatus:op.orderInvoiceStatus}
          ordersData[op.orderId].areAllArchived === undefined ? ordersData[op.orderId].areAllArchived = true : ''
          ordersData[op.orderId].isAtLeastOneArchived === undefined ? ordersData[op.orderId].isAtLeastOneArchived = false : ''
          if(!opArchived) ordersData[op.orderId].areAllArchived = false
          if(opArchived) ordersData[op.orderId].isAtLeastOneArchived = true
          

          //if(this.productVariations[op.productVariationId] !== undefined && this.productVariations[op.productVariationId].warehoused) ordersData[op.orderId].orderedProducts[op.id].warehoused = true
          if(this.productVariations[op.productVariationId] !== undefined && this.productVariations[op.productVariationId].warehoused && orderedProducts[op.id].warehouseStatus !== undefined){
            ordersData[op.orderId].orderedProducts[op.id].warehouseStatus = orderedProducts[op.id].warehouseStatus
            //console.log(ordersData[op.orderId].orderedProducts[op.id].warehouseStatus)
          }
          else {
            ordersData[op.orderId].orderedProducts[op.id].warehouseStatus = null
          }

        }
        
        var sortedOrders = Object.keys(ordersData).sort(function(a,b){
          var aDate = ordersData[a].created_at.seconds
          var bDate = ordersData[b].created_at.seconds
          return bDate - aDate;
        });
        var newOrdersData = {}
        sortedOrders.map(function(key, index) {
          newOrdersData[key] = ordersData[key]
          return 
        })
        this.ordersData = newOrdersData 
      },
      getOrderProducts(orderId){
        return typeof this.orderStatuses[orderId] !== "undefined" ? this.orderStatuses[orderId] : []
      },
      formatAmount(amount){
        if(amount !== 'n/a'){
          amount = amount.toFixed(2)
          amount = Number(amount)
        }
        return amount
      },
      setDeliveryStatusColor(status){
        if(status === "new") return ""
      },
      fieldUpdated(field, orderId){
        //console.log(this.orders[orderId][field])
        this.orders[orderId][field] = this.orders[orderId][field].replace(",", ".")
      },
      generateAddress(companyId){
        var company = this.companies[companyId]
        var address = company.deliveryAddress + " " + company.deliveryPostalCode + ", " + company.deliveryCity + " " + company.deliveryCountry
        return address
      },
      getContacts(companyId){
        var contacts = this.contacts
        var contactList = []
        Object.keys(this.contacts).map(function(key, index) {
          var c = contacts[key]
          c.companyId === companyId ? contactList.push({text: c.firstName + " " + c.lastName, value: c.id}) : ""
          return {text: c.firstName + " " + c.lastName, value: c.id}
        })
        return contactList
      },
      customFormatter(date,includetime) {
        try{
          if (date.seconds) {
            var myDate = new Date(date.seconds*1000);
            if(includetime) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
            return dateFormat(myDate, "yyyy-mm-dd")
          }
          if (date._seconds) {
            var myDate = new Date(date._seconds*1000);
            if(includetime) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
            return dateFormat(myDate, "yyyy-mm-dd")
          }
          else if (date !== undefined && date.seconds === undefined){
            if(includetime) return dateFormat(date, "yyyy-mm-dd HH:MM")
            return dateFormat(date, "yyyy-mm-dd")
          }
          return ''
        }
        catch(e){
          return ''
        }
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      getProductsTotal(orderId) {
        var orderedProducts = this.orderedProducts
        var total = 0
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = orderedProducts[key]
          if(op.orderId === orderId && op.orderStatus !== 'cancelled') {
            total += (op.unitPrice * op.quantity) 
          }
        })
        return total
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.unitPrice * p.quantity) 
          }
          return result
        },0))).toFixed(2)
      },
      getOrderproductResponsibles(orderId){
        var orderedProducts = this.orderedProducts
        var productList = []
        Object.keys(this.orderedProducts).map(function(key, index) {
          var op = orderedProducts[key]
          //if(key==="hny4Tefs5g245OsLs9Tw") console.log(op)
          op.orderId === orderId ? productList.push({id: op.id, deliveryStatus:op.orderStatus, invoiceStatus:op.orderInvoiceStatus}) : ""
          return {}
        })
        return productList
      },
      getPrintTotal(orderId) {
        var orderedProducts = this.orderedProducts
        var total = 0
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = orderedProducts[key]
          if(op.orderId === orderId && op.orderStatus !== 'cancelled') {
            total += (op.unitPrintPrice * op.printQuantity) 
          }
        })
        return total
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.unitPrintPrice * p.printQuantity) 
          }
          return result
        },0))).toFixed(2)
      },
      getPositioningTotal(orderId) {
        var orderedProducts = this.orderedProducts
        var total = 0
        Object.keys(this.orderedProducts).forEach(opId => {
          var op = orderedProducts[key]
          if(op.orderId === orderId && op.orderStatus !== 'cancelled') {
            total += (op.pricePerPositioning * op.numberOfPositionings) 
          }
        })
        return total
        return Number(Number(Object.keys(this.orderedProducts).reduce((result, key, currIndex, array) => { 
          var p = orderedProducts[key]
          if(p.orderId === orderId) {
            return result + (p.pricePerPositioning * p.numberOfPositionings) 
          }
          return result
        },0))).toFixed(2)
      },
      getTotal(orderId) {
        return (Number(this.getProductsTotal(orderId)) + Number(this.getPrintTotal(orderId)) + Number(this.getPositioningTotal(orderId)) + Number(this.orders[orderId].deliveryCharge)).toFixed(2)
      },
      editItem (item) {
        this.editedIndex = this.products.indexOf(item)
        this.newItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        if (confirm('Haluatko varmasti poistaa tilauksen?')) {
          this.selectedOrderOrderId = ""
          if(this.pinnedOrdersInOrders.includes(item.id)){
            this.pinnedOrdersInOrders = this.pinnedOrdersInOrders.filter(o => o !== item.id)
          }
          var store = this.$store
          var orderedProducts = this.orderedProducts
          Object.keys(this.orderedProducts).forEach((opId) => {
            var orderedProduct = orderedProducts[opId]
            if(orderedProduct.orderId === item.id) {
              store.dispatch('orderedProduct/delete', orderedProduct.id)
            }
          })
          this.$store.dispatch('order/delete', item.id)
          
          var totalOrders = null
          if(this.companies[item.companyId] && this.companies[item.companyId].totalOrders !== undefined) {
            totalOrders = this.companies[item.companyId].totalOrders - 1
          }
          
          if(totalOrders !== null){
            this.$store.dispatch('company/set', {
              id:item.companyId,
              totalOrders
            })
          }
        }
      },
      generateProductsData(){
        var productsData = {}
        var t = this
        t.numberOfExceededArrivalDates = 0
        t.numberOfWithin3DaysArrivalDates = 0
        /* if(this.createVariationName === undefined) console.log("HERE")
        console.log(this.createVariationName)
        return productsData */
        Object.keys(this.productVariations).forEach( key => {
          var pv = t.productVariations[key]
          try{
            if(typeof t.products[pv.productId] === "undefined" || t.products[pv.productId] === "") {console.log (); return}
            if(pv.batches && Object.keys(pv.batches).length > 0) {
              if(t.products[pv.productId] !== undefined){
                
                productsData[pv.productId] === undefined ? productsData[pv.productId] = {} : ""
                Object.defineProperty(productsData, pv.productId, { configurable: false });
                productsData[pv.productId].productVariations === undefined ? productsData[pv.productId].productVariations = {} : ""
                t.products[pv.productId].warehouseInformation !== undefined ? productsData[pv.productId].warehouseInformation = t.products[pv.productId].warehouseInformation : ""
                t.products[pv.productId].productInformation !== undefined ? productsData[pv.productId].productInformation = t.products[pv.productId].productInformation : ""
                productsData[pv.productId].id = pv.productId
                productsData[pv.productId].created_at = t.products[pv.productId].created_at
                t.products[pv.productId].archived !== undefined ? productsData[pv.productId].archived = t.products[pv.productId].archived : productsData[pv.productId].archived = false
                t.products[pv.productId].warehoused !== undefined ? productsData[pv.productId].warehoused = t.products[pv.productId].warehoused : productsData[pv.productId].warehoused = false
                productsData[pv.productId].deliveryTime = t.products[pv.productId].deliveryTime
                productsData[pv.productId].isPrintProduct = t.products[pv.productId].isPrintProduct
                productsData[pv.productId].isDoubleSidePrintPossible = t.products[pv.productId].isDoubleSidePrintPossible
                productsData[pv.productId].name = t.products[pv.productId].name.fi
                productsData[pv.productId].officeComments = t.products[pv.productId].officeComments
                productsData[pv.productId].printFormats = ""
                productsData[pv.productId].selectedProductImageId = t.products[pv.productId].selectedProductImageId !== undefined ? t.products[pv.productId].selectedProductImageId : ""
                t.products[pv.productId].printFormats !== undefined && Array.isArray(t.products[pv.productId].printFormats)? t.products[pv.productId].printFormats.forEach(format => {
                  t.settings.printFormatsObject[format] !== undefined ? productsData[pv.productId].printFormats += t.settings.printFormatsObject[format].fi : ""
                }) : ""
                //
                if(t.products[pv.productId].wholesaleCompany !== undefined && t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined && 
                t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts !== undefined){
                  
                  Object.keys(t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts).forEach(key =>{
                    
                    var contact = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].partnerContacts[key]
                    //contact.contactType === 'ordersContact' ? console.log("HERE") : ""
                    contact.contactType === 'ordersContact' ? productsData[pv.productId].ordersContactEmail = contact.email : productsData[pv.productId].ordersContactEmail = ''
                    contact.contactType === 'ordersContact' ? productsData[pv.productId].ordersContactPhone = contact.phone : productsData[pv.productId].ordersContactPhone = ''
                  })
                }

                productsData[pv.productId].wholesaleCompanyId = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].id : ""
                productsData[pv.productId].wholesaleCompany = t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany] !== undefined ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
                productsData[pv.productId].printShops = ""
                t.products[pv.productId].printShops !== undefined && Array.isArray(t.products[pv.productId].printShops) ? t.products[pv.productId].printShops.forEach(shop => {
                  t.printShops[shop] !== undefined ? productsData[pv.productId].printShops += t.printShops[shop].name +", " : ""
                  //console.log(productsData[pv.productId].printShops)
                }) : ""
                //productsData[pv.productId].printShops = typeof t.printShops[t.products[pv.productId].wholesaleCompany] !== "undefined" ? t.wholesaleCompanies[t.products[pv.productId].wholesaleCompany].name : ""
                var text = t.createVariationName(pv)
                productsData[pv.productId].productVariations[pv.id] = {
                  id: pv.id,
                  colorCode:pv.colorCode,
                  warehoused:pv.warehoused ? pv.warehoused : false,
                  campaigned:pv.campaigned ? pv.campaigned : false,
                  avecorStock:pv.avecorStock ? pv.avecorStock : 0, 
                  printShopStock:pv.printShopStock ? pv.printShopStock : 0,
                  customersWarehoused: pv.customersWarehoused ? pv.customersWarehoused : {},
                  commentsForSales:pv.commentsForSales !== undefined ? pv.commentsForSales : '', 
                  name:text, 
                  //avecorSku:(t.products[pv.productId].avecorSku ? t.products[pv.productId].avecorSku : '') + (t.products[pv.productId].avecorSku && pv.colorCode ? '-'+pv.colorCode : ''), 
                  shelfLocation:pv.shelfLocation !== undefined ? pv.shelfLocation : '',
                  unitPurchasePrice:pv.unitPurchasePrice !== undefined ? pv.unitPurchasePrice : 0,
                  unitSalesPrice:pv.unitSalesPrice !== undefined ? pv.unitSalesPrice : 0,
                  subtractAlsoPrintShopStock:pv.subtractAlsoPrintShopStock ? pv.subtractAlsoPrintShopStock : false,
                  avecorStockNotifyLevel:pv.avecorStockNotifyLevel ? pv.avecorStockNotifyLevel : '',
                  printShopStockNotifyLevel:pv.printShopStockNotifyLevel ? pv.printShopStockNotifyLevel : ''
                }
                var avecorSku = t.createVariationAvecorSku(pv.id)
                productsData[pv.productId].productVariations[pv.id].avecorSku = avecorSku
                productsData[pv.productId].productVariations[pv.id].batches = {}
                if(pv.batches !== undefined){
                  var clonedBatches = JSON.parse(JSON.stringify(pv.batches))
                  productsData[pv.productId].productVariations[pv.id].batches = clonedBatches
                  /* Object.keys(pv.batches).forEach(batchId => {
                    productsData[pv.productId].productVariations[pv.id].batches[batchId] = Object.assign({}, pv.batches[batchId]);
                    //console.log(productsData[pv.productId].productVariations[pv.id].batches[batchId])
                  }) */
                  
                }
                productsData[pv.productId].numberOfExceededArrivalDates === undefined ? productsData[pv.productId].numberOfExceededArrivalDates = 0 : ''
                productsData[pv.productId].numberOfWithin3DaysArrivalDates === undefined ? productsData[pv.productId].numberOfWithin3DaysArrivalDates = 0 : ''
                productsData[pv.productId].numberOfWithin5DaysArrivalDates === undefined ? productsData[pv.productId].numberOfWithin5DaysArrivalDates = 0 : ''
                Object.keys(productsData[pv.productId].productVariations[pv.id].batches).forEach(batchId => {
                  var batch = productsData[pv.productId].productVariations[pv.id].batches[batchId]
                  productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = ""
                  //productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "ok"
                  if(batch.status === "batchArrivedToWarehouse"){
                    productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "arrived"
                  }
                  else if(batch.status === "batchPartiallyShelfed"){
                    productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "partiallyShelfed"
                  }
                  else if(batch.status === "batchShelfed"){
                    productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "shelfed"
                  }
                  else {
                    //console.log("HERE")
                    //productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = ""
                    if(batch.estimatedArrivalDate !== undefined){
                      if (new Date(batch.estimatedArrivalDate) - new Date() < 0) {
                        productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "exceeded"
                        productsData[pv.productId].numberOfExceededArrivalDates += 1
                        //console.log(productsData[pv.productId].numberOfExceededArrivalDates)
                        t.numberOfExceededArrivalDates += 1
                      }
                      else if ((new Date(batch.estimatedArrivalDate) - new Date() - 259200000) < 0) {
                        productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "within3days"
                        productsData[pv.productId].numberOfWithin3DaysArrivalDates += 1
                        t.numberOfWithin3DaysArrivalDates += 1
                      }
                      /* if ((new Date(batch.estimatedArrivalDate) - new Date() - 432000000) < 0) {
                        productsData[pv.productId].productVariations[pv.id].batches[batchId].batchArrivalDateStatus = "within5days"
                        productsData[pv.productId].numberOfWithin5DaysArrivalDates += 1
                        t.numberOfWithin5DaysArrivalDates += 1
                      } */
                    }
                  }
                  
                })
                //if(t.internalProductData[pv.id] === undefined) console.log(t.internalProductData[pv.id]) //t.addInternalProductData(pv.id)
                productsData[pv.productId].productVariationSkus === undefined ? productsData[pv.productId].productVariationSkus = "" : ""
                pv.avecorSku !== undefined ? productsData[pv.productId].productVariationSkus += pv.avecorSku : ""
                !productsData[pv.productId].wholesaleSku ? productsData[pv.productId].wholesaleSku = t.products[pv.productId].wholesaleSku : ""
                productsData[pv.productId].productVariationWholesaleSkus === undefined ? productsData[pv.productId].productVariationWholesaleSkus = '' : ''
                if(productsData[pv.productId].productVariationWholesaleSkus === '') productsData[pv.productId].productVariationWholesaleSkus += pv.wholesaleSku ? pv.wholesaleSku : ''
                else pv.wholesaleSku && !productsData[pv.productId].productVariationWholesaleSkus.includes(pv.wholesaleSku) ? productsData[pv.productId].productVariationWholesaleSkus += ', '+ pv.wholesaleSku : ''


                return 
              }
            }
          }
          catch(e){
            console.log(e)
          }
        })
        
        //console.log(productsData)
        this.productsData = productsData
      },
      printItem (order){
        const cssText = `
          @page { size: auto;  margin: 0mm 40px; }
          h1 {
            color: black;
            font-family: sans-serif;
          }
        `
        const d = new Printd()

        var mainDiv = document.createElement('div')
        var h1 = document.createElement('h1')
        var orderDiv = document.createElement('div')
        var productsDiv = document.createElement('div')
        productsDiv.style.paddingTop = "20px"
        h1.innerHTML = "Avecor Tilauskooste"
        
        h1.style.fontSize = "30px"
        mainDiv.style.fontSize = "12px"
        //orderDiv.style.fontSize = "10px"

        
        var orderDetailsText = "Tilauksen Avecor ID: " + order.id + "<br />" 
        order.netvisorId ? orderDetailsText += "Tilauksen Netvisor ID: " + order.netvisorId +"<br /><br />" : orderDetailsText += "Tilauksen Netvisor ID: Ei määritelty<br/><br/>"
        orderDetailsText += "Tilauksen pvm: " + this.customFormatter(order.created_at) +"<br />"
        orderDetailsText += "Yritys: " + this.companies[order.companyId].companyName +"<br />"
        orderDetailsText += "Y-tunnus: " + this.companies[order.companyId].companyId +"<br />"
        orderDetailsText += "Osoite: " + this.generateAddress(order.companyId) +"<br />"
        orderDetailsText += "Tilaaja: " + this.contacts[order.contactId].firstName +" " + this.contacts[order.contactId].lastName +"<br/>"
        orderDetailsText += "Tilaajan puhelinnumero: " + this.contacts[order.contactId].phone +"<br />"
        orderDetailsText += "Myyjä: " + this.staff[order.salespersonId].firstName + " " + this.staff[order.salespersonId].lastName +"<br/>"
        if(!order.viaSearch && this.orders[order.id] && this.orders[order.id].officeOrderComments) orderDetailsText += "<div style='font-size:14px;max-width:500px;'>Toimiston kommentit: " + this.orders[order.id].officeOrderComments +"</div><br />" 
        else if(order.viaSearch && this.searchOrders[order.id] && this.searchOrders[order.id].officeOrderComments) orderDetailsText += "<div style='font-size:14px;max-width:500px;'>Toimiston kommentit: " + this.searchOrders[order.id].officeOrderComments +"</div><br />"
        
        if(!order.viaSearch && this.orders[order.id]) orderDetailsText += "<div style='font-size:14px;max-width:500px;'>Myyjän kommentit: " + this.orders[order.id].orderComments +"</div><br />"
        else if(order.viaSearch && this.searchOrders[order.id]) orderDetailsText += "<div style='font-size:14px;max-width:500px;'>Myyjän kommentit: " + this.searchOrders[order.id].orderComments +"</div><br />"
        
        orderDiv.innerHTML = orderDetailsText
        
        //var productText = ""
        //var productCatalog = this.productCatalog
        var productVariations = this.productVariations
        var orderedProducts = {}
        if (order.viaSearch) orderedProducts = this.searchOrderedProducts
        else orderedProducts = this.orderedProducts
        
        var products = this.products
        var settings = this.settings
        var latestToCustomerProducts = []
        Object.keys(orderedProducts).forEach((key) => {
          var orderedProduct = orderedProducts[key]
          if(orderedProduct.orderStatus === 'cancelled') return
          if(orderedProduct.orderId === order.id) {
            var productText = ""
            var productContainer = document.createElement('div')
            var productDiv = document.createElement('div')
            var productCheckboxDiv = document.createElement('div')
            var productCheckbox = document.createElement('span')
            productCheckboxDiv.style.padding = "0px"
            productCheckboxDiv.style.margin = "0px"
            productCheckbox.style.fontSize = "40px"
            productCheckbox.style.lineHeight = "10px"
            productCheckbox.innerHTML = "□"
            productCheckboxDiv.appendChild(productCheckbox)
            var backOrderCheckboxDiv = document.createElement('div')
            var backOrderCheckbox = document.createElement('span')
            backOrderCheckboxDiv.style.padding = "0px"
            backOrderCheckboxDiv.style.margin = "0px"
            backOrderCheckbox.style.fontSize = "40px"
            backOrderCheckbox.style.lineHeight = "10px"
            backOrderCheckbox.innerHTML = "□"
            var backOrderCheckboxText = document.createElement('span')
            backOrderCheckboxText.style.fontSize = "12px"
            backOrderCheckboxText.innerHTML = "Jälkitoimitus. Määrä _________"
            backOrderCheckboxText.style.lineHeight = "10px"
            backOrderCheckboxDiv.appendChild(backOrderCheckbox)
            backOrderCheckboxDiv.appendChild(backOrderCheckboxText)


            var latestToCustomer = orderedProduct.latestToCustomer
            if(productVariations[orderedProduct.productVariationId]){
              var pv = productVariations[orderedProduct.productVariationId]
              var p = products[pv.productId]
              var colorName = ""
              var colorCode = ""
              pv.colorCode && this.settings.colors[pv.colorCode] ? colorName = this.settings.colors[pv.colorCode].fi : ''
              pv.colorCode && this.settings.colors[pv.colorCode] ? colorCode = this.settings.colors[pv.colorCode].id : ''
              
              var avecorSku = p.avecorSku ? p.avecorSku : ''
              avecorSku += colorCode ? '-'+colorCode : ''
              avecorSku ? productText += "Tuotekoodi: "+ avecorSku + "<br />" : productText += "Tuotekoodi: tuotekoodia ei ole lisätty järjestelmään vielä <br />"
              settings.packageTypes[pv.packageType] !== undefined ? productText += "Pakettityyppi: "+settings.packageTypes[pv.packageType].fi + "<br />" : productText += "Pakettityyppi: pakettityyppia ei määritelty <br />"
              this.products[pv.productId].name.fi !== undefined ? productText += "Tuotenimi: "+this.products[pv.productId].name.fi + "<br />" : productText += "Tuotenimi: tuotenimeä ei määritelty <br />"
              pv.material !== undefined ? productText += "Materiaali:"+pv.material +"<br/>" :  "Materiaali: Ei määritelty<br />"
              colorName ? productText += "Väri: "+colorName + "<br />" : productText += "Väri: väriä ei määritelty<br />" 
              pv.size !== undefined ? productText += "Koko: "+pv.size + "<br />" : productText += "Koko: kokoa ei määritelty<br />" 
              pv.other !== undefined ? productText += "Muut tuotetiedot: "+pv.other + "<br />": productText += "Muut tuotetiedot: tietoja ei määritelty<br />" 
            }
            
            
            productText += "Määrä: "+orderedProduct.quantity + "<br />"
            orderedProduct.numberOfSamples ? productText += "Mallikappaleet: "+orderedProduct.numberOfSamples +"<br />" : productText += "Mallikappaleet: "+0 +"<br />"
            productText += "Painatus: "
            productText += orderedProduct.print ? "Kyllä<br />" : "Ei<br />"
            orderedProduct.print ? productText += "Painatusten määrä: " + orderedProduct.printQuantity +"<br />" : ""
            if(latestToCustomer) productText += "<span style=\"font-size:16px\">Viim. asiakkaalla: " + orderedProduct.latestToCustomer +"<br /></span>"
            productText += "<br />"
            //productContainer.appendChild(productCheckboxDiv)
            //productContainer.appendChild(backOrderCheckboxDiv)
            if(latestToCustomer){
              latestToCustomerProducts.push({avecorSku,name:this.products[pv.productId].name.fi,latestToCustomer})
              productContainer.prepend(productDiv)
              productDiv.innerHTML = productText
              productsDiv.prepend(productContainer)
              
              productContainer.prepend(backOrderCheckboxText)
              productContainer.prepend(backOrderCheckbox)
              productContainer.prepend(productCheckbox)
            }
            else{
              productContainer.appendChild(productCheckbox)
              productContainer.appendChild(backOrderCheckbox)
              productContainer.appendChild(backOrderCheckboxText)
              productContainer.appendChild(productDiv)
              productDiv.innerHTML = productText
              productsDiv.appendChild(productContainer)
            }
            //productText = "Tuotekoodi:"+productVariations[orderedProduct.productVariationId].productId + "<br />"
          }
        })
        //productsDiv.innerHTML = productText
        mainDiv.appendChild(h1)
        if(order.netvisorId){
          var netvisorIdDiv = document.createElement('div')
          netvisorIdDiv.style.position = "absolute"
          netvisorIdDiv.style.top = "300px"
          netvisorIdDiv.style.right = "30px"
          netvisorIdDiv.style.padding = "0px"
          netvisorIdDiv.style.margin = "0px"
          netvisorIdDiv.style.fontSize = "75px"
          netvisorIdDiv.style.fontWeight = "800"
          netvisorIdDiv.style.lineHeight = "10px"
          netvisorIdDiv.innerHTML = order.netvisorId
          mainDiv.appendChild(netvisorIdDiv)
        }
        if(order.deliveryWeek){
          var splits = order.deliveryWeek.split('/')
          var splits2 = splits[1].split(" ")
          
          var startDate = this.getDateForStartOfWeek(splits[0],splits2[0])
          var startDateText = startDate.getDate() + "." + eval(startDate.getMonth()+1)
          var endDate = new Date(startDate.getTime());
          endDate.setDate(startDate.getDate()+4)
          var endDateText = endDate.getDate() + "." + eval(endDate.getMonth()+1)
          console.log(startDateText, endDateText)
          var deliveryWeekDiv = document.createElement('div')
          deliveryWeekDiv.style.position = "absolute"
          deliveryWeekDiv.style.top = "350px"
          deliveryWeekDiv.style.right = "30px"
          deliveryWeekDiv.style.padding = "0px"
          deliveryWeekDiv.style.margin = "0px"
          deliveryWeekDiv.style.fontSize = "50px"
          deliveryWeekDiv.style.lineHeight = "10px"
          deliveryWeekDiv.innerHTML = 'VK ' +splits[0]+'/'+splits2[0]
          mainDiv.appendChild(deliveryWeekDiv)
          var deliveryWeekDates = document.createElement('div')
          deliveryWeekDates.style.position = "absolute"
          deliveryWeekDates.style.top = "400px"
          deliveryWeekDates.style.right = "30px"
          deliveryWeekDates.style.padding = "0px"
          deliveryWeekDates.style.margin = "0px"
          deliveryWeekDates.style.fontSize = "50px"
          deliveryWeekDates.style.lineHeight = "10px"
          deliveryWeekDates.innerHTML = splits2[1] ? splits2[1] : startDateText + '-' + endDateText
          mainDiv.appendChild(deliveryWeekDates)
        }
        if(latestToCustomerProducts.length > 0){
          
          var latestToCusomerDiv = document.createElement('div')
          latestToCusomerDiv.style.position = "absolute"
          latestToCusomerDiv.style.top = "450px"
          latestToCusomerDiv.style.right = "30px"
          latestToCusomerDiv.style.padding = "0px"
          latestToCusomerDiv.style.margin = "0px"
          latestToCusomerDiv.style.fontSize = "14px"
          latestToCusomerDiv.style.lineHeight = "18px"
          latestToCusomerDiv.innerHTML += 'Viim. asiakkaalla tuotteet <br/>'
          latestToCustomerProducts.forEach(p =>{
            latestToCusomerDiv.innerHTML += p.name + ' ('+p.avecorSku+'): <span style="font-weight:800">'+p.latestToCustomer+'</span><br/>'
          })
          
          mainDiv.appendChild(latestToCusomerDiv)
        }


        mainDiv.appendChild(orderDiv)
        mainDiv.appendChild(productsDiv)
        d.print( mainDiv, [ cssText ] )
      },
      printOrderLetter(order){
        const cssText = `
          @page { size: auto;  margin: 0mm 40px; }
          h1 {
            color: black;
            font-family: sans-serif;
          }
          .order-letter-logo {
            opacity:0.6;
            margin-top:40px;
          }
          .order-letter-address-block {
            font-size:12px;
            color: #CCC;
            font-family: arial;
            line-height:20px;
          }
          .order-letter-footer-texts {
            font-size:13px;
            color: #CCC;
            font-family: arial;
            line-height:15px;
          }
          hr {
          }
          .customer-details {
            margin-top:10px;
            margin-left:10px;
            margin-bottom:10px;
          }
          .product-details {
            font-size:11px;
          }
          
        `
        const d = new Printd()
        var mainDiv = document.createElement('div')
        var logo = document.createElement('div')
        var logoImg = document.createElement('img')
        // OLD IMAGE logoImg.src = 'https://firebasestorage.googleapis.com/v0/b/avecor-709ff.appspot.com/o/images%2Flogo_400x120.png?alt=media&token=f146b37c-be32-4caa-99c1-7361a80b72c0'
        logoImg.src = 'https://storage.googleapis.com/cdn.avecor.fi/avecor-logo-no-slogan-200x57.png'
        //logoImg.src = 'https://firebasestorage.googleapis.com/v0/b/avecor-public/o/avecor%2Flogo_uusi_300x99.png?alt=media&token=cc515932-72b6-436a-98db-927daf81ed86'
        logoImg.width = 300
        logoImg.height = 90
        logoImg.classList.add("order-letter-logo")
        
        var headerRow1 = document.createElement('div')
        headerRow1.style.marginTop = "30px"
        var avecorAddressText1 = document.createElement('span')
        avecorAddressText1.classList.add("order-letter-address-block")
        avecorAddressText1.innerHTML = "Teerisuonkuja 4"
        avecorAddressText1.style.width = "300px"
        avecorAddressText1.style.display = "inline-block"

        var orderLetterText = document.createElement('span')
        orderLetterText.innerHTML = "Lähete"
        orderLetterText.style.color = "#CCC"
        orderLetterText.style.width = "100px"
        orderLetterText.style.display = "inline-block"
        orderLetterText.style.fontSize = "20px"
        orderLetterText.style.fontWeight = "bold"

        //headerRow1.appendChild(avecorAddressText1)
        headerRow1.appendChild(orderLetterText)

        var headerRow2 = document.createElement('div')
        var avecorAddressText2 = document.createElement('span')
        avecorAddressText2.classList.add("order-letter-address-block")
        avecorAddressText2.innerHTML = "00700 Helsinki"
        avecorAddressText2.style.width = "300px"
        avecorAddressText2.style.display = "inline-block"

        var dateHeader = document.createElement('span')
        dateHeader.classList.add("order-letter-address-block")
        dateHeader.innerHTML = "Päiväys"
        dateHeader.style.width = "150px"
        dateHeader.style.display = "inline-block"
        
        var orderLetterText2 = document.createElement('span')
        orderLetterText2.classList.add("order-letter-address-block")
        orderLetterText2.innerHTML = "Lähete"
        orderLetterText2.style.width = "100px"
        orderLetterText2.style.display = "inline-block"
        
        var orderText = document.createElement('span')
        orderText.classList.add("order-letter-address-block")
        orderText.innerHTML = "Tilaus"
        orderText.style.width = "100px"
        orderText.style.display = "inline-block"

        //headerRow2.appendChild(avecorAddressText2)
        headerRow2.appendChild(dateHeader)
        //headerRow2.appendChild(orderLetterText2)
        //headerRow2.appendChild(orderText)
        var headerRow3 = document.createElement('div')
        var avecorAddressText3 = document.createElement('span')
        avecorAddressText3.classList.add("order-letter-address-block")
        avecorAddressText3.innerHTML = "Suomi"
        avecorAddressText3.style.width = "300px"
        avecorAddressText3.style.display = "inline-block"

        var dateText = document.createElement('span')
        dateText.classList.add("order-letter-address-block")
        dateText.innerHTML = new Date().toISOString().substr(0, 10)
        dateText.style.width = "100px"
        dateText.style.display = "inline-block"
                
        //headerRow3.appendChild(avecorAddressText3)
        headerRow3.appendChild(dateText)
        
        var hr = document.createElement('hr')
        hr.border = "none"
        hr.height = "1px"
        hr.color = "#999"
        var hr2 = document.createElement('hr')
        hr2.border = "none"
        hr2.height = "1px"
        hr2.color = "#999"
        var hr3 = document.createElement('hr')
        hr3.border = "none"
        hr3.height = "1px"
        hr3.color = "#999"
        var hr4 = document.createElement('hr')
        hr4.border = "none"
        hr4.height = "1px"
        hr4.color = "#999"
        var hr5 = document.createElement('hr')
        hr5.border = "none"
        hr5.height = "1px"
        hr5.color = "#999"
        var hr6 = document.createElement('hr')
        hr6.border = "none"
        hr6.height = "1px"
        hr6.color = "#999"
        var hr7 = document.createElement('hr')
        hr7.border = "none"
        hr7.height = "1px"
        hr7.color = "#999"
        var hr8 = document.createElement('hr')
        hr8.border = "none"
        hr8.height = "1px"
        hr8.color = "#999"
        var hr9 = document.createElement('hr')
        hr9.border = "none"
        hr9.height = "1px"
        hr9.color = "#999"
        var hr10 = document.createElement('hr')
        hr10.border = "none"
        hr10.height = "1px"
        hr10.color = "#999"
        var hr11 = document.createElement('hr')
        hr11.border = "none"
        hr11.height = "1px"
        hr11.color = "#999"
        var hr12 = document.createElement('hr')
        hr12.border = "none"
        hr12.height = "1px"
        hr12.color = "#999"

        var customerDetailsBlock = document.createElement('div')
        customerDetailsBlock.classList.add("customer-details")
        var customerInfoHeadline = document.createElement('div')
        customerInfoHeadline.innerHTML = "Toimitusasiakas"
        customerInfoHeadline.style.paddingBottom = "15px"
        var companyName = document.createElement('div')
        companyName.innerHTML = this.companies[order.companyId].companyName.toUpperCase()
        var companyAddress = document.createElement('div')
        companyAddress.innerHTML = this.companies[order.companyId].deliveryAddress.toUpperCase()
        var companyPostalCodeAndCity = document.createElement('div')
        companyPostalCodeAndCity.innerHTML = this.companies[order.companyId].deliveryPostalCode.toUpperCase() + ", " + this.companies[order.companyId].deliveryCity.toUpperCase()
        companyPostalCodeAndCity.style.paddingBottom = "15px"
        var customerNameAndPhone = document.createElement('div')
        customerNameAndPhone.innerHTML = this.contacts[order.contactId].firstName.toUpperCase() 
          + " " + this.contacts[order.contactId].lastName.toUpperCase()
          + ", " + this.contacts[order.contactId].phone

        customerDetailsBlock.appendChild(customerInfoHeadline)
        customerDetailsBlock.appendChild(companyName)
        customerDetailsBlock.appendChild(companyAddress)
        customerDetailsBlock.appendChild(companyPostalCodeAndCity)
        customerDetailsBlock.appendChild(customerNameAndPhone)
        
        var orderDetailsRow1Headers = document.createElement('div')
        var orderNumberHeader = document.createElement('span')
        orderNumberHeader.innerHTML = "Tilausnumero"
        orderNumberHeader.style.width = "500px"
        orderNumberHeader.style.display = "inline-block"
        var deliveryMethodHeader = document.createElement('span')
        deliveryMethodHeader.innerHTML = "Toimitustapa"
        deliveryMethodHeader.style.width = "180px"
        deliveryMethodHeader.style.display = "inline-block"
        var avecorReferenceHeader = document.createElement('span')
        avecorReferenceHeader.innerHTML = "Viitteemme"
        avecorReferenceHeader.style.width = "180px"
        avecorReferenceHeader.style.display = "inline-block"
        var customerReferenceHeader = document.createElement('span')
        customerReferenceHeader.innerHTML = "Viitteenne"
        customerReferenceHeader.style.width = "180px"
        customerReferenceHeader.style.display = "inline-block"
        orderDetailsRow1Headers.appendChild(orderNumberHeader)
        orderDetailsRow1Headers.appendChild(deliveryMethodHeader)
        //orderDetailsRow1Headers.appendChild(avecorReferenceHeader)
        //orderDetailsRow1Headers.appendChild(customerReferenceHeader)
        
        var orderDetailsRow1Values = document.createElement('div')
        var orderNumberValue = document.createElement('span')
        order.netvisorId !== undefined ? orderNumberValue.innerHTML = order.netvisorId : orderNumberValue.innerHTML = ""
        orderNumberValue.style.width = "500px"
        orderNumberValue.style.display = "inline-block"
        var deliveryMethodValue = document.createElement('span')
        deliveryMethodValue.innerHTML = "Posti/Transpoint"
        deliveryMethodValue.style.width = "180px"
        deliveryMethodValue.style.display = "inline-block"
        var avecorReferenceValue = document.createElement('span')
        avecorReferenceValue.innerHTML = this.contacts[order.contactId].firstName.toUpperCase() + " " + this.contacts[order.contactId].lastName.toUpperCase()
        avecorReferenceValue.style.width = "180px"
        avecorReferenceValue.style.display = "inline-block"
        var customerReferenceValue = document.createElement('span')
        customerReferenceValue.innerHTML = order.billingReferenceDetails
        customerReferenceValue.style.width = "180px"
        customerReferenceValue.style.display = "inline-block"

        orderDetailsRow1Values.appendChild(orderNumberValue)
        orderDetailsRow1Values.appendChild(deliveryMethodValue)
        //orderDetailsRow1Values.appendChild(avecorReferenceValue)
        //orderDetailsRow1Values.appendChild(customerReferenceValue)
        var orderDetailsRow3Headers = document.createElement('div')
        var paymentTermsHeader = document.createElement('span')
        paymentTermsHeader.innerHTML = "Maksuehto"
        paymentTermsHeader.style.width = "200px"
        paymentTermsHeader.style.display = "inline-block"
        var noticeTimeHeader = document.createElement('span')
        noticeTimeHeader.innerHTML = "Huom. aika"
        noticeTimeHeader.style.width = "200px"
        noticeTimeHeader.style.display = "inline-block"
        var orderWeightHeader = document.createElement('span')
        orderWeightHeader.innerHTML = "Tavarapaino Kg"
        orderWeightHeader.style.width = "200px"
        orderWeightHeader.style.display = "inline-block"
        orderDetailsRow3Headers.appendChild(paymentTermsHeader)
        orderDetailsRow3Headers.appendChild(noticeTimeHeader)
        orderDetailsRow3Headers.appendChild(orderWeightHeader)

        var orderDetailsRow3Values = document.createElement('div')
        var paymentTermsValue = document.createElement('span')
        paymentTermsValue.innerHTML = "14 pv netto"
        paymentTermsValue.style.width = "200px"
        paymentTermsValue.style.display = "inline-block"
        var noticeTimeValue = document.createElement('span')
        noticeTimeValue.innerHTML = ""
        noticeTimeValue.style.width = "200px"
        noticeTimeValue.style.display = "inline-block"
        var orderWeightValue = document.createElement('span')
        orderWeightValue.innerHTML = ""
        orderWeightValue.style.width = "200px"
        orderWeightValue.style.display = "inline-block"
        orderDetailsRow3Values.appendChild(paymentTermsValue)
        orderDetailsRow3Values.appendChild(noticeTimeValue)
        orderDetailsRow3Values.appendChild(orderWeightValue)

        // PRODUCTS
        var productDivTitle = document.createElement('div')
          productDivTitle.style.marginTop = "20px"
          productDivTitle.style.fontSize = "16px"
          productDivTitle.innerHTML = "TUOTTEET TÄSSÄ TOIMITUKSESSA"
          productDivTitle.style.fontWeight = "bold"
        var productDivHeader = document.createElement('div')
        productDivHeader.style.marginLeft = "10px"
        productDivHeader.style.marginTop = "10px"
        productDivHeader.style.fontSize = "14px"
        var productNameHeader = document.createElement('span')
        productNameHeader.innerHTML = "Nimike"
        productNameHeader.style.width = "375px"
        productNameHeader.style.display = "inline-block"
        productNameHeader.style.fontWeight = "bold"
        var productQuantityHeader = document.createElement('span')
        productQuantityHeader.innerHTML = "Määrä"
        productQuantityHeader.style.width = "75px"
        productQuantityHeader.style.display = "inline-block"
        productQuantityHeader.style.fontWeight = "bold"
        var unitTypeHeader = document.createElement('span')
        unitTypeHeader.innerHTML = "Yks."
        unitTypeHeader.style.width = "100px"
        unitTypeHeader.style.display = "inline-block"
        unitTypeHeader.style.fontWeight = "bold"
        var colorHeader = document.createElement('span')
        colorHeader.innerHTML = "Väri"
        colorHeader.style.width = "100px"
        colorHeader.style.display = "inline-block"
        colorHeader.style.fontWeight = "bold"
        var sizeHeader = document.createElement('span')
        sizeHeader.innerHTML = "Koko"
        sizeHeader.style.width = "75px"
        sizeHeader.style.display = "inline-block"
        sizeHeader.style.fontWeight = "bold"
        
        productDivHeader.appendChild(productNameHeader)
        productDivHeader.appendChild(productQuantityHeader)
        //productDivHeader.appendChild(unitTypeHeader)
        productDivHeader.appendChild(colorHeader)
        productDivHeader.appendChild(sizeHeader)

        //var productCatalog = this.productCatalog
        var productVariations = this.productVariations
        var orderedProducts = {}
        if (order.viaSearch) orderedProducts = this.searchOrderedProducts
        else orderedProducts = this.orderedProducts
        var settings = this.settings
        var productsDiv = document.createElement('div')
        productsDiv.style.marginBottom = "0px"

        var allDeliveries = []
        var toBeDelivered = []



        Object.keys(orderedProducts).forEach((key) => {
          var op = orderedProducts[key]
          if(op.orderStatus === 'cancelled') return
          if(op.orderId === order.id){
            // FULL DELIVERIES
            if((!op.partialDeliveries || Object.keys(op.partialDeliveries).length == 0) && op.orderStatus === 'productsShipped' && op.shippedDate){
              var shippedDate = this.customFormatter(op.shippedDate)
              allDeliveries.push({shippedDate, opId:op.id,quantity:op.quantity})
            }
            // PARTIAL DELIVERIES
            else if(op.partialDeliveries && Object.keys(op.partialDeliveries).length > 0){
              Object.keys(op.partialDeliveries).forEach(pdId => {
                var pd = op.partialDeliveries[pdId]
                var shippedDate = this.customFormatter(pd.date)
                allDeliveries.push({shippedDate, opId:op.id, quantity:pd.deliveredAmount,pdId})
                //console.log({shippedDate:pd.date, opId:op.id, quantity:pd.deliveredAmount,pdId})
              })
            }
            // OLD PARTIAL DELIVERES
            /* else if(op.backOrderAmount){
              allDeliveries.push({shippedDate:"2020-01-01", opId:op.id, quantity:op.quantity - op.backOrderAmount})
            } */
            
            // NOT YET DELIVERED FULL DELIVERIES
            if((!op.partialDeliveries || Object.keys(op.partialDeliveries).length == 0) && op.orderStatus !== 'productsShipped'){
              toBeDelivered.push({opId:op.id,quantity:op.quantity})
            }
            // PARTIALLY NOT YET DELIVERED
            /* OLD LOGIC
            else if(op.backOrderAmount){
              toBeDelivered.push({opId:op.id,quantity:op.backOrderAmount})
            } */
            else if(op.partialDeliveries && Object.keys(op.partialDeliveries).length > 0){
              var total = 0
              var pds = op.partialDeliveries
              Object.keys(pds).forEach(pdId => {
                var pd = pds[pdId]
                if(!isNaN(Number(pd.deliveredAmount))) total += Number(pd.deliveredAmount)
              })
              var diff = op.quantity - total
              if(diff > 0) toBeDelivered.push({opId:op.id,quantity:diff})
            }
          }
        })

        allDeliveries = allDeliveries.sort(function(a,b){
          return new Date(a.shippedDate) - new Date(b.shippedDate)
        });
        //console.log(allDeliveries)

        /* if(allDeliveries.length == 0) {
          alert("Tilauksessa ei vielä toimitettuja tuotteita.")
          return
        } */

        logo.appendChild(logoImg)
        mainDiv.appendChild(logo)
        
        mainDiv.appendChild(headerRow1)
        mainDiv.appendChild(headerRow2)
        mainDiv.appendChild(headerRow3)
        mainDiv.appendChild(hr)
        mainDiv.appendChild(customerDetailsBlock)
        mainDiv.appendChild(hr2)
        mainDiv.appendChild(orderDetailsRow1Headers)
        mainDiv.appendChild(orderDetailsRow1Values)
        mainDiv.appendChild(hr3)
        //mainDiv.appendChild(orderDetailsRow2Headers)
        //mainDiv.appendChild(orderDetailsRow2Values)
        //mainDiv.appendChild(hr4)
        //mainDiv.appendChild(orderDetailsRow3Headers)
        //mainDiv.appendChild(orderDetailsRow3Values)
        //mainDiv.appendChild(hr5)

        var thisDelivery = []
        var pastDeliveries = []
        /* console.log("HERE")
        var latestDeliveryDate = ''
        allDeliveries.forEach(d => {
          if(!latestDeliveryDate) latestDeliveryDate = d.shippedDate
          else if (new Date(d.shippedDate) > new Date(latestDeliveryDate)) latestDeliveryDate = d.shippedDate
        })
        console.log(latestDeliveryDate) */

        if(allDeliveries.length > 0 && allDeliveries[allDeliveries.length-1].shippedDate){
          var thisDeliveryDate = allDeliveries[allDeliveries.length-1].shippedDate
          console.log(allDeliveries)
          console.log(thisDeliveryDate)
          allDeliveries.forEach(d => {
            if (d.shippedDate === thisDeliveryDate){
              thisDelivery.push(d)
            }
            else {
              pastDeliveries.push(d)
            }
          })
        }

        else{
          thisDelivery = toBeDelivered
          toBeDelivered = []
        }
        
        

        thisDelivery.forEach((d) => {
          var op = orderedProducts[d.opId]
          var productDiv = document.createElement('div')
          productDiv.style.marginLeft = "10px"
          productDiv.classList.add("product-details")
          var productName = document.createElement('span')
          productVariations[op.productVariationId] !== undefined && this.products[productVariations[op.productVariationId].productId].name.fi !== undefined ? productName.innerHTML += this.products[productVariations[op.productVariationId].productId].name.fi.toUpperCase()  : productName.innerHTML += ""
          productName.style.width = "375px"
          productName.style.display = "inline-block"
          
          var productQuantity = document.createElement('span')  
          productQuantity.innerHTML = d.quantity
          productQuantity.style.width = "75px"
          productQuantity.style.display = "inline-block"
          
          var productUnitType = document.createElement('span')
          productVariations[op.productVariationId] !== undefined && settings.packageTypes[productVariations[op.productVariationId].packageType] !== undefined ? productUnitType.innerHTML  += settings.packageTypes[productVariations[op.productVariationId].packageType].fi : productUnitType.innerHTML  += ""
          productUnitType.style.width = "200px"
          productUnitType.style.display = "inline-block"
          
          var productColor = document.createElement('span')
          productColor.style.width = "100px"
          productColor.style.display = "inline-block"
          productColor.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].color !== undefined ? productVariations[op.productVariationId].color :  ""
          
          var productSize = document.createElement('span')
          productSize.style.width = "75px"
          productSize.style.display = "inline-block"
          productSize.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].size !== undefined ? productVariations[op.productVariationId].size :  ""

          productDiv.appendChild(productName)
          productDiv.appendChild(productQuantity)
          productDiv.appendChild(productColor)
          productDiv.appendChild(productSize)
          //productDiv.appendChild(productUnitType)
          productsDiv.appendChild(productDiv)
        })
        mainDiv.appendChild(productDivTitle)
        mainDiv.appendChild(productDivHeader)
        mainDiv.appendChild(hr6)
        mainDiv.appendChild(productsDiv)
        mainDiv.appendChild(hr7)


        // PAST DELIVERIES
        if(pastDeliveries.length > 0){
          var pastDeliveriesDiv = document.createElement('div')
          pastDeliveriesDiv.style.marginBottom = "0px"
          pastDeliveriesDiv.style.marginLeft = "10px"
          pastDeliveriesDiv.classList.add("product-details")
          var pastDeliveryProductDivTitle = document.createElement('div')
          pastDeliveryProductDivTitle.style.marginTop = "20px"
          pastDeliveryProductDivTitle.style.fontSize = "16px"
          pastDeliveryProductDivTitle.innerHTML = "AIKAISEMMIN TOIMITETUT TUOTTEET"
          pastDeliveryProductDivTitle.style.fontWeight = "bold"
          var pastDeliveryProductDivHeader = document.createElement('div')
          pastDeliveryProductDivHeader.style.marginLeft = "10px"
          pastDeliveryProductDivHeader.style.marginTop = "10px"
          pastDeliveryProductDivHeader.style.fontSize = "14px"
          var pastDeliveryProductNameHeader = document.createElement('span')
          pastDeliveryProductNameHeader.innerHTML = "Nimike"
          pastDeliveryProductNameHeader.style.width = "375px"
          pastDeliveryProductNameHeader.style.display = "inline-block"
          pastDeliveryProductNameHeader.style.fontWeight = "bold"
          var pastDeliveryProductQuantityHeader = document.createElement('span')
          pastDeliveryProductQuantityHeader.innerHTML = "Määrä"
          pastDeliveryProductQuantityHeader.style.width = "75px"
          pastDeliveryProductQuantityHeader.style.display = "inline-block"
          pastDeliveryProductQuantityHeader.style.fontWeight = "bold"
          var pastDeliveryColorHeader = document.createElement('span')
          pastDeliveryColorHeader.innerHTML = "Väri"
          pastDeliveryColorHeader.style.width = "100px"
          pastDeliveryColorHeader.style.display = "inline-block"
          pastDeliveryColorHeader.style.fontWeight = "bold"
          var pastDeliverySizeHeader = document.createElement('span')
          pastDeliverySizeHeader.innerHTML = "Koko"
          pastDeliverySizeHeader.style.width = "75px"
          pastDeliverySizeHeader.style.display = "inline-block"
          pastDeliverySizeHeader.style.fontWeight = "bold"
          var pastDeliveryDateHeader = document.createElement('span')
          pastDeliveryDateHeader.innerHTML = "Pvm"
          pastDeliveryDateHeader.style.width = "60px"
          pastDeliveryDateHeader.style.display = "inline-block"
          pastDeliveryDateHeader.style.fontWeight = "bold"

          pastDeliveryProductDivHeader.appendChild(pastDeliveryProductNameHeader)
          pastDeliveryProductDivHeader.appendChild(pastDeliveryProductQuantityHeader)
          pastDeliveryProductDivHeader.appendChild(pastDeliveryColorHeader)
          pastDeliveryProductDivHeader.appendChild(pastDeliverySizeHeader)
          pastDeliveryProductDivHeader.appendChild(pastDeliveryDateHeader)


          pastDeliveries.forEach(d => {
            var op = orderedProducts[d.opId]
            var productDiv = document.createElement('div')
            productDiv.style.marginLeft = "10px"
            var productName = document.createElement('span')
            productVariations[op.productVariationId] !== undefined && this.products[productVariations[op.productVariationId].productId].name.fi !== undefined ? productName.innerHTML += this.products[productVariations[op.productVariationId].productId].name.fi.toUpperCase()  : productName.innerHTML += ""
            productName.style.width = "375px"
            productName.style.display = "inline-block"
            
            var productQuantity = document.createElement('span')  
            productQuantity.innerHTML = d.quantity
            productQuantity.style.width = "75px"
            productQuantity.style.display = "inline-block"
            
            var productUnitType = document.createElement('span')
            productVariations[op.productVariationId] !== undefined && settings.packageTypes[productVariations[op.productVariationId].packageType] !== undefined ? productUnitType.innerHTML  += settings.packageTypes[productVariations[op.productVariationId].packageType].fi : productUnitType.innerHTML  += ""
            productUnitType.style.width = "200px"
            productUnitType.style.display = "inline-block"
            
            var productColor = document.createElement('span')
            productColor.style.width = "100px"
            productColor.style.display = "inline-block"
            productColor.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].color !== undefined ? productVariations[op.productVariationId].color :  ""
            
            var productSize = document.createElement('span')
            productSize.style.width = "75px"
            productSize.style.display = "inline-block"
            productSize.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].size !== undefined ? productVariations[op.productVariationId].size :  ""

            var productDeliveryDate = document.createElement('span')
            productDeliveryDate.style.width = "60px"
            productDeliveryDate.style.display = "inline-block"
            productDeliveryDate.innerHTML += d.shippedDate
            

            pastDeliveriesDiv.appendChild(productName)
            pastDeliveriesDiv.appendChild(productQuantity)
            pastDeliveriesDiv.appendChild(productColor)
            pastDeliveriesDiv.appendChild(productSize)
            pastDeliveriesDiv.appendChild(productDeliveryDate)
            
            //productDiv.appendChild(productUnitType)

            pastDeliveriesDiv.appendChild(productDiv)
          })

          mainDiv.appendChild(pastDeliveryProductDivTitle)
          mainDiv.appendChild(pastDeliveryProductDivHeader)
          mainDiv.appendChild(hr8)
          mainDiv.appendChild(pastDeliveriesDiv)
          mainDiv.appendChild(hr9)
        }
                // TO BE DELIVERED
        if(toBeDelivered.length > 0){
          var toBeDeliveredDiv = document.createElement('div')
          toBeDeliveredDiv.style.marginBottom = "0px"
          toBeDeliveredDiv.style.marginLeft = "10px"
          toBeDeliveredDiv.classList.add("product-details")
          var toBeDeliveredProductDivTitle = document.createElement('div')
          toBeDeliveredProductDivTitle.style.marginTop = "20px"
          toBeDeliveredProductDivTitle.style.fontSize = "16px"
          toBeDeliveredProductDivTitle.innerHTML = "MYÖHEMMIN TOIMITETAAN"
          toBeDeliveredProductDivTitle.style.fontWeight = "bold"
          var toBeDeliveredProductDivHeader = document.createElement('div')
          toBeDeliveredProductDivHeader.style.marginLeft = "10px"
          toBeDeliveredProductDivHeader.style.marginTop = "10px"
          toBeDeliveredProductDivHeader.style.fontSize = "14px"
          var toBeDeliveredProductNameHeader = document.createElement('span')
          toBeDeliveredProductNameHeader.innerHTML = "Nimike"
          toBeDeliveredProductNameHeader.style.width = "375px"
          toBeDeliveredProductNameHeader.style.display = "inline-block"
          toBeDeliveredProductNameHeader.style.fontWeight = "bold"
          var toBeDeliveredProductQuantityHeader = document.createElement('span')
          toBeDeliveredProductQuantityHeader.innerHTML = "Määrä"
          toBeDeliveredProductQuantityHeader.style.width = "75px"
          toBeDeliveredProductQuantityHeader.style.display = "inline-block"
          toBeDeliveredProductQuantityHeader.style.fontWeight = "bold"
          var toBeDeliveredColorHeader = document.createElement('span')
          toBeDeliveredColorHeader.innerHTML = "Väri"
          toBeDeliveredColorHeader.style.width = "100px"
          toBeDeliveredColorHeader.style.display = "inline-block"
          toBeDeliveredColorHeader.style.fontWeight = "bold"
          var toBeDeliveredSizeHeader = document.createElement('span')
          toBeDeliveredSizeHeader.innerHTML = "Koko"
          toBeDeliveredSizeHeader.style.width = "75px"
          toBeDeliveredSizeHeader.style.display = "inline-block"
          toBeDeliveredSizeHeader.style.fontWeight = "bold"

          toBeDeliveredProductDivHeader.appendChild(toBeDeliveredProductNameHeader)
          toBeDeliveredProductDivHeader.appendChild(toBeDeliveredProductQuantityHeader)
          toBeDeliveredProductDivHeader.appendChild(toBeDeliveredColorHeader)
          toBeDeliveredProductDivHeader.appendChild(toBeDeliveredSizeHeader)


          toBeDelivered.forEach(d => {
            var op = orderedProducts[d.opId]
            var productDiv = document.createElement('div')
            productDiv.style.marginLeft = "10px"
            var productName = document.createElement('span')
            productVariations[op.productVariationId] !== undefined && this.products[productVariations[op.productVariationId].productId].name.fi !== undefined ? productName.innerHTML += this.products[productVariations[op.productVariationId].productId].name.fi.toUpperCase()  : productName.innerHTML += ""
            productName.style.width = "375px"
            productName.style.display = "inline-block"
            
            var productQuantity = document.createElement('span')  
            productQuantity.innerHTML = d.quantity
            productQuantity.style.width = "75px"
            productQuantity.style.display = "inline-block"
            
            var productUnitType = document.createElement('span')
            productVariations[op.productVariationId] !== undefined && settings.packageTypes[productVariations[op.productVariationId].packageType] !== undefined ? productUnitType.innerHTML  += settings.packageTypes[productVariations[op.productVariationId].packageType].fi : productUnitType.innerHTML  += ""
            productUnitType.style.width = "200px"
            productUnitType.style.display = "inline-block"
            
            var productColor = document.createElement('span')
            productColor.style.width = "100px"
            productColor.style.display = "inline-block"
            productColor.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].color !== undefined ? productVariations[op.productVariationId].color :  ""
            
            var productSize = document.createElement('span')
            productSize.style.width = "75px"
            productSize.style.display = "inline-block"
            productSize.innerHTML += productVariations[op.productVariationId] !== undefined && productVariations[op.productVariationId].size !== undefined ? productVariations[op.productVariationId].size :  ""
            

            toBeDeliveredDiv.appendChild(productName)
            toBeDeliveredDiv.appendChild(productQuantity)
            toBeDeliveredDiv.appendChild(productColor)
            toBeDeliveredDiv.appendChild(productSize)
            
            //productDiv.appendChild(productUnitType)

            toBeDeliveredDiv.appendChild(productDiv)
          })

          mainDiv.appendChild(toBeDeliveredProductDivTitle)
          mainDiv.appendChild(toBeDeliveredProductDivHeader)
          mainDiv.appendChild(hr10)
          mainDiv.appendChild(toBeDeliveredDiv)
          mainDiv.appendChild(hr11)
        }

        var footerDiv = document.createElement('div')
        footerDiv.style.position = "absolute"
        footerDiv.style.bottom = "15px"
        footerDiv.style.width = "100%"

        var footerRow1 = document.createElement('div')
        footerRow1.style.marginTop = "10px"
        var footerRow1Column1 = document.createElement('span')
        footerRow1Column1.classList.add("order-letter-footer-texts")
        footerRow1Column1.innerHTML = "Avecor Oy"
        footerRow1Column1.style.width = "120px"
        footerRow1Column1.style.display = "inline-block"

        var footerRow1Column2 = document.createElement('span')
        footerRow1Column2.classList.add("order-letter-footer-texts")
        footerRow1Column2.innerHTML = "Puhelin"
        footerRow1Column2.style.width = "120px"
        footerRow1Column2.style.display = "inline-block"
        footerRow1Column2.style.fontWeight = "bold"

        var footerRow1Column3 = document.createElement('span')
        footerRow1Column3.classList.add("order-letter-footer-texts")
        footerRow1Column3.innerHTML = "Pankit"
        footerRow1Column3.style.width = "200px"
        footerRow1Column3.style.display = "inline-block"
        footerRow1Column3.style.fontWeight = "bold"

        var footerRow1Column4 = document.createElement('span')
        footerRow1Column4.classList.add("order-letter-footer-texts")
        footerRow1Column4.innerHTML = "Y-tunnus"
        footerRow1Column4.style.width = "100px"
        footerRow1Column4.style.display = "inline-block"
        footerRow1Column4.style.fontWeight = "bold"

        var footerRow1Column5 = document.createElement('span')
        footerRow1Column5.classList.add("order-letter-footer-texts")
        footerRow1Column5.innerHTML = "2714868-9"
        footerRow1Column5.style.width = "100px"
        footerRow1Column5.style.display = "inline-block"

        var footerRow2 = document.createElement('div')
        var footerRow2Column1 = document.createElement('span')
        footerRow2Column1.classList.add("order-letter-footer-texts")
        footerRow2Column1.innerHTML = "Teerisuonkuja 4"
        footerRow2Column1.style.width = "120px"
        footerRow2Column1.style.display = "inline-block"

        var footerRow2Column2 = document.createElement('span')
        footerRow2Column2.classList.add("order-letter-footer-texts")
        footerRow2Column2.innerHTML = "+358 10 419 0160"
        footerRow2Column2.style.width = "120px"
        footerRow2Column2.style.display = "inline-block"
        
        var footerRow2Column3 = document.createElement('span')
        footerRow2Column3.classList.add("order-letter-footer-texts")
        footerRow2Column3.innerHTML = "Osuuspankki 578038-20117769"
        footerRow2Column3.style.width = "200px"
        footerRow2Column3.style.display = "inline-block"
        
        var footerRow2Column4 = document.createElement('span')
        footerRow2Column4.classList.add("order-letter-footer-texts")
        footerRow2Column4.innerHTML = "Kotipaikka"
        footerRow2Column4.style.width = "100px"
        footerRow2Column4.style.display = "inline-block"
        footerRow2Column4.style.fontWeight = "bold"

        var footerRow2Column5 = document.createElement('span')
        footerRow2Column5.classList.add("order-letter-footer-texts")
        footerRow2Column5.innerHTML = "Helsinki"
        footerRow2Column5.style.width = "100px"
        footerRow2Column5.style.display = "inline-block"

        var footerRow3 = document.createElement('div')
        var footerRow3Column1 = document.createElement('span')
        footerRow3Column1.classList.add("order-letter-footer-texts")
        footerRow3Column1.innerHTML = "00700 Helsinki"
        footerRow3Column1.style.width = "120px"
        footerRow3Column1.style.display = "inline-block"

        var footerRow3Column2 = document.createElement('span')
        footerRow3Column2.classList.add("order-letter-footer-texts")
        footerRow3Column2.innerHTML = ""
        footerRow3Column2.style.width = "120px"
        footerRow3Column2.style.display = "inline-block"
        
        var footerRow3Column3 = document.createElement('span')
        footerRow3Column3.classList.add("order-letter-footer-texts")
        footerRow3Column3.innerHTML = "FI48 5780 3820 1177 69"
        footerRow3Column3.style.width = "200px"
        footerRow3Column3.style.display = "inline-block"
        
        var footerRow3Column4 = document.createElement('span')
        footerRow3Column4.classList.add("order-letter-footer-texts")
        footerRow3Column4.innerHTML = "www.avecor.fi"
        footerRow3Column4.style.width = "100px"
        footerRow3Column4.style.display = "inline-block"
        
        var footerRow4 = document.createElement('div')
        var footerRow4Column1 = document.createElement('span')
        footerRow4Column1.classList.add("order-letter-footer-texts")
        footerRow4Column1.innerHTML = "Suomi"
        footerRow4Column1.style.width = "120px"
        footerRow4Column1.style.display = "inline-block"

        var footerRow4Column2 = document.createElement('span')
        footerRow4Column2.classList.add("order-letter-footer-texts")
        footerRow4Column2.innerHTML = ""
        footerRow4Column2.style.width = "120px"
        footerRow4Column2.style.display = "inline-block"
        
        var footerRow4Column3 = document.createElement('span')
        footerRow4Column3.classList.add("order-letter-footer-texts")
        footerRow4Column3.innerHTML = "OKOYFIHH"
        footerRow4Column3.style.width = "200px"
        footerRow4Column3.style.display = "inline-block"
        
        var footerRow4Column4 = document.createElement('span')
        footerRow4Column4.classList.add("order-letter-footer-texts")
        footerRow4Column4.innerHTML = "myynti@avecor.fi"
        footerRow4Column4.style.width = "150px"
        footerRow4Column4.style.display = "inline-block"
              

        footerRow1.appendChild(footerRow1Column1)
        footerRow1.appendChild(footerRow1Column2)
        footerRow1.appendChild(footerRow1Column3)
        footerRow1.appendChild(footerRow1Column4)
        footerRow1.appendChild(footerRow1Column5)
        footerRow2.appendChild(footerRow2Column1)
        footerRow2.appendChild(footerRow2Column2)
        footerRow2.appendChild(footerRow2Column3)
        footerRow2.appendChild(footerRow2Column4)
        footerRow2.appendChild(footerRow2Column5)
        footerRow3.appendChild(footerRow3Column1)
        footerRow3.appendChild(footerRow3Column2)
        footerRow3.appendChild(footerRow3Column3)
        footerRow3.appendChild(footerRow3Column4)
        footerRow4.appendChild(footerRow4Column1)
        footerRow4.appendChild(footerRow4Column2)
        footerRow4.appendChild(footerRow4Column3)
        footerRow4.appendChild(footerRow4Column4)
        
        footerDiv.appendChild(hr12)
        footerDiv.appendChild(footerRow1)
        footerDiv.appendChild(footerRow2)
        footerDiv.appendChild(footerRow3)
        footerDiv.appendChild(footerRow4)

        mainDiv.appendChild(footerDiv)

        d.print( mainDiv, [ cssText ] )
      },


      getDateForStartOfWeek(weekNo,year){
        var d = new Date(year, 0, 1);
        var firstWeek = this.getFirstOfTheYearWeekNumber(year)
        if(firstWeek != 1){
          d = new Date(d.setDate(d.getDate() + 7))
        }
        var daysSinceMonday = d.getDay()-1
        //console.log(daysSinceMonday)
        if(daysSinceMonday < 0) daysSinceMonday = 6
        d.setDate(d.getDate() - daysSinceMonday);
        d.setDate(d.getDate() + ( 7 * (weekNo-1)));
        var day = d.getDate() 
        var month = d.getMonth()+1
        var year = d.getFullYear()
        //var helsinkiDate = new tc.DateTime(year, month, day, 8, 0, 0, 0, tc.zone("Europe/Helsinki"));
        //var h = helsinkiDate.utcHour(); // 12
        //console.log(h)
        //d.setUTCHours(h,0,0,0)
        return d
      },
      getFirstOfTheYearWeekNumber(year) {
        var date = new Date(year, 0, 1);
        //var date = new Date(this.getTime());
        date.setHours(0, 0, 0, 0);
        // Thursday in current week decides the year.
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        // January 4 is always in week 1.
        var week1 = new Date(date.getFullYear(), 0, 4);
        // Adjust to Thursday in week 1 and count number of weeks from date to week1.
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
                              - 3 + (week1.getDay() + 6) % 7) / 7);
      }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/blocks/OrdersTable.vue